(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}



// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bv.ao === region.aZ.ao)
	{
		return 'on line ' + region.bv.ao;
	}
	return 'on lines ' + region.bv.ao + ' through ' + region.aZ.ao;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = elm$core$Set$toList(x);
		y = elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (!x.$)
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
	}));
});



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? elm$core$Maybe$Nothing
		: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800)
			+
			String.fromCharCode(code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

var _Json_decodeInt = { $: 2 };
var _Json_decodeBool = { $: 3 };
var _Json_decodeFloat = { $: 4 };
var _Json_decodeValue = { $: 5 };
var _Json_decodeString = { $: 6 };

function _Json_decodeList(decoder) { return { $: 7, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 8, b: decoder }; }

function _Json_decodeNull(value) { return { $: 9, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 10,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 11,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 12,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 13,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 14,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 15,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 3:
			return (typeof value === 'boolean')
				? elm$core$Result$Ok(value)
				: _Json_expecting('a BOOL', value);

		case 2:
			if (typeof value !== 'number') {
				return _Json_expecting('an INT', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return elm$core$Result$Ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return elm$core$Result$Ok(value);
			}

			return _Json_expecting('an INT', value);

		case 4:
			return (typeof value === 'number')
				? elm$core$Result$Ok(value)
				: _Json_expecting('a FLOAT', value);

		case 6:
			return (typeof value === 'string')
				? elm$core$Result$Ok(value)
				: (value instanceof String)
					? elm$core$Result$Ok(value + '')
					: _Json_expecting('a STRING', value);

		case 9:
			return (value === null)
				? elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 5:
			return elm$core$Result$Ok(_Json_wrap(value));

		case 7:
			if (!Array.isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 8:
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 10:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));

		case 11:
			var index = decoder.e;
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));

		case 12:
			if (typeof value !== 'object' || value === null || Array.isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!elm$core$Result$isOk(result))
					{
						return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));

		case 13:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return elm$core$Result$Ok(answer);

		case 14:
			var result = _Json_runHelp(decoder.b, value);
			return (!elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 15:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if (elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));

		case 1:
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!elm$core$Result$isOk(result))
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return elm$core$Result$Ok(toElmValue(array));
}

function _Json_toElmArray(array)
{
	return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 3:
		case 2:
		case 4:
		case 6:
		case 5:
			return true;

		case 9:
			return x.c === y.c;

		case 7:
		case 8:
		case 12:
			return _Json_equality(x.b, y.b);

		case 10:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 11:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 13:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 14:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 15:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return elm$core$Maybe$Nothing;
	}
}


// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dq,
		impl.eh,
		impl.dZ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2(elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F2(function(request, maybeProgress)
{
	return _Scheduler_binding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		_Http_configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_Scheduler_fail(elm$http$Http$NetworkError));
		});
		xhr.addEventListener('timeout', function() {
			callback(_Scheduler_fail(elm$http$Http$Timeout));
		});
		xhr.addEventListener('load', function() {
			callback(_Http_handleResponse(xhr, request.a_.a));
		});

		try
		{
			xhr.open(request.dx, request.ei, true);
		}
		catch (e)
		{
			return callback(_Scheduler_fail(elm$http$Http$BadUrl(request.ei)));
		}

		_Http_configureRequest(xhr, request);

		var body = request.cZ;
		xhr.send(elm$http$Http$Internal$isStringBody(body)
			? (xhr.setRequestHeader('Content-Type', body.a), body.b)
			: body.a
		);

		return function() { xhr.abort(); };
	});
});

function _Http_configureProgress(xhr, maybeProgress)
{
	if (!elm$core$Maybe$isJust(maybeProgress))
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_Scheduler_rawSpawn(maybeProgress.a({
			c$: event.loaded,
			c0: event.total
		}));
	});
}

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.aH; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}

	xhr.responseType = request.a_.b;
	xhr.withCredentials = request.bz;

	elm$core$Maybe$isJust(request.bx) && (xhr.timeout = request.bx.a);
}


// RESPONSES

function _Http_handleResponse(xhr, responseToResult)
{
	var response = _Http_toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(elm$http$Http$BadStatus(response));
	}

	var result = responseToResult(response);

	if (elm$core$Result$isOk(result))
	{
		return _Scheduler_succeed(result.a);
	}
	else
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(A2(elm$http$Http$BadPayload, result.a, response));
	}
}

function _Http_toResponse(xhr)
{
	return {
		ei: xhr.responseURL,
		cE: { c4: xhr.status, dv: xhr.statusText },
		aH: _Http_parseHeaders(xhr.getAllResponseHeaders()),
		cZ: xhr.response
	};
}

function _Http_parseHeaders(rawHeaders)
{
	var headers = elm$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(elm$core$Dict$update, key, function(oldValue) {
				return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function _Http_expectStringResponse(responseToResult)
{
	return {
		$: 0,
		b: 'text',
		a: responseToResult
	};
}

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		b: expect.b,
		a: function(response) {
			var convertedResponse = expect.a(response);
			return A2(elm$core$Result$map, func, convertedResponse);
		}
	};
});


// BODY

function _Http_multipart(parts)
{


	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}

	return elm$http$Http$Internal$FormDataBody(formData);
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2(elm$json$Json$Decode$map, func, handler.a)
				:
			A3(elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dv: func(record.dv),
		bw: record.bw,
		bk: record.bk
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dv;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.bw;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.bk) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dq,
		impl.eh,
		impl.dZ,
		function(sendToApp, initialModel) {
			var view = impl.ek;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dq,
		impl.eh,
		impl.dZ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.as && impl.as(sendToApp)
			var view = impl.ek;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.cZ);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.d1) && (_VirtualDom_doc.title = title = doc.d1);
			});
		}
	);
});



// ANIMATION


var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.dE;
	var onUrlRequest = impl.dF;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		as: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.download)
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.co === next.co
							&& curr.bX === next.bX
							&& curr.cj.a === next.cj.a
						)
							? elm$browser$Browser$Internal(next)
							: elm$browser$Browser$External(href)
					));
				}
			});
		},
		dq: function(flags)
		{
			return A3(impl.dq, flags, _Browser_getUrl(), key);
		},
		ek: impl.ek,
		eh: impl.eh,
		dZ: impl.dZ
	});
}

function _Browser_getUrl()
{
	return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { dm: 'hidden', aj: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { dm: 'mozHidden', aj: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { dm: 'msHidden', aj: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { dm: 'webkitHidden', aj: 'webkitvisibilitychange' }
		: { dm: 'hidden', aj: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		cz: _Browser_getScene(),
		cM: {
			aR: _Browser_window.pageXOffset,
			aS: _Browser_window.pageYOffset,
			cP: _Browser_doc.documentElement.clientWidth,
			bW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		cP: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			cz: {
				cP: node.scrollWidth,
				bW: node.scrollHeight
			},
			cM: {
				aR: node.scrollLeft,
				aS: node.scrollTop,
				cP: node.clientWidth,
				bW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			cz: _Browser_getScene(),
			cM: {
				aR: x,
				aS: y,
				cP: _Browser_doc.documentElement.clientWidth,
				bW: _Browser_doc.documentElement.clientHeight
			},
			dc: {
				aR: x + rect.left,
				aS: y + rect.top,
				cP: rect.width,
				bW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}
var author$project$Eth$Config$BasicConfig = F4(
	function (contracts, cTokensRaw, tokens, interestModels) {
		return {bH: cTokensRaw, bM: contracts, dr: interestModels, cI: tokens};
	});
var author$project$Eth$Config$InterestRateModelConfig = F2(
	function (contract, address) {
		return {o: address, c8: contract};
	});
var author$project$Eth$Ethereum$Contract = elm$core$Basics$identity;
var elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var elm$core$Basics$identity = function (x) {
	return x;
};
var elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var elm$core$Maybe$Nothing = {$: 1};
var elm$core$Basics$EQ = 1;
var elm$core$Basics$LT = 0;
var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var elm$core$Array$foldr = F3(
	function (func, baseCase, _n0) {
		var tree = _n0.c;
		var tail = _n0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			elm$core$Elm$JsArray$foldr,
			helper,
			A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var elm$core$List$cons = _List_cons;
var elm$core$Array$toList = function (array) {
	return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
};
var elm$core$Basics$GT = 2;
var elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var elm$core$Dict$toList = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var elm$core$Dict$keys = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm$core$Set$toList = function (_n0) {
	var dict = _n0;
	return elm$core$Dict$keys(dict);
};
var elm$core$String$toLower = _String_toLower;
var elm$core$Array$branchFactor = 32;
var elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var elm$core$Basics$ceiling = _Basics_ceiling;
var elm$core$Basics$fdiv = _Basics_fdiv;
var elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var elm$core$Basics$toFloat = _Basics_toFloat;
var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
	A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
var elm$core$Elm$JsArray$empty = _JsArray_empty;
var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
var elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var elm$core$List$reverse = function (list) {
	return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
};
var elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
			var node = _n0.a;
			var remainingNodes = _n0.b;
			var newAcc = A2(
				elm$core$List$cons,
				elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var elm$core$Basics$eq = _Utils_equal;
var elm$core$Tuple$first = function (_n0) {
	var x = _n0.a;
	return x;
};
var elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var elm$core$Basics$add = _Basics_add;
var elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var elm$core$Basics$floor = _Basics_floor;
var elm$core$Basics$gt = _Utils_gt;
var elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var elm$core$Basics$mul = _Basics_mul;
var elm$core$Basics$sub = _Basics_sub;
var elm$core$Elm$JsArray$length = _JsArray_length;
var elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.h) {
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.j),
				elm$core$Array$shiftStep,
				elm$core$Elm$JsArray$empty,
				builder.j);
		} else {
			var treeLen = builder.h * elm$core$Array$branchFactor;
			var depth = elm$core$Basics$floor(
				A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.k) : builder.k;
			var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.h);
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.j) + treeLen,
				A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
				tree,
				builder.j);
		}
	});
var elm$core$Basics$False = 1;
var elm$core$Basics$idiv = _Basics_idiv;
var elm$core$Basics$lt = _Utils_lt;
var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					elm$core$Array$builderToArray,
					false,
					{k: nodeList, h: (len / elm$core$Array$branchFactor) | 0, j: tail});
			} else {
				var leaf = elm$core$Array$Leaf(
					A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var elm$core$Basics$le = _Utils_le;
var elm$core$Basics$remainderBy = _Basics_remainderBy;
var elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return elm$core$Array$empty;
		} else {
			var tailLen = len % elm$core$Array$branchFactor;
			var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
			return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var elm$core$Basics$True = 0;
var elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var elm$core$Basics$and = _Basics_and;
var elm$core$Basics$append = _Utils_append;
var elm$core$Basics$or = _Basics_or;
var elm$core$Char$toCode = _Char_toCode;
var elm$core$Char$isLower = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var elm$core$Char$isUpper = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var elm$core$Char$isAlpha = function (_char) {
	return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
};
var elm$core$Char$isDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var elm$core$Char$isAlphaNum = function (_char) {
	return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
};
var elm$core$List$length = function (xs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var elm$core$List$map2 = _List_map2;
var elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2(elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var elm$core$List$range = F2(
	function (lo, hi) {
		return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$map2,
			f,
			A2(
				elm$core$List$range,
				0,
				elm$core$List$length(xs) - 1),
			xs);
	});
var elm$core$String$all = _String_all;
var elm$core$String$fromInt = _String_fromNumber;
var elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var elm$core$String$uncons = _String_uncons;
var elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var elm$json$Json$Decode$indent = function (str) {
	return A2(
		elm$core$String$join,
		'\n    ',
		A2(elm$core$String$split, '\n', str));
};
var elm$json$Json$Encode$encode = _Json_encode;
var elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
			elm$json$Json$Decode$errorToString(error))));
	});
var elm$json$Json$Decode$errorToString = function (error) {
	return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _n1 = elm$core$String$uncons(f);
						if (_n1.$ === 1) {
							return false;
						} else {
							var _n2 = _n1.a;
							var _char = _n2.a;
							var rest = _n2.b;
							return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + (elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
								elm$core$List$length(errors)) + ' ways:'));
							return A2(
								elm$core$String$join,
								'\n\n',
								A2(
									elm$core$List$cons,
									introduction,
									A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								elm$core$String$join,
								'',
								elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + (elm$json$Json$Decode$indent(
						A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var elm$json$Json$Decode$andThen = _Json_andThen;
var elm$json$Json$Decode$map = _Json_map1;
var elm$json$Json$Decode$string = _Json_decodeString;
var elm$json$Json$Decode$succeed = _Json_succeed;
var author$project$Eth$Decoders$decodeContractAddress = A2(
	elm$json$Json$Decode$andThen,
	A2(elm$core$Basics$composeL, elm$json$Json$Decode$succeed, elm$core$Basics$identity),
	A2(elm$json$Json$Decode$map, elm$core$String$toLower, elm$json$Json$Decode$string));
var elm$json$Json$Decode$field = _Json_decodeField;
var elm$json$Json$Decode$map2 = _Json_map2;
var author$project$Eth$Config$decodeInterestRateModel = A3(
	elm$json$Json$Decode$map2,
	author$project$Eth$Config$InterestRateModelConfig,
	A2(elm$json$Json$Decode$field, 'contract', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'address', author$project$Eth$Decoders$decodeContractAddress));
var author$project$Eth$Config$RawCTokenConfig = F5(
	function (name, symbol, decimals, address, underlying) {
		return {o: address, z: decimals, dA: name, d$: symbol, af: underlying};
	});
var elm$json$Json$Decode$int = _Json_decodeInt;
var elm$json$Json$Decode$map5 = _Json_map5;
var author$project$Eth$Config$decodeRawCToken = A6(
	elm$json$Json$Decode$map5,
	author$project$Eth$Config$RawCTokenConfig,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'symbol', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'decimals', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'address', author$project$Eth$Decoders$decodeContractAddress),
	A2(elm$json$Json$Decode$field, 'underlying', author$project$Eth$Decoders$decodeContractAddress));
var author$project$Eth$Config$TokenConfig = F6(
	function (name, symbol, decimals, address, supported, reader) {
		return {o: address, z: decimals, dA: name, cr: reader, cG: supported, d$: symbol};
	});
var elm$json$Json$Decode$bool = _Json_decodeBool;
var elm$json$Json$Decode$map6 = _Json_map6;
var elm$json$Json$Decode$oneOf = _Json_oneOf;
var elm$json$Json$Decode$maybe = function (decoder) {
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder),
				elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing)
			]));
};
var author$project$Eth$Config$decodeToken = A7(
	elm$json$Json$Decode$map6,
	author$project$Eth$Config$TokenConfig,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'symbol', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'decimals', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'address', author$project$Eth$Decoders$decodeContractAddress),
	elm$json$Json$Decode$maybe(
		A2(elm$json$Json$Decode$field, 'supported', elm$json$Json$Decode$bool)),
	elm$json$Json$Decode$maybe(
		A2(elm$json$Json$Decode$field, 'reader', author$project$Eth$Decoders$decodeContractAddress)));
var elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
var elm$core$Dict$Black = 1;
var elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var elm$core$Basics$compare = _Utils_compare;
var elm$core$Dict$Red = 0;
var elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _n1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _n3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _n5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _n6 = left.d;
				var _n7 = _n6.a;
				var llK = _n6.b;
				var llV = _n6.c;
				var llLeft = _n6.d;
				var llRight = _n6.e;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _n1 = A2(elm$core$Basics$compare, key, nKey);
			switch (_n1) {
				case 0:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3(elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3(elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$fromList = function (assocs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, dict) {
				var key = _n0.a;
				var value = _n0.b;
				return A3(elm$core$Dict$insert, key, value, dict);
			}),
		elm$core$Dict$empty,
		assocs);
};
var elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		elm$json$Json$Decode$map,
		elm$core$Dict$fromList,
		elm$json$Json$Decode$keyValuePairs(decoder));
};
var elm$json$Json$Decode$map4 = _Json_map4;
var author$project$Eth$Config$basicConfigDecoder = elm$json$Json$Decode$dict(
	elm$json$Json$Decode$maybe(
		A5(
			elm$json$Json$Decode$map4,
			author$project$Eth$Config$BasicConfig,
			A2(
				elm$json$Json$Decode$field,
				'Contracts',
				elm$json$Json$Decode$dict(author$project$Eth$Decoders$decodeContractAddress)),
			A2(
				elm$json$Json$Decode$field,
				'cTokens',
				elm$json$Json$Decode$dict(author$project$Eth$Config$decodeRawCToken)),
			A2(
				elm$json$Json$Decode$field,
				'Tokens',
				elm$json$Json$Decode$dict(author$project$Eth$Config$decodeToken)),
			A2(
				elm$json$Json$Decode$field,
				'InterestRateModel',
				elm$json$Json$Decode$dict(author$project$Eth$Config$decodeInterestRateModel)))));
var author$project$LandingSite$About$emptyState = {aG: _List_Nil};
var author$project$LandingSite$Developers$emptyState = {};
var author$project$LandingSite$DevelopersAPI$emptyState = {aM: elm$core$Dict$empty};
var author$project$LandingSite$Home$emptyState = {aG: _List_Nil};
var author$project$LandingSite$Markets$emptyState = {aG: _List_Nil, aI: elm$core$Maybe$Nothing, aJ: elm$core$Maybe$Nothing};
var author$project$LandingSite$Page$Home = {$: 0};
var author$project$Main$Tick = function (a) {
	return {$: 1, a: a};
};
var elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var elm$json$Json$Encode$string = _Json_wrap;
var author$project$LandingSite$About$loadScript = _Platform_outgoingPort(
	'loadScript',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			elm$json$Json$Encode$list,
			elm$core$Basics$identity,
			_List_fromArray(
				[
					elm$json$Json$Encode$string(a),
					elm$json$Json$Encode$string(b)
				]));
	});
var author$project$LandingSite$About$init = _Utils_Tuple2(
	author$project$LandingSite$About$emptyState,
	author$project$LandingSite$About$loadScript(
		_Utils_Tuple2('hire-embed-loader', 'https://hire.withgoogle.com/s/embed/hire-jobs.js?company=compoundfinance')));
var author$project$Utils$Highlighter$highlightScroll = _Platform_outgoingPort(
	'highlightScroll',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			elm$json$Json$Encode$list,
			elm$core$Basics$identity,
			_List_fromArray(
				[
					elm$json$Json$Encode$string(a),
					elm$json$Json$Encode$string(b)
				]));
	});
var author$project$LandingSite$Developers$init = _Utils_Tuple2(
	author$project$LandingSite$Developers$emptyState,
	author$project$Utils$Highlighter$highlightScroll(
		_Utils_Tuple2('.navigation a', 'section[id],.function[id]')));
var author$project$Utils$ProtoDoc$File = F4(
	function (name, enums, messages, services) {
		return {aF: enums, dw: messages, dA: name, dQ: services};
	});
var author$project$Utils$ProtoDoc$Enum = F4(
	function (name, longName, fullName, values) {
		return {Q: fullName, ba: longName, dA: name, ej: values};
	});
var author$project$Utils$ProtoDoc$EnumValue = F3(
	function (name, number, description) {
		return {A: description, dA: name, dB: number};
	});
var elm$json$Json$Decode$map3 = _Json_map3;
var author$project$Utils$ProtoDoc$decodeEnumValue = A4(
	elm$json$Json$Decode$map3,
	author$project$Utils$ProtoDoc$EnumValue,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'number', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'description', elm$json$Json$Decode$string));
var elm$json$Json$Decode$list = _Json_decodeList;
var author$project$Utils$ProtoDoc$decodeEnum = A5(
	elm$json$Json$Decode$map4,
	author$project$Utils$ProtoDoc$Enum,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'longName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'fullName', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$field,
		'values',
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeEnumValue)));
var author$project$Utils$ProtoDoc$Message = F5(
	function (name, longName, fullName, description, fields) {
		return {A: description, bS: fields, Q: fullName, ba: longName, dA: name};
	});
var author$project$Utils$ProtoDoc$Field = F4(
	function (name, description, fieldType, fullType) {
		return {A: description, P: fieldType, R: fullType, dA: name};
	});
var author$project$Utils$ProtoDoc$decodeField = A5(
	elm$json$Json$Decode$map4,
	author$project$Utils$ProtoDoc$Field,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'description', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'type', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'fullType', elm$json$Json$Decode$string));
var author$project$Utils$ProtoDoc$decodeMessage = A6(
	elm$json$Json$Decode$map5,
	author$project$Utils$ProtoDoc$Message,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'longName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'fullName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'description', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$field,
		'fields',
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeField)));
var author$project$Utils$ProtoDoc$Service = F5(
	function (name, longName, fullName, description, methods) {
		return {A: description, Q: fullName, ba: longName, dy: methods, dA: name};
	});
var author$project$Utils$ProtoDoc$Method = F5(
	function (name, description, requestFullType, responseFullType, rules) {
		return {A: description, dA: name, ct: requestFullType, cv: responseFullType, dP: rules};
	});
var author$project$Utils$ProtoDoc$Rule = F2(
	function (method, pattern) {
		return {dx: method, dJ: pattern};
	});
var author$project$Utils$ProtoDoc$decodeRule = A3(
	elm$json$Json$Decode$map2,
	author$project$Utils$ProtoDoc$Rule,
	A2(elm$json$Json$Decode$field, 'method', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'pattern', elm$json$Json$Decode$string));
var elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							elm$core$List$foldl,
							fn,
							acc,
							elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
	});
var author$project$Utils$ProtoDoc$decodeMethod = A6(
	elm$json$Json$Decode$map5,
	author$project$Utils$ProtoDoc$Method,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'description', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'requestFullType', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'responseFullType', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['options', 'google.api.http', 'rules']),
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeRule)));
var author$project$Utils$ProtoDoc$decodeService = A6(
	elm$json$Json$Decode$map5,
	author$project$Utils$ProtoDoc$Service,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'longName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'fullName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'description', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$field,
		'methods',
		elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeMethod),
					elm$json$Json$Decode$succeed(_List_Nil)
				]))));
var author$project$Utils$ProtoDoc$decodeFile = A5(
	elm$json$Json$Decode$map4,
	author$project$Utils$ProtoDoc$File,
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$field,
		'enums',
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeEnum)),
	A2(
		elm$json$Json$Decode$field,
		'messages',
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeMessage)),
	A2(
		elm$json$Json$Decode$field,
		'services',
		elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeService)));
var elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var author$project$Utils$ProtoDoc$toDict = F2(
	function (els, fn) {
		return elm$core$Dict$fromList(
			A2(
				elm$core$List$map,
				function (el) {
					return _Utils_Tuple2(
						fn(el),
						el);
				},
				els));
	});
var author$project$Utils$ProtoDoc$fileToProtoDoc = function (_n0) {
	var name = _n0.dA;
	var enums = _n0.aF;
	var messages = _n0.dw;
	var services = _n0.dQ;
	return _Utils_Tuple2(
		name,
		{
			aF: A2(
				author$project$Utils$ProtoDoc$toDict,
				enums,
				function ($) {
					return $.Q;
				}),
			dw: A2(
				author$project$Utils$ProtoDoc$toDict,
				messages,
				function ($) {
					return $.Q;
				}),
			dQ: A2(
				author$project$Utils$ProtoDoc$toDict,
				services,
				function ($) {
					return $.Q;
				})
		});
};
var elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return elm$core$Result$Err(e);
		}
	});
var elm$json$Json$Decode$decodeValue = _Json_run;
var author$project$Utils$ProtoDoc$decodeProtoDoc = function (val) {
	return A2(
		elm$core$Result$map,
		elm$core$Dict$fromList,
		A2(
			elm$core$Result$map,
			elm$core$List$map(author$project$Utils$ProtoDoc$fileToProtoDoc),
			A2(
				elm$json$Json$Decode$decodeValue,
				A2(
					elm$json$Json$Decode$field,
					'files',
					elm$json$Json$Decode$list(author$project$Utils$ProtoDoc$decodeFile)),
				val)));
};
var elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var author$project$LandingSite$DevelopersAPI$init = function (protoDocJson) {
	var protoDoc = A2(
		elm$core$Result$withDefault,
		elm$core$Dict$empty,
		author$project$Utils$ProtoDoc$decodeProtoDoc(protoDocJson));
	return _Utils_Tuple2(
		{aM: protoDoc},
		author$project$Utils$Highlighter$highlightScroll(
			_Utils_Tuple2('.navigation a', 'section[id],.function[id]')));
};
var author$project$LandingSite$Page$getHrefUrl = function (page) {
	switch (page.$) {
		case 0:
			return '/';
		case 1:
			return '/About';
		case 2:
			if (page.a.$ === 1) {
				var _n1 = page.a;
				return '/Developers';
			} else {
				var section = page.a.a;
				return '/Developers#' + section;
			}
		case 3:
			if (page.a.$ === 1) {
				var _n2 = page.a;
				return '/Developers/api';
			} else {
				var section = page.a.a;
				return '/Developers/api#' + section;
			}
		case 4:
			return '/legacy';
		case 5:
			var networkString = page.a;
			var contractName = page.b;
			return '/Developers/abi/' + (networkString + ('/' + contractName));
		case 6:
			return '/Markets';
		default:
			var cTokenSymbol = page.a;
			return '/Asset/' + cTokenSymbol;
	}
};
var author$project$LandingSite$Page$About = {$: 1};
var author$project$LandingSite$Page$DevelopersABIView = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var author$project$LandingSite$Page$DevelopersAPI = function (a) {
	return {$: 3, a: a};
};
var author$project$LandingSite$Page$DevelopersHome = function (a) {
	return {$: 2, a: a};
};
var author$project$LandingSite$Page$DevelopersLegacy = {$: 4};
var author$project$LandingSite$Page$Markets = {$: 6};
var elm$url$Url$Parser$Parser = elm$core$Basics$identity;
var elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {E: frag, I: params, D: unvisited, x: value, J: visited};
	});
var elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_n0) {
		var visited = _n0.J;
		var unvisited = _n0.D;
		var params = _n0.I;
		var frag = _n0.E;
		var value = _n0.x;
		return _List_fromArray(
			[
				A5(
				elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var elm$url$Url$Parser$mapState = F2(
	function (func, _n0) {
		var visited = _n0.J;
		var unvisited = _n0.D;
		var params = _n0.I;
		var frag = _n0.E;
		var value = _n0.x;
		return A5(
			elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var elm$url$Url$Parser$map = F2(
	function (subValue, _n0) {
		var parseArg = _n0;
		return function (_n1) {
			var visited = _n1.J;
			var unvisited = _n1.D;
			var params = _n1.I;
			var frag = _n1.E;
			var value = _n1.x;
			return A2(
				elm$core$List$map,
				elm$url$Url$Parser$mapState(value),
				parseArg(
					A5(elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
		}
	});
var elm$core$List$concat = function (lists) {
	return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
};
var elm$core$List$concatMap = F2(
	function (f, list) {
		return elm$core$List$concat(
			A2(elm$core$List$map, f, list));
	});
var elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			elm$core$List$concatMap,
			function (_n0) {
				var parser = _n0;
				return parser(state);
			},
			parsers);
	};
};
var elm$url$Url$Parser$s = function (str) {
	return function (_n0) {
		var visited = _n0.J;
		var unvisited = _n0.D;
		var params = _n0.I;
		var frag = _n0.E;
		var value = _n0.x;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					elm$url$Url$Parser$State,
					A2(elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var elm$url$Url$Parser$slash = F2(
	function (_n0, _n1) {
		var parseBefore = _n0;
		var parseAfter = _n1;
		return function (state) {
			return A2(
				elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_n0) {
			var visited = _n0.J;
			var unvisited = _n0.D;
			var params = _n0.I;
			var frag = _n0.E;
			var value = _n0.x;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _n2 = stringToSomething(next);
				if (!_n2.$) {
					var nextValue = _n2.a;
					return _List_fromArray(
						[
							A5(
							elm$url$Url$Parser$State,
							A2(elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var elm$url$Url$Parser$string = A2(elm$url$Url$Parser$custom, 'STRING', elm$core$Maybe$Just);
var elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var author$project$LandingSite$Page$parser = elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(elm$url$Url$Parser$map, author$project$LandingSite$Page$Home, elm$url$Url$Parser$top),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$Markets,
			elm$url$Url$Parser$s('Markets')),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$About,
			elm$url$Url$Parser$s('About')),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$DevelopersHome,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('Developers'),
				elm$url$Url$Parser$fragment(elm$core$Basics$identity))),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$DevelopersAPI,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('Developers'),
				A2(
					elm$url$Url$Parser$slash,
					elm$url$Url$Parser$s('api'),
					elm$url$Url$Parser$fragment(elm$core$Basics$identity)))),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$DevelopersLegacy,
			elm$url$Url$Parser$s('legacy')),
			A2(
			elm$url$Url$Parser$map,
			author$project$LandingSite$Page$DevelopersABIView,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('Developers'),
				A2(
					elm$url$Url$Parser$slash,
					elm$url$Url$Parser$s('abi'),
					A2(elm$url$Url$Parser$slash, elm$url$Url$Parser$string, elm$url$Url$Parser$string))))
		]));
var elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _n1 = state.D;
			if (!_n1.b) {
				return elm$core$Maybe$Just(state.x);
			} else {
				if ((_n1.a === '') && (!_n1.b.b)) {
					return elm$core$Maybe$Just(state.x);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				elm$core$List$cons,
				segment,
				elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var elm$url$Url$Parser$preparePath = function (path) {
	var _n0 = A2(elm$core$String$split, '/', path);
	if (_n0.b && (_n0.a === '')) {
		var segments = _n0.b;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _n0;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _n1 = A2(elm$core$Basics$compare, targetKey, key);
				switch (_n1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var lLeft = _n1.d;
			var lRight = _n1.e;
			var _n2 = dict.e;
			var rClr = _n2.a;
			var rK = _n2.b;
			var rV = _n2.c;
			var rLeft = _n2.d;
			var _n3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _n2.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n4 = dict.d;
			var lClr = _n4.a;
			var lK = _n4.b;
			var lV = _n4.c;
			var lLeft = _n4.d;
			var lRight = _n4.e;
			var _n5 = dict.e;
			var rClr = _n5.a;
			var rK = _n5.b;
			var rV = _n5.c;
			var rLeft = _n5.d;
			var rRight = _n5.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var _n2 = _n1.d;
			var _n3 = _n2.a;
			var llK = _n2.b;
			var llV = _n2.c;
			var llLeft = _n2.d;
			var llRight = _n2.e;
			var lRight = _n1.e;
			var _n4 = dict.e;
			var rClr = _n4.a;
			var rK = _n4.b;
			var rV = _n4.c;
			var rLeft = _n4.d;
			var rRight = _n4.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n5 = dict.d;
			var lClr = _n5.a;
			var lK = _n5.b;
			var lV = _n5.c;
			var lLeft = _n5.d;
			var lRight = _n5.e;
			var _n6 = dict.e;
			var rClr = _n6.a;
			var rK = _n6.b;
			var rV = _n6.c;
			var rLeft = _n6.d;
			var rRight = _n6.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _n1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_n2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _n3 = right.a;
							var _n4 = right.d;
							var _n5 = _n4.a;
							return elm$core$Dict$moveRedRight(dict);
						} else {
							break _n2$2;
						}
					} else {
						var _n6 = right.a;
						var _n7 = right.d;
						return elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _n2$2;
				}
			}
			return dict;
		}
	});
var elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _n3 = lLeft.a;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			} else {
				var _n4 = elm$core$Dict$moveRedLeft(dict);
				if (_n4.$ === -1) {
					var nColor = _n4.a;
					var nKey = _n4.b;
					var nValue = _n4.c;
					var nLeft = _n4.d;
					var nRight = _n4.e;
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _n4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _n6 = lLeft.a;
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _n7 = elm$core$Dict$moveRedLeft(dict);
						if (_n7.$ === -1) {
							var nColor = _n7.a;
							var nKey = _n7.b;
							var nValue = _n7.c;
							var nLeft = _n7.d;
							var nRight = _n7.e;
							return A5(
								elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2(elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2(elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _n1 = elm$core$Dict$getMin(right);
				if (_n1.$ === -1) {
					var minKey = _n1.b;
					var minValue = _n1.c;
					return A5(
						elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						elm$core$Dict$removeMin(right));
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2(elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var elm$core$Dict$remove = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _n0 = alter(
			A2(elm$core$Dict$get, targetKey, dictionary));
		if (!_n0.$) {
			var value = _n0.a;
			return A3(elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2(elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var elm$url$Url$percentDecode = _Url_percentDecode;
var elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return elm$core$Maybe$Just(
				A2(elm$core$List$cons, value, list));
		}
	});
var elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _n0 = A2(elm$core$String$split, '=', segment);
		if ((_n0.b && _n0.b.b) && (!_n0.b.b.b)) {
			var rawKey = _n0.a;
			var _n1 = _n0.b;
			var rawValue = _n1.a;
			var _n2 = elm$url$Url$percentDecode(rawKey);
			if (_n2.$ === 1) {
				return dict;
			} else {
				var key = _n2.a;
				var _n3 = elm$url$Url$percentDecode(rawValue);
				if (_n3.$ === 1) {
					return dict;
				} else {
					var value = _n3.a;
					return A3(
						elm$core$Dict$update,
						key,
						elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			elm$core$List$foldr,
			elm$url$Url$Parser$addParam,
			elm$core$Dict$empty,
			A2(elm$core$String$split, '&', qry));
	}
};
var elm$url$Url$Parser$parse = F2(
	function (_n0, url) {
		var parser = _n0;
		return elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					elm$url$Url$Parser$State,
					_List_Nil,
					elm$url$Url$Parser$preparePath(url.bj),
					elm$url$Url$Parser$prepareQuery(url.cp),
					url.bU,
					elm$core$Basics$identity)));
	});
var author$project$LandingSite$Page$getLandingPage = function (location) {
	return A2(
		elm$core$Maybe$withDefault,
		author$project$LandingSite$Page$Home,
		A2(elm$url$Url$Parser$parse, author$project$LandingSite$Page$parser, location));
};
var author$project$LandingSite$About$translator = F2(
	function (_n0, msg) {
		var onInternalMessage = _n0.cg;
		var internal = msg;
		return onInternalMessage(internal);
	});
var author$project$Main$LandingAboutMsg = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$landingAboutTranslator = author$project$LandingSite$About$translator(
	{cg: author$project$Main$LandingAboutMsg});
var author$project$LandingSite$DevelopersAPI$translator = F2(
	function (_n0, msg) {
		var onInternalMessage = _n0.cg;
		var internal = msg;
		return onInternalMessage(internal);
	});
var author$project$Main$LandingDevelopersApiMsg = function (a) {
	return {$: 6, a: a};
};
var author$project$Main$landingDevelopersApiTranslator = author$project$LandingSite$DevelopersAPI$translator(
	{cg: author$project$Main$LandingDevelopersApiMsg});
var author$project$LandingSite$Developers$translator = F2(
	function (_n0, msg) {
		var onInternalMessage = _n0.cg;
		var internal = msg;
		return onInternalMessage(internal);
	});
var author$project$Main$LandingDevelopersPresidioMsg = function (a) {
	return {$: 7, a: a};
};
var author$project$Main$landingDevelopersPresidioTranslator = author$project$LandingSite$Developers$translator(
	{cg: author$project$Main$LandingDevelopersPresidioMsg});
var author$project$Main$scrollIntoView = _Platform_outgoingPort('scrollIntoView', elm$json$Json$Encode$string);
var elm$core$Platform$Cmd$batch = _Platform_batch;
var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
var author$project$Main$maybeScroll = function (page) {
	_n0$2:
	while (true) {
		switch (page.$) {
			case 2:
				if (!page.a.$) {
					var fragment = page.a.a;
					return author$project$Main$scrollIntoView(fragment);
				} else {
					break _n0$2;
				}
			case 3:
				if (!page.a.$) {
					var fragment = page.a.a;
					return author$project$Main$scrollIntoView(fragment);
				} else {
					break _n0$2;
				}
			default:
				break _n0$2;
		}
	}
	return elm$core$Platform$Cmd$none;
};
var author$project$Main$pageTransition = _Platform_outgoingPort(
	'pageTransition',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			elm$json$Json$Encode$list,
			elm$core$Basics$identity,
			_List_fromArray(
				[
					elm$json$Json$Encode$string(a),
					elm$json$Json$Encode$string(b)
				]));
	});
var elm$core$Basics$neq = _Utils_notEqual;
var elm$core$Platform$Cmd$map = _Platform_map;
var author$project$Main$transitionPage = F2(
	function (model, url) {
		var newPage = function () {
			if (!url.$) {
				var location = url.a;
				return author$project$LandingSite$Page$getLandingPage(location);
			} else {
				return author$project$LandingSite$Page$Home;
			}
		}();
		var pageTransitionCmd = author$project$Main$pageTransition(
			_Utils_Tuple2(
				author$project$LandingSite$Page$getHrefUrl(model.H),
				author$project$LandingSite$Page$getHrefUrl(newPage)));
		var abiResetModel = _Utils_update(
			model,
			{al: elm$core$Maybe$Nothing});
		var _n0 = function () {
			if (!_Utils_eq(model.H, newPage)) {
				switch (newPage.$) {
					case 1:
						var _n2 = author$project$LandingSite$About$init;
						var landingModel = _n2.a;
						var landingCmd = _n2.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{U: landingModel}),
							A2(elm$core$Platform$Cmd$map, author$project$Main$landingAboutTranslator, landingCmd));
					case 2:
						var fragment = newPage.a;
						var _n3 = author$project$LandingSite$Developers$init;
						var landingModel = _n3.a;
						var landingCmd = _n3.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{W: landingModel}),
							A2(elm$core$Platform$Cmd$map, author$project$Main$landingDevelopersPresidioTranslator, landingCmd));
					case 3:
						var fragment = newPage.a;
						var _n4 = author$project$LandingSite$DevelopersAPI$init(model.aa);
						var landingModel = _n4.a;
						var landingCmd = _n4.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{V: landingModel}),
							A2(elm$core$Platform$Cmd$map, author$project$Main$landingDevelopersApiTranslator, landingCmd));
					case 5:
						var networkString = newPage.a;
						var contractName = newPage.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{
									al: elm$core$Maybe$Just(
										_Utils_Tuple2(networkString, contractName))
								}),
							elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(abiResetModel, elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(abiResetModel, elm$core$Platform$Cmd$none);
			}
		}();
		var newModel = _n0.a;
		var newCmd = _n0.b;
		return _Utils_Tuple2(
			_Utils_update(
				newModel,
				{H: newPage}),
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						pageTransitionCmd,
						author$project$Main$maybeScroll(newPage),
						newCmd
					])));
	});
var author$project$Main$transitionTo = F2(
	function (url, _n0) {
		var model = _n0.a;
		var cmd = _n0.b;
		var _n1 = A2(author$project$Main$transitionPage, model, url);
		var newModel = _n1.a;
		var pageCmd = _n1.b;
		return _Utils_Tuple2(
			newModel,
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[pageCmd, cmd])));
	});
var author$project$Preferences$USD = 1;
var elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			elm$core$List$foldl,
			F2(
				function (_n0, obj) {
					var k = _n0.a;
					var v = _n0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var author$project$Preferences$askStoredPreferencesPort = _Platform_outgoingPort(
	'askStoredPreferencesPort',
	function ($) {
		return elm$json$Json$Encode$object(_List_Nil);
	});
var author$project$Preferences$askStoredPreferences = author$project$Preferences$askStoredPreferencesPort(
	{});
var author$project$Preferences$preferencesInit = _Utils_Tuple2(
	{N: 1},
	author$project$Preferences$askStoredPreferences);
var author$project$Strings$Translations$En = 0;
var elm$core$Task$Perform = elm$core$Basics$identity;
var elm$core$Task$succeed = _Scheduler_succeed;
var elm$core$Task$init = elm$core$Task$succeed(0);
var elm$core$Task$andThen = _Scheduler_andThen;
var elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return A2(
					elm$core$Task$andThen,
					function (b) {
						return elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var elm$core$Task$sequence = function (tasks) {
	return A3(
		elm$core$List$foldr,
		elm$core$Task$map2(elm$core$List$cons),
		elm$core$Task$succeed(_List_Nil),
		tasks);
};
var elm$core$Platform$sendToApp = _Platform_sendToApp;
var elm$core$Task$spawnCmd = F2(
	function (router, _n0) {
		var task = _n0;
		return _Scheduler_spawn(
			A2(
				elm$core$Task$andThen,
				elm$core$Platform$sendToApp(router),
				task));
	});
var elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			elm$core$Task$map,
			function (_n0) {
				return 0;
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Task$spawnCmd(router),
					commands)));
	});
var elm$core$Task$onSelfMsg = F3(
	function (_n0, _n1, _n2) {
		return elm$core$Task$succeed(0);
	});
var elm$core$Task$cmdMap = F2(
	function (tagger, _n0) {
		var task = _n0;
		return A2(elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
var elm$core$Task$command = _Platform_leaf('Task');
var elm$core$Task$perform = F2(
	function (toMessage, task) {
		return elm$core$Task$command(
			A2(elm$core$Task$map, toMessage, task));
	});
var elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$customZone = elm$time$Time$Zone;
var elm$time$Time$Posix = elm$core$Basics$identity;
var elm$time$Time$millisToPosix = elm$core$Basics$identity;
var elm$time$Time$now = _Time_now(elm$time$Time$millisToPosix);
var elm$core$String$length = _String_length;
var elm$core$String$slice = _String_slice;
var elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			elm$core$String$slice,
			n,
			elm$core$String$length(string),
			string);
	});
var elm$core$String$startsWith = _String_startsWith;
var elm$url$Url$Http = 0;
var elm$url$Url$Https = 1;
var elm$core$String$indexes = _String_indexes;
var elm$core$String$isEmpty = function (string) {
	return string === '';
};
var elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
	});
var elm$core$String$contains = _String_contains;
var elm$core$String$toInt = _String_toInt;
var elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bU: fragment, bX: host, bj: path, cj: port_, co: protocol, cp: query};
	});
var elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, ':', str);
			if (!_n0.b) {
				return elm$core$Maybe$Just(
					A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_n0.b.b) {
					var i = _n0.a;
					var _n1 = elm$core$String$toInt(
						A2(elm$core$String$dropLeft, i + 1, str));
					if (_n1.$ === 1) {
						return elm$core$Maybe$Nothing;
					} else {
						var port_ = _n1;
						return elm$core$Maybe$Just(
							A6(
								elm$url$Url$Url,
								protocol,
								A2(elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return elm$core$Maybe$Nothing;
				}
			}
		}
	});
var elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '/', str);
			if (!_n0.b) {
				return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _n0.a;
				return A5(
					elm$url$Url$chompBeforePath,
					protocol,
					A2(elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '?', str);
			if (!_n0.b) {
				return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _n0.a;
				return A4(
					elm$url$Url$chompBeforeQuery,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '#', str);
			if (!_n0.b) {
				return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
			} else {
				var i = _n0.a;
				return A3(
					elm$url$Url$chompBeforeFragment,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$fromString = function (str) {
	return A2(elm$core$String$startsWith, 'http://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		0,
		A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		1,
		A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
};
var author$project$Main$init = function (_n0) {
	var path = _n0.bj;
	var configAbiFiles = _n0.aV;
	var configurations = _n0.aX;
	var apiBaseUrlMap = _n0.aT;
	var apiBaseUrl = _n0.M;
	var protoDocJson = _n0.aa;
	var dummyconfigs = A2(
		elm$core$Result$withDefault,
		elm$core$Dict$empty,
		A2(
			elm$json$Json$Decode$decodeValue,
			elm$json$Json$Decode$dict(elm$json$Json$Decode$string),
			configurations));
	var decodedApiBaseUrl = A2(
		elm$core$Result$withDefault,
		'',
		A2(elm$json$Json$Decode$decodeValue, elm$json$Json$Decode$string, apiBaseUrl));
	var configs = A2(
		elm$core$Result$withDefault,
		elm$core$Dict$empty,
		A2(elm$json$Json$Decode$decodeValue, author$project$Eth$Config$basicConfigDecoder, configurations));
	var _n1 = author$project$Preferences$preferencesInit;
	var initPreferences = _n1.a;
	var initPreferencesCmd = _n1.b;
	return A2(
		author$project$Main$transitionTo,
		elm$url$Url$fromString(path),
		_Utils_Tuple2(
			{M: decodedApiBaseUrl, aW: configAbiFiles, aC: configs, aD: elm$core$Maybe$Nothing, al: elm$core$Maybe$Nothing, aG: _List_Nil, U: author$project$LandingSite$About$emptyState, V: author$project$LandingSite$DevelopersAPI$emptyState, W: author$project$LandingSite$Developers$emptyState, an: author$project$LandingSite$Home$emptyState, X: author$project$LandingSite$Markets$emptyState, H: author$project$LandingSite$Page$Home, _: initPreferences, aa: protoDocJson, aQ: 0},
			A2(elm$core$Task$perform, author$project$Main$Tick, elm$time$Time$now)));
};
var author$project$Main$UrlChange = function (a) {
	return {$: 0, a: a};
};
var author$project$Main$onUrlChange = _Platform_incomingPort('onUrlChange', elm$json$Json$Decode$string);
var author$project$Utils$Time$seconds = 1;
var elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var elm$core$Platform$Sub$batch = _Platform_batch;
var elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$State = F2(
	function (taggers, processes) {
		return {cn: processes, cH: taggers};
	});
var elm$time$Time$init = elm$core$Task$succeed(
	A2(elm$time$Time$State, elm$core$Dict$empty, elm$core$Dict$empty));
var elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _n0) {
				stepState:
				while (true) {
					var list = _n0.a;
					var result = _n0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _n2 = list.a;
						var lKey = _n2.a;
						var lValue = _n2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_n0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_n0 = $temp$_n0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _n3 = A3(
			elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _n3.a;
		var intermediateResult = _n3.b;
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n4, result) {
					var k = _n4.a;
					var v = _n4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var elm$core$Process$kill = _Scheduler_kill;
var elm$time$Time$addMySub = F2(
	function (_n0, state) {
		var interval = _n0.a;
		var tagger = _n0.b;
		var _n1 = A2(elm$core$Dict$get, interval, state);
		if (_n1.$ === 1) {
			return A3(
				elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _n1.a;
			return A3(
				elm$core$Dict$insert,
				interval,
				A2(elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var elm$core$Process$spawn = _Scheduler_spawn;
var elm$time$Time$setInterval = _Time_setInterval;
var elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = elm$core$Process$spawn(
				A2(
					elm$time$Time$setInterval,
					interval,
					A2(elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					elm$time$Time$spawnHelp,
					router,
					rest,
					A3(elm$core$Dict$insert, interval, id, processes));
			};
			return A2(elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var elm$time$Time$onEffects = F3(
	function (router, subs, _n0) {
		var processes = _n0.cn;
		var rightStep = F3(
			function (_n6, id, _n7) {
				var spawns = _n7.a;
				var existing = _n7.b;
				var kills = _n7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						elm$core$Task$andThen,
						function (_n5) {
							return kills;
						},
						elm$core$Process$kill(id)));
			});
		var newTaggers = A3(elm$core$List$foldl, elm$time$Time$addMySub, elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _n4) {
				var spawns = _n4.a;
				var existing = _n4.b;
				var kills = _n4.c;
				return _Utils_Tuple3(
					A2(elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _n3) {
				var spawns = _n3.a;
				var existing = _n3.b;
				var kills = _n3.c;
				return _Utils_Tuple3(
					spawns,
					A3(elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _n1 = A6(
			elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				elm$core$Dict$empty,
				elm$core$Task$succeed(0)));
		var spawnList = _n1.a;
		var existingDict = _n1.b;
		var killTask = _n1.c;
		return A2(
			elm$core$Task$andThen,
			function (newProcesses) {
				return elm$core$Task$succeed(
					A2(elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				elm$core$Task$andThen,
				function (_n2) {
					return A3(elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _n0 = A2(elm$core$Dict$get, interval, state.cH);
		if (_n0.$ === 1) {
			return elm$core$Task$succeed(state);
		} else {
			var taggers = _n0.a;
			var tellTaggers = function (time) {
				return elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						function (tagger) {
							return A2(
								elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				A2(elm$core$Task$andThen, tellTaggers, elm$time$Time$now));
		}
	});
var elm$time$Time$subMap = F2(
	function (f, _n0) {
		var interval = _n0.a;
		var tagger = _n0.b;
		return A2(
			elm$time$Time$Every,
			interval,
			A2(elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager(elm$time$Time$init, elm$time$Time$onEffects, elm$time$Time$onSelfMsg, 0, elm$time$Time$subMap);
var elm$time$Time$subscription = _Platform_leaf('Time');
var elm$time$Time$every = F2(
	function (interval, tagger) {
		return elm$time$Time$subscription(
			A2(elm$time$Time$Every, interval, tagger));
	});
var author$project$Main$subscriptions = function (model) {
	return elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(elm$time$Time$every, (1000.0 * 10.0) * author$project$Utils$Time$seconds, author$project$Main$Tick),
				author$project$Main$onUrlChange(
				A2(elm$core$Basics$composeR, elm$url$Url$fromString, author$project$Main$UrlChange))
			]));
};
var author$project$Console$log = _Platform_outgoingPort('log', elm$json$Json$Encode$string);
var author$project$Console$error = function (err) {
	return author$project$Console$log('Error: ' + err);
};
var author$project$LandingSite$About$update = F2(
	function (msg, model) {
		var error = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aG: A2(elm$core$List$cons, error, model.aG)
				}),
			author$project$Console$error(error));
	});
var author$project$LandingSite$Developers$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	});
var author$project$LandingSite$DevelopersAPI$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	});
var author$project$LandingSite$Home$update = F2(
	function (msg, model) {
		var error = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aG: A2(elm$core$List$cons, error, model.aG)
				}),
			author$project$Console$error(error));
	});
var author$project$CompoundApi$Common$Models$API_Error = F2(
	function (error_code, message) {
		return {de: error_code, dv: message};
	});
var elm$json$Json$Decode$null = _Json_decodeNull;
var elm$json$Json$Decode$nullable = function (decoder) {
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
			]));
};
var author$project$CompoundApi$Common$Decoders$apiErrorDecoder = elm$json$Json$Decode$nullable(
	A3(
		elm$json$Json$Decode$map2,
		author$project$CompoundApi$Common$Models$API_Error,
		A2(elm$json$Json$Decode$field, 'error_code', elm$json$Json$Decode$int),
		A2(elm$json$Json$Decode$field, 'message', elm$json$Json$Decode$string)));
var author$project$Decimal$Decimal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var cmditch$elm_bigint$BigInt$Negative = 1;
var cmditch$elm_bigint$BigInt$Positive = 0;
var cmditch$elm_bigint$BigInt$Magnitude = elm$core$Basics$identity;
var elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var cmditch$elm_bigint$BigInt$emptyZero = function (_n0) {
	var xs = _n0;
	var _n1 = A2(
		elm_community$list_extra$List$Extra$dropWhile,
		elm$core$Basics$eq(0),
		xs);
	if (!_n1.b) {
		return _List_Nil;
	} else {
		return xs;
	}
};
var cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return elm$core$Maybe$Just(
				f(value));
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var elm$core$String$fromList = _String_fromList;
var elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2(elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var elm$core$List$takeTailRec = F2(
	function (n, list) {
		return elm$core$List$reverse(
			A3(elm$core$List$takeReverse, n, list, _List_Nil));
	});
var elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _n0 = _Utils_Tuple2(n, list);
			_n0$1:
			while (true) {
				_n0$5:
				while (true) {
					if (!_n0.b.b) {
						return list;
					} else {
						if (_n0.b.b.b) {
							switch (_n0.a) {
								case 1:
									break _n0$1;
								case 2:
									var _n2 = _n0.b;
									var x = _n2.a;
									var _n3 = _n2.b;
									var y = _n3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_n0.b.b.b.b) {
										var _n4 = _n0.b;
										var x = _n4.a;
										var _n5 = _n4.b;
										var y = _n5.a;
										var _n6 = _n5.b;
										var z = _n6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _n0$5;
									}
								default:
									if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
										var _n7 = _n0.b;
										var x = _n7.a;
										var _n8 = _n7.b;
										var y = _n8.a;
										var _n9 = _n8.b;
										var z = _n9.a;
										var _n10 = _n9.b;
										var w = _n10.a;
										var tl = _n10.b;
										return (ctr > 1000) ? A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _n0$5;
									}
							}
						} else {
							if (_n0.a === 1) {
								break _n0$1;
							} else {
								break _n0$5;
							}
						}
					}
				}
				return list;
			}
			var _n1 = _n0.b;
			var x = _n1.a;
			return _List_fromArray(
				[x]);
		}
	});
var elm$core$List$take = F2(
	function (n, list) {
		return A3(elm$core$List$takeFast, 0, n, list);
	});
var elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2(elm$core$List$drop, step, xs);
		var okayXs = elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			elm$core$List$cons,
			A2(elm$core$List$take, size, xs),
			A3(elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3(elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var elm_community$maybe_extra$Maybe$Extra$traverse = function (f) {
	var step = F2(
		function (e, acc) {
			var _n0 = f(e);
			if (_n0.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var x = _n0.a;
				return A2(
					elm$core$Maybe$map,
					elm$core$List$cons(x),
					acc);
			}
		});
	return A2(
		elm$core$List$foldr,
		step,
		elm$core$Maybe$Just(_List_Nil));
};
var elm_community$maybe_extra$Maybe$Extra$combine = elm_community$maybe_extra$Maybe$Extra$traverse(elm$core$Basics$identity);
var cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		elm$core$Maybe$map,
		A2(elm$core$Basics$composeL, cmditch$elm_bigint$BigInt$emptyZero, elm$core$Basics$identity),
		elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				elm$core$List$map,
				A2(
					elm$core$Basics$composeR,
					elm$core$List$reverse,
					A2(elm$core$Basics$composeR, elm$core$String$fromList, elm$core$String$toInt)),
				A2(
					elm_community$list_extra$List$Extra$greedyGroupsOf,
					cmditch$elm_bigint$Constants$maxDigitMagnitude,
					elm$core$List$reverse(x)))));
};
var cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var cmditch$elm_bigint$BigInt$Zer = {$: 2};
var elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if (elm$core$List$isEmpty(digits)) {
			return cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var elm$core$String$foldr = _String_foldr;
var elm$core$String$toList = function (string) {
	return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
};
var cmditch$elm_bigint$BigInt$fromString = function (x) {
	var _n0 = elm$core$String$toList(
		elm$core$String$toLower(x));
	if (!_n0.b) {
		return elm$core$Maybe$Nothing;
	} else {
		switch (_n0.a) {
			case '-':
				if (!_n0.b.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var xs = _n0.b;
					return A2(
						elm$core$Maybe$map,
						cmditch$elm_bigint$BigInt$mkBigInt(1),
						cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_n0.b.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var xs = _n0.b;
					return A2(
						elm$core$Maybe$map,
						cmditch$elm_bigint$BigInt$mkBigInt(0),
						cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _n0;
				return A2(
					elm$core$Maybe$map,
					cmditch$elm_bigint$BigInt$mkBigInt(0),
					cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var elm$core$Basics$negate = function (n) {
	return -n;
};
var author$project$Decimal$fromString = function (s) {
	var stringToDecimal = function (targetString) {
		var stringIntToDecimal = F2(
			function (s_, e) {
				var _n8 = cmditch$elm_bigint$BigInt$fromString(s_);
				if (_n8.$ === 1) {
					return elm$core$Maybe$Nothing;
				} else {
					var a = _n8.a;
					return elm$core$Maybe$Just(
						A2(author$project$Decimal$Decimal, a, e));
				}
			});
		var _n6 = A2(elm$core$String$split, '.', targetString);
		_n6$2:
		while (true) {
			if (_n6.b) {
				if (_n6.b.b) {
					if (!_n6.b.b.b) {
						var a = _n6.a;
						var _n7 = _n6.b;
						var b = _n7.a;
						return A2(
							stringIntToDecimal,
							_Utils_ap(a, b),
							-elm$core$String$length(b));
					} else {
						break _n6$2;
					}
				} else {
					var a = _n6.a;
					return A2(stringIntToDecimal, a, 0);
				}
			} else {
				break _n6$2;
			}
		}
		return elm$core$Maybe$Nothing;
	};
	var makeMantissa = function (targetString) {
		var _n4 = A2(elm$core$String$split, '.', targetString);
		_n4$2:
		while (true) {
			if (_n4.b) {
				if (!_n4.b.b) {
					var s1 = _n4.a;
					return stringToDecimal(s1);
				} else {
					if (!_n4.b.b.b) {
						var s1 = _n4.a;
						var _n5 = _n4.b;
						var s2 = _n5.a;
						return stringToDecimal(
							A2(
								elm$core$String$join,
								'',
								_List_fromArray(
									[s1, s2])));
					} else {
						break _n4$2;
					}
				}
			} else {
				break _n4$2;
			}
		}
		return elm$core$Maybe$Nothing;
	};
	var splitMantissaExponent = function (targetString) {
		var _n2 = A2(
			elm$core$String$split,
			'e',
			elm$core$String$toLower(targetString));
		_n2$2:
		while (true) {
			if (_n2.b) {
				if (!_n2.b.b) {
					var s1 = _n2.a;
					return _Utils_Tuple2(
						stringToDecimal(s1),
						elm$core$Maybe$Just(0));
				} else {
					if (!_n2.b.b.b) {
						var s1 = _n2.a;
						var _n3 = _n2.b;
						var s2 = _n3.a;
						return _Utils_Tuple2(
							stringToDecimal(s1),
							elm$core$String$toInt(s2));
					} else {
						break _n2$2;
					}
				}
			} else {
				break _n2$2;
			}
		}
		return _Utils_Tuple2(elm$core$Maybe$Nothing, elm$core$Maybe$Nothing);
	};
	var _n0 = splitMantissaExponent(s);
	if ((!_n0.a.$) && (!_n0.b.$)) {
		var _n1 = _n0.a.a;
		var m = _n1.a;
		var a = _n1.b;
		var e = _n0.b.a;
		return elm$core$Maybe$Just(
			A2(author$project$Decimal$Decimal, m, e + a));
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$json$Json$Decode$fail = _Json_fail;
var author$project$Eth$Decoders$forceMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var val = maybe.a;
			return elm$json$Json$Decode$succeed(val);
		} else {
			return elm$json$Json$Decode$fail(err);
		}
	});
var author$project$Eth$Decoders$stringDecimal = A2(
	elm$json$Json$Decode$andThen,
	author$project$Eth$Decoders$forceMaybe('invalid float'),
	A2(elm$json$Json$Decode$map, author$project$Decimal$fromString, elm$json$Json$Decode$string));
var author$project$CompoundApi$Common$Decoders$apiPrecise = A2(elm$json$Json$Decode$field, 'value', author$project$Eth$Decoders$stringDecimal);
var author$project$CompoundApi$Presidio$CTokens$Decoders$andMap = elm$json$Json$Decode$map2(elm$core$Basics$apR);
var cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = elm$core$Basics$identity;
var elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _n0 = elm_community$list_extra$List$Extra$last(digits);
	if (_n0.$ === 1) {
		return false;
	} else {
		var x = _n0.a;
		return x < 0;
	}
};
var cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2(cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && elm$core$List$isEmpty(xs)) ? _List_Nil : A2(elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var cmditch$elm_bigint$BigInt$dropZeroes = elm_community$list_extra$List$Extra$dropWhileRight(
	elm$core$Basics$eq(0));
var elm$core$Basics$pow = _Basics_pow;
var cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2(elm$core$Basics$pow, 10, cmditch$elm_bigint$Constants$maxDigitMagnitude);
var cmditch$elm_bigint$BigInt$baseDigit = cmditch$elm_bigint$Constants$maxDigitValue + 1;
var elm$core$Tuple$mapFirst = F2(
	function (func, _n0) {
		var x = _n0.a;
		var y = _n0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		elm$core$Tuple$mapFirst,
		elm$core$Basics$add(-1),
		cmditch$elm_bigint$BigInt$normaliseDigit(x + cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / cmditch$elm_bigint$BigInt$baseDigit) | 0, x % cmditch$elm_bigint$BigInt$baseDigit);
};
var cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _n1 = cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _n1.a;
				var x_ = _n1.b;
				return A2(
					elm$core$List$cons,
					x_,
					A2(cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_n0) {
	var xs = _n0;
	return cmditch$elm_bigint$BigInt$dropZeroes(
		A2(cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var cmditch$elm_bigint$BigInt$reverseMagnitude = elm$core$List$map(elm$core$Basics$negate);
var cmditch$elm_bigint$BigInt$Zero = 2;
var cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var cmditch$elm_bigint$BigInt$normalise = function (_n0) {
	normalise:
	while (true) {
		var s = _n0.a;
		var digits = _n0.b;
		var _n1 = cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _n1;
		if (cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_n0 = A2(
				cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				cmditch$elm_bigint$BigInt$signNegate(s),
				cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_n0 = $temp$_n0;
			continue normalise;
		} else {
			return A2(cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var cmditch$elm_bigint$BigInt$MagnitudePair = elm$core$Basics$identity;
var cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _n0 = _Utils_Tuple2(xs, ys);
		if (!_n0.a.b) {
			if (!_n0.b.b) {
				return _List_Nil;
			} else {
				var _n2 = _n0.b;
				var y = _n2.a;
				var ys_ = _n2.b;
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2(cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_n0.b.b) {
				var _n1 = _n0.a;
				var x = _n1.a;
				var xs_ = _n1.b;
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2(cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _n3 = _n0.a;
				var x = _n3.a;
				var xs_ = _n3.b;
				var _n4 = _n0.b;
				var y = _n4.a;
				var ys_ = _n4.b;
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2(cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_n0, _n1) {
		var xs = _n0;
		var ys = _n1;
		return A2(cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2(cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2(cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _n0 = cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _n0.b;
		var _n1 = cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _n1.b;
		var _n2 = A2(cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _n2;
		var added = A2(
			elm$core$List$map,
			function (_n3) {
				var a_ = _n3.a;
				var b_ = _n3.b;
				return a_ + b_;
			},
			pairs);
		return cmditch$elm_bigint$BigInt$normalise(
			A2(cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_n0, d) {
		var xs = _n0;
		return cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				elm$core$List$map,
				elm$core$Basics$mul(d),
				xs));
	});
var cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_n0, _n1) {
		var mag1 = _n0;
		var mag2 = _n1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2(cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2(cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _n3 = A2(cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _n3;
				var bigInt = A2(
					cmditch$elm_bigint$BigInt$add,
					A2(cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2(elm$core$List$cons, 0, rest)));
				return cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				cmditch$elm_bigint$BigInt$signProduct,
				cmditch$elm_bigint$BigInt$sign(int1),
				cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				cmditch$elm_bigint$BigInt$mulMagnitudes,
				cmditch$elm_bigint$BigInt$magnitude(int1),
				cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var author$project$Decimal$mul = F2(
	function (_n0, _n1) {
		var ma = _n0.a;
		var ea = _n0.b;
		var mb = _n1.a;
		var eb = _n1.b;
		return A2(
			author$project$Decimal$Decimal,
			A2(cmditch$elm_bigint$BigInt$mul, ma, mb),
			ea + eb);
	});
var author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow = function (_n0) {
	var total_borrows = _n0.d9;
	var underlying_price = _n0.cL;
	return A2(author$project$Decimal$mul, underlying_price, total_borrows);
};
var author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply = function (_n0) {
	var total_supply = _n0.ec;
	var exchange_rate = _n0.df;
	var underlying_price = _n0.cL;
	return A2(
		author$project$Decimal$mul,
		underlying_price,
		A2(author$project$Decimal$mul, exchange_rate, total_supply));
};
var author$project$CompoundApi$Presidio$CTokens$Models$CToken = function (borrow_rate) {
	return function (cash) {
		return function (collateral_factor) {
			return function (exchange_rate) {
				return function (interest_rate_model_address) {
					return function (name) {
						return function (number_of_borrowers) {
							return function (number_of_suppliers) {
								return function (reserves) {
									return function (supply_rate) {
										return function (symbol) {
											return function (token_address) {
												return function (total_borrows) {
													return function (total_supply) {
														return function (underlying_address) {
															return function (underlying_name) {
																return function (underlying_price) {
																	return function (underlying_symbol) {
																		return function (total_supply_value_in_eth) {
																			return function (total_borrow_value_in_eth) {
																				return {c_: borrow_rate, c2: cash, c5: collateral_factor, df: exchange_rate, ds: interest_rate_model_address, dA: name, dC: number_of_borrowers, dD: number_of_suppliers, dN: reserves, d_: supply_rate, d$: symbol, d7: token_address, d8: total_borrow_value_in_eth, d9: total_borrows, ec: total_supply, ed: total_supply_value_in_eth, ee: underlying_address, ef: underlying_name, cL: underlying_price, eg: underlying_symbol};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _n0 = A2(elm$core$Basics$compare, x, 0);
	switch (_n0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return cmditch$elm_bigint$BigInt$normalise(
		A2(
			cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					elm$core$Basics$abs(x)
				])));
};
var author$project$Decimal$fromIntWithExponent = F2(
	function (n, e) {
		return A2(
			author$project$Decimal$Decimal,
			cmditch$elm_bigint$BigInt$fromInt(n),
			e);
	});
var author$project$Decimal$fromInt = function (n) {
	return A2(author$project$Decimal$fromIntWithExponent, n, 0);
};
var author$project$Decimal$zero = author$project$Decimal$fromInt(0);
var author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder = function () {
	var addEthValues = function (apiToken) {
		var supplyValue = author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply(apiToken);
		var borrowValue = author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow(apiToken);
		return elm$json$Json$Decode$succeed(
			_Utils_update(
				apiToken,
				{d8: borrowValue, ed: supplyValue}));
	};
	return A2(
		elm$json$Json$Decode$andThen,
		addEthValues,
		A2(
			author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
			elm$json$Json$Decode$succeed(author$project$Decimal$zero),
			A2(
				author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
				elm$json$Json$Decode$succeed(author$project$Decimal$zero),
				A2(
					author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
					A2(elm$json$Json$Decode$field, 'underlying_symbol', elm$json$Json$Decode$string),
					A2(
						author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
						A2(elm$json$Json$Decode$field, 'underlying_price', author$project$CompoundApi$Common$Decoders$apiPrecise),
						A2(
							author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
							A2(elm$json$Json$Decode$field, 'underlying_name', elm$json$Json$Decode$string),
							A2(
								author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
								A2(
									elm$json$Json$Decode$field,
									'underlying_address',
									elm$json$Json$Decode$maybe(elm$json$Json$Decode$string)),
								A2(
									author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
									A2(elm$json$Json$Decode$field, 'total_supply', author$project$CompoundApi$Common$Decoders$apiPrecise),
									A2(
										author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
										A2(elm$json$Json$Decode$field, 'total_borrows', author$project$CompoundApi$Common$Decoders$apiPrecise),
										A2(
											author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
											A2(elm$json$Json$Decode$field, 'token_address', elm$json$Json$Decode$string),
											A2(
												author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
												A2(elm$json$Json$Decode$field, 'symbol', elm$json$Json$Decode$string),
												A2(
													author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
													A2(elm$json$Json$Decode$field, 'supply_rate', author$project$CompoundApi$Common$Decoders$apiPrecise),
													A2(
														author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
														A2(elm$json$Json$Decode$field, 'reserves', author$project$CompoundApi$Common$Decoders$apiPrecise),
														A2(
															author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
															A2(elm$json$Json$Decode$field, 'number_of_suppliers', elm$json$Json$Decode$int),
															A2(
																author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																A2(elm$json$Json$Decode$field, 'number_of_borrowers', elm$json$Json$Decode$int),
																A2(
																	author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
																	A2(
																		author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																		A2(elm$json$Json$Decode$field, 'interest_rate_model_address', elm$json$Json$Decode$string),
																		A2(
																			author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																			A2(elm$json$Json$Decode$field, 'exchange_rate', author$project$CompoundApi$Common$Decoders$apiPrecise),
																			A2(
																				author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																				A2(elm$json$Json$Decode$field, 'collateral_factor', author$project$CompoundApi$Common$Decoders$apiPrecise),
																				A2(
																					author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																					A2(elm$json$Json$Decode$field, 'cash', author$project$CompoundApi$Common$Decoders$apiPrecise),
																					A2(
																						author$project$CompoundApi$Presidio$CTokens$Decoders$andMap,
																						A2(elm$json$Json$Decode$field, 'borrow_rate', author$project$CompoundApi$Common$Decoders$apiPrecise),
																						elm$json$Json$Decode$succeed(author$project$CompoundApi$Presidio$CTokens$Models$CToken))))))))))))))))))))));
}();
var author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest = F3(
	function (addresses, block_number, block_timestamp) {
		return {cV: addresses, cX: block_number, cY: block_timestamp};
	});
var author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse = F3(
	function (request, cToken, error) {
		return {c1: cToken, dd: error, dK: request};
	});
var author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder = A4(
	elm$json$Json$Decode$map3,
	author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse,
	A2(
		elm$json$Json$Decode$field,
		'request',
		A4(
			elm$json$Json$Decode$map3,
			author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest,
			A2(
				elm$json$Json$Decode$field,
				'addresses',
				elm$json$Json$Decode$list(elm$json$Json$Decode$string)),
			A2(
				elm$json$Json$Decode$field,
				'block_number',
				elm$json$Json$Decode$maybe(elm$json$Json$Decode$int)),
			A2(
				elm$json$Json$Decode$field,
				'block_timestamp',
				elm$json$Json$Decode$maybe(elm$json$Json$Decode$int)))),
	A2(
		elm$json$Json$Decode$field,
		'cToken',
		elm$json$Json$Decode$list(author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder)),
	A2(elm$json$Json$Decode$field, 'error', author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var elm$json$Json$Encode$int = _Json_wrap;
var author$project$CompoundApi$Presidio$CTokens$Encoders$cTokenRequestEncoder = function (request) {
	var requiredParams = _List_fromArray(
		[
			_Utils_Tuple2(
			'addresses',
			A2(elm$json$Json$Encode$list, elm$json$Json$Encode$string, request.cV))
		]);
	var blockTimestampParam = function () {
		var _n0 = request.cY;
		if (!_n0.$) {
			var block_timestamp = _n0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'block_timestamp',
					elm$json$Json$Encode$int(block_timestamp))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return elm$json$Json$Encode$object(
		_Utils_ap(requiredParams, blockTimestampParam));
};
var author$project$Network$networkName = function (network) {
	switch (network) {
		case 0:
			return 'Olympic';
		case 1:
			return 'MainNet';
		case 2:
			return 'Morden';
		case 3:
			return 'Ropsten';
		case 4:
			return 'Rinkeby';
		case 5:
			return 'Ubiq';
		case 6:
			return 'Kovan';
		case 7:
			return 'Sokol';
		case 8:
			return 'Core';
		case 9:
			return 'Development';
		default:
			return 'unknown';
	}
};
var author$project$CompoundApi$Common$Url$buildApiUrl = F3(
	function (apiBaseUrlMap, network, apiEndpoint) {
		return A2(
			elm$core$Maybe$map,
			function (apiBaseUrl) {
				return _Utils_ap(apiBaseUrl, apiEndpoint);
			},
			A2(
				elm$core$Dict$get,
				elm$core$String$toLower(
					author$project$Network$networkName(network)),
				apiBaseUrlMap));
	});
var author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl = F2(
	function (apiBaseUrlMap, network) {
		return A3(author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/ctoken');
	});
var author$project$LandingSite$Markets$AllCTokensLatestStatsResponse = function (a) {
	return {$: 0, a: a};
};
var author$project$LandingSite$Markets$AllCTokensThirtyDaysAgoStatsResponse = function (a) {
	return {$: 1, a: a};
};
var author$project$LandingSite$Markets$ForSelf = function (a) {
	return {$: 0, a: a};
};
var elm$core$Basics$round = _Basics_round;
var elm$http$Http$Internal$EmptyBody = {$: 0};
var elm$http$Http$emptyBody = elm$http$Http$Internal$EmptyBody;
var elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var elm$http$Http$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$NetworkError = {$: 2};
var elm$http$Http$Timeout = {$: 1};
var elm$http$Http$Internal$FormDataBody = function (a) {
	return {$: 2, a: a};
};
var elm$http$Http$Internal$isStringBody = function (body) {
	if (body.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var elm$http$Http$expectStringResponse = _Http_expectStringResponse;
var elm$json$Json$Decode$decodeString = _Json_runOnString;
var elm$http$Http$expectJson = function (decoder) {
	return elm$http$Http$expectStringResponse(
		function (response) {
			var _n0 = A2(elm$json$Json$Decode$decodeString, decoder, response.cZ);
			if (_n0.$ === 1) {
				var decodeError = _n0.a;
				return elm$core$Result$Err(
					elm$json$Json$Decode$errorToString(decodeError));
			} else {
				var value = _n0.a;
				return elm$core$Result$Ok(value);
			}
		});
};
var elm$http$Http$Internal$Request = elm$core$Basics$identity;
var elm$http$Http$request = elm$core$Basics$identity;
var elm$http$Http$get = F2(
	function (url, decoder) {
		return elm$http$Http$request(
			{
				cZ: elm$http$Http$emptyBody,
				a_: elm$http$Http$expectJson(decoder),
				aH: _List_Nil,
				dx: 'GET',
				bx: elm$core$Maybe$Nothing,
				ei: url,
				bz: false
			});
	});
var elm$http$Http$Internal$StringBody = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$http$Http$jsonBody = function (value) {
	return A2(
		elm$http$Http$Internal$StringBody,
		'application/json',
		A2(elm$json$Json$Encode$encode, 0, value));
};
var elm$http$Http$post = F3(
	function (url, body, decoder) {
		return elm$http$Http$request(
			{
				cZ: body,
				a_: elm$http$Http$expectJson(decoder),
				aH: _List_Nil,
				dx: 'POST',
				bx: elm$core$Maybe$Nothing,
				ei: url,
				bz: false
			});
	});
var elm$core$Task$onError = _Scheduler_onError;
var elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return elm$core$Task$command(
			A2(
				elm$core$Task$onError,
				A2(
					elm$core$Basics$composeL,
					A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
					elm$core$Result$Err),
				A2(
					elm$core$Task$andThen,
					A2(
						elm$core$Basics$composeL,
						A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
						elm$core$Result$Ok),
					task)));
	});
var elm$http$Http$toTask = function (_n0) {
	var request_ = _n0;
	return A2(_Http_toTask, request_, elm$core$Maybe$Nothing);
};
var elm$http$Http$send = F2(
	function (resultToMessage, request_) {
		return A2(
			elm$core$Task$attempt,
			resultToMessage,
			elm$http$Http$toTask(request_));
	});
var elm$time$Time$posixToMillis = function (_n0) {
	var millis = _n0;
	return millis;
};
var author$project$LandingSite$Markets$loadMarkets = F3(
	function (currentTime, apiBaseUrlMap, network) {
		var maybeCTokenUrl = A2(author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl, apiBaseUrlMap, network);
		var historyTime = function () {
			if (!currentTime.$) {
				var timeToDie = currentTime.a;
				return elm$core$Maybe$Just(
					elm$core$Basics$round(
						function (millis) {
							return millis / 1000;
						}(
							(-86400000) + elm$time$Time$posixToMillis(timeToDie))));
			} else {
				return elm$core$Maybe$Nothing;
			}
		}();
		var historyBody = elm$http$Http$jsonBody(
			author$project$CompoundApi$Presidio$CTokens$Encoders$cTokenRequestEncoder(
				{cV: _List_Nil, cX: elm$core$Maybe$Nothing, cY: historyTime}));
		var cTokensRequestCmds = function () {
			if (!maybeCTokenUrl.$) {
				var cTokenUrl = maybeCTokenUrl.a;
				var historicCTokenRequestHttpPost = A3(elm$http$Http$post, cTokenUrl, historyBody, author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				var cTokenRequestHttpPost = A2(elm$http$Http$get, cTokenUrl, author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				return _List_fromArray(
					[
						A2(
						elm$http$Http$send,
						A2(elm$core$Basics$composeL, author$project$LandingSite$Markets$ForSelf, author$project$LandingSite$Markets$AllCTokensLatestStatsResponse),
						cTokenRequestHttpPost),
						A2(
						elm$http$Http$send,
						A2(elm$core$Basics$composeL, author$project$LandingSite$Markets$ForSelf, author$project$LandingSite$Markets$AllCTokensThirtyDaysAgoStatsResponse),
						historicCTokenRequestHttpPost)
					]);
			} else {
				return _List_fromArray(
					[elm$core$Platform$Cmd$none]);
			}
		}();
		return elm$core$Platform$Cmd$batch(cTokensRequestCmds);
	});
var author$project$Utils$Http$showError = function (err) {
	switch (err.$) {
		case 0:
			var url = err.a;
			return 'BadUrl: ' + url;
		case 1:
			return 'Timeout';
		case 2:
			return 'NetworkError';
		case 3:
			var resp = err.a;
			return 'BadStatus ' + resp.cE.dv;
		default:
			var info = err.a;
			var resp = err.b;
			return 'BadPayload: ' + (info + ('; ' + resp.cE.dv));
	}
};
var author$project$LandingSite$Markets$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aJ: elm$core$Maybe$Just(cTokenResponse)
							}),
						elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						author$project$Console$error(
							'Error from CToken API, ' + author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aI: elm$core$Maybe$Just(cTokenResponse)
							}),
						elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						author$project$Console$error(
							'Error from CToken API, ' + author$project$Utils$Http$showError(errMsg)));
				}
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aG: A2(elm$core$List$cons, error, model.aG)
						}),
					author$project$Console$error(error));
		}
	});
var author$project$Main$WrappedPreferencesMsg = function (a) {
	return {$: 2, a: a};
};
var author$project$Functions$demaybeify = function (maybeMaybeVal) {
	if (!maybeMaybeVal.$) {
		var val = maybeMaybeVal.a;
		return val;
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Main$getMainNetConfig = function (model) {
	return author$project$Functions$demaybeify(
		A2(elm$core$Dict$get, 'mainnet', model.aC));
};
var author$project$LandingSite$Home$translator = F2(
	function (_n0, msg) {
		var onInternalMessage = _n0.cg;
		var internal = msg;
		return onInternalMessage(internal);
	});
var author$project$Main$LandingHomeMsg = function (a) {
	return {$: 3, a: a};
};
var author$project$Main$landingHomeTranslator = author$project$LandingSite$Home$translator(
	{cg: author$project$Main$LandingHomeMsg});
var author$project$LandingSite$Markets$translator = F2(
	function (_n0, msg) {
		var onInternalMessage = _n0.cg;
		var onWrappedPreferencesdMsg = _n0.ch;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var preferencesMsg = msg.a;
			return onWrappedPreferencesdMsg(preferencesMsg);
		}
	});
var author$project$Main$LandingMarketsMsg = function (a) {
	return {$: 5, a: a};
};
var author$project$Main$landingMarketsTranslator = author$project$LandingSite$Markets$translator(
	{cg: author$project$Main$LandingMarketsMsg, ch: author$project$Main$WrappedPreferencesMsg});
var author$project$Network$MainNet = 1;
var author$project$Preferences$askClearPreferencesPort = _Platform_outgoingPort(
	'askClearPreferencesPort',
	function ($) {
		return elm$json$Json$Encode$object(_List_Nil);
	});
var author$project$Preferences$askClearPreferences = author$project$Preferences$askClearPreferencesPort(
	{});
var author$project$Preferences$displayCurrencyToString = function (displayCurrency) {
	if (!displayCurrency) {
		return 'Ether';
	} else {
		return 'USD';
	}
};
var author$project$Preferences$storePreferencesPort = _Platform_outgoingPort(
	'storePreferencesPort',
	function ($) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'displayCurrency',
					elm$json$Json$Encode$string($.N))
				]));
	});
var author$project$Preferences$storePreferences = function (_n0) {
	var displayCurrency = _n0.N;
	return author$project$Preferences$storePreferencesPort(
		{
			N: author$project$Preferences$displayCurrencyToString(displayCurrency)
		});
};
var author$project$Preferences$preferencesUpdate = F2(
	function (msg, state) {
		switch (msg.$) {
			case 0:
				var displayCurrency = msg.a;
				var updatedState = _Utils_update(
					state,
					{N: displayCurrency});
				return _Utils_Tuple2(
					updatedState,
					author$project$Preferences$storePreferences(updatedState));
			case 1:
				var preferences = msg.a;
				return _Utils_Tuple2(preferences, elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, author$project$Preferences$askClearPreferences);
		}
	});
var author$project$Main$update = F2(
	function (msg, model) {
		var page = model.H;
		var apiBaseUrl = model.M;
		var preferences = model._;
		var maybeConfig = author$project$Main$getMainNetConfig(model);
		switch (msg.$) {
			case 0:
				var location = msg.a;
				return A2(author$project$Main$transitionPage, model, location);
			case 1:
				var time = msg.a;
				var apiBaseUrlMap = elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('mainnet', 'https://api.compound.finance/api/')
						]));
				var loadMarketsCmd = _Utils_eq(model.aD, elm$core$Maybe$Nothing) ? A2(
					elm$core$Platform$Cmd$map,
					author$project$Main$landingMarketsTranslator,
					A3(
						author$project$LandingSite$Markets$loadMarkets,
						elm$core$Maybe$Just(time),
						apiBaseUrlMap,
						1)) : elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aD: elm$core$Maybe$Just(time)
						}),
					loadMarketsCmd);
			case 2:
				var preferencesMsg = msg.a;
				var _n1 = A2(author$project$Preferences$preferencesUpdate, preferencesMsg, model._);
				var updatedPreferences = _n1.a;
				var preferencesCmd = _n1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_: updatedPreferences}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$WrappedPreferencesMsg, preferencesCmd));
			case 3:
				var landingHomeMsg = msg.a;
				var _n2 = A2(author$project$LandingSite$Home$update, landingHomeMsg, model.an);
				var updatedlandingHomeModel = _n2.a;
				var landingHomeCmd = _n2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{an: updatedlandingHomeModel}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$landingHomeTranslator, landingHomeCmd));
			case 4:
				var landingAboutMsg = msg.a;
				var _n3 = A2(author$project$LandingSite$About$update, landingAboutMsg, model.U);
				var updatedlandingAboutModel = _n3.a;
				var landingAboutCmd = _n3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U: updatedlandingAboutModel}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$landingAboutTranslator, landingAboutCmd));
			case 5:
				var landingMarketsMsg = msg.a;
				var _n4 = A2(author$project$LandingSite$Markets$update, landingMarketsMsg, model.X);
				var updatedLandingMarketsModel = _n4.a;
				var landingMarketsCmd = _n4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{X: updatedLandingMarketsModel}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$landingMarketsTranslator, landingMarketsCmd));
			case 6:
				var landingDevelopersApiMsg = msg.a;
				var _n5 = A2(author$project$LandingSite$DevelopersAPI$update, landingDevelopersApiMsg, model.V);
				var updatedLandingDevelopersApiModel = _n5.a;
				var landingDevelopersApiCmd = _n5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{V: updatedLandingDevelopersApiModel}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$landingDevelopersApiTranslator, landingDevelopersApiCmd));
			case 7:
				var landingDevelopersPresidioMsg = msg.a;
				var _n6 = A2(author$project$LandingSite$Developers$update, landingDevelopersPresidioMsg, model.W);
				var updatedLandingDevelopersPresidioModel = _n6.a;
				var landingDevelopersPresidioCmd = _n6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{W: updatedLandingDevelopersPresidioModel}),
					A2(elm$core$Platform$Cmd$map, author$project$Main$landingDevelopersPresidioTranslator, landingDevelopersPresidioCmd));
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aG: model.aG}),
					author$project$Console$log(error));
		}
	});
var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var elm$html$Html$Attributes$style = elm$virtual_dom$VirtualDom$style;
var author$project$Utils$CompoundHtmlAttributes$style = F2(
	function (styleName, styleValue) {
		return A2(elm$html$Html$Attributes$style, styleName, styleValue);
	});
var elm$html$Html$pre = _VirtualDom_node('pre');
var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
var elm$json$Json$Decode$value = _Json_decodeValue;
var author$project$LandingSite$AbiViewer$view = F3(
	function (networkName, contractName, abiFilesRaw) {
		var contractAbi = A2(
			elm$core$Result$withDefault,
			abiFilesRaw,
			A2(
				elm$json$Json$Decode$decodeValue,
				A2(
					elm$json$Json$Decode$field,
					networkName,
					A2(elm$json$Json$Decode$field, contractName, elm$json$Json$Decode$value)),
				abiFilesRaw));
		return A2(
			elm$html$Html$pre,
			_List_fromArray(
				[
					A2(author$project$Utils$CompoundHtmlAttributes$style, 'word-wrap', 'break-word')
				]),
			_List_fromArray(
				[
					elm$html$Html$text(
					A2(elm$json$Json$Encode$encode, 4, contractAbi))
				]));
	});
var author$project$Strings$Translations$about = function (lang) {
	return 'About';
};
var author$project$Strings$Translations$copyright = function (lang) {
	return '2019 Compound Labs, Inc.';
};
var author$project$Strings$Translations$developers = function (lang) {
	return 'Developers';
};
var author$project$Strings$Translations$markets = function (lang) {
	return 'Markets';
};
var author$project$Strings$Translations$whitepaper = function (lang) {
	return 'Whitepaper';
};
var author$project$Utils$CompoundHtmlAttributes$External = 2;
var author$project$Utils$CompoundHtmlAttributes$Internal = 1;
var author$project$Utils$CompoundHtmlAttributes$PageNavigation = 0;
var elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var elm$html$Html$Attributes$attribute = elm$virtual_dom$VirtualDom$attribute;
var author$project$Utils$CompoundHtmlAttributes$class = function (className) {
	return A2(elm$html$Html$Attributes$attribute, 'class', className);
};
var author$project$Utils$CompoundHtmlAttributes$href = F2(
	function (linkType, linkString) {
		var relAttributes = function () {
			switch (linkType) {
				case 1:
					return _List_fromArray(
						[
							A2(elm$html$Html$Attributes$attribute, 'rel', 'internal')
						]);
				case 2:
					return _List_fromArray(
						[
							A2(elm$html$Html$Attributes$attribute, 'rel', 'external')
						]);
				default:
					return _List_Nil;
			}
		}();
		return _Utils_ap(
			relAttributes,
			_List_fromArray(
				[
					A2(elm$html$Html$Attributes$attribute, 'href', linkString)
				]));
	});
var author$project$Utils$CompoundHtmlAttributes$target = function (targetName) {
	return A2(elm$html$Html$Attributes$attribute, 'target', targetName);
};
var elm$html$Html$a = _VirtualDom_node('a');
var elm$html$Html$div = _VirtualDom_node('div');
var elm$html$Html$footer = _VirtualDom_node('footer');
var elm$html$Html$span = _VirtualDom_node('span');
var author$project$LandingSite$CommonViews$pageFooter = function (userLanguage) {
	return A2(
		elm$html$Html$footer,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						author$project$Utils$CompoundHtmlAttributes$class('container-large')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('top')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$span,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('brand')
									]),
								_List_Nil),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('links')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Markets'),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$markets(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('mobile-hide')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/About')),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$about(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Developers'),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$developers(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/documents/Compound.Whitepaper.v04.pdf')),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$whitepaper(userLanguage))
											]))
									]))
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('bottom')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(
										author$project$Strings$Translations$copyright(userLanguage))
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('icn discord')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw')),
										_List_Nil),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('icn medium')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance')),
										_List_Nil),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('icn twitter')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://twitter.com/compoundfinance')),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var author$project$Strings$Translations$app = function (lang) {
	return 'App';
};
var author$project$Strings$Translations$faq = function (lang) {
	return 'FAQ';
};
var elm$html$Html$header = _VirtualDom_node('header');
var author$project$LandingSite$CommonViews$pageHeader = function (userLanguage) {
	return A2(
		elm$html$Html$header,
		_List_fromArray(
			[
				author$project$Utils$CompoundHtmlAttributes$class('landing')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						author$project$Utils$CompoundHtmlAttributes$class('container-large')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('col-xs-3')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										A2(
											elm$core$List$append,
											A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('brand')
												])),
										_List_Nil)
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-center')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Markets'),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$markets(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('mobile-hide')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/About')),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$about(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Developers'),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$developers(userLanguage))
											])),
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('mobile-hide'),
													author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$faq(userLanguage))
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('dapp button hollow')
												]),
											A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Strings$Translations$app(userLanguage))
											]))
									]))
							]))
					]))
			]));
};
var author$project$Strings$Translations$about_page_description = function (lang) {
	return 'The majority of cryptocurrencies sit idle on exchanges and in wallets, without yielding interest. We\'re on a mission to change that.';
};
var author$project$Strings$Translations$application_lead = function (lang) {
	return 'Application Lead';
};
var author$project$Strings$Translations$calvin_description = function (lang) {
	return 'Crypto investor; previously data analytics at Gusto, advised digital currency and FinTech startups at Promontory Financial Group';
};
var author$project$Strings$Translations$ceo = function (lang) {
	return 'CEO';
};
var author$project$Strings$Translations$coburn_description = function (lang) {
	return 'Experienced web stack engineer from The RealReal; previously an attorney';
};
var author$project$Strings$Translations$cto = function (lang) {
	return 'CTO';
};
var author$project$Strings$Translations$date_aug_2018 = function (lang) {
	return 'August 2018';
};
var author$project$Strings$Translations$date_jan_2018 = function (lang) {
	return 'January 2018';
};
var author$project$Strings$Translations$date_july_2018 = function (lang) {
	return 'July 2018';
};
var author$project$Strings$Translations$date_may_2018 = function (lang) {
	return 'May 2018';
};
var author$project$Strings$Translations$date_nov_2018 = function (lang) {
	return 'November 2018';
};
var author$project$Strings$Translations$date_oct_2018 = function (lang) {
	return 'October 2018';
};
var author$project$Strings$Translations$date_sept_2018 = function (lang) {
	return 'September 2018';
};
var author$project$Strings$Translations$emily_description = function (lang) {
	return 'Experienced recruiter and startup veteran; scaled teams of tens to hundreds at Postmates, Wikimedia, and TeleNav';
};
var author$project$Strings$Translations$general_counsel = function (lang) {
	return 'General Counsel';
};
var author$project$Strings$Translations$geoff_description = function (lang) {
	return 'Maintainer of Exthereum, technology founder of two startups, led Core Services at Postmates';
};
var author$project$Strings$Translations$head_of_design = function (lang) {
	return 'Head of Design';
};
var author$project$Strings$Translations$jake_description = function (lang) {
	return 'Lawyer, but not yours. Former litigator at Kobre Kim and Baker Mckenzie.';
};
var author$project$Strings$Translations$jared_description = function (lang) {
	return 'Diverse background in distributed systems, and feedback loops; deep experience from Nokia Research, AdRoll, Caffeine, et al';
};
var author$project$Strings$Translations$jayson_description = function (lang) {
	return 'Led product design for Coinbase Pro and Coinbase Custody; previously Otto / Uber Freight, agencies';
};
var author$project$Strings$Translations$max_description = function (lang) {
	return 'Open finance enthusiast. Former cofounder of Marble Protocol. Economics at Stanford.';
};
var author$project$Strings$Translations$open_positions = function (lang) {
	return 'Open Positions';
};
var author$project$Strings$Translations$our_team = function (lang) {
	return 'Our Team';
};
var author$project$Strings$Translations$people_lead = function (lang) {
	return 'People Lead';
};
var author$project$Strings$Translations$press_and_announcements = function (lang) {
	return 'Press & Announcements';
};
var author$project$Strings$Translations$press_coinbase_first_investment = function (lang) {
	return 'Coinbase’s first investment, Compound, earns you interest on crypto';
};
var author$project$Strings$Translations$press_compound_raises = function (lang) {
	return 'Compound Raises $8.2 Million to Create Money Markets for Crypto Assets';
};
var author$project$Strings$Translations$press_easy_way_to_short = function (lang) {
	return 'Compound launches easy way to short cryptocurrencies';
};
var author$project$Strings$Translations$press_fund_partners = function (lang) {
	return 'The Compound Ecosystem: Fund Partners';
};
var author$project$Strings$Translations$press_introducing_compound = function (lang) {
	return 'Introducing Compound, the Money Market Protocol';
};
var author$project$Strings$Translations$press_latest_threat_to_crypto_prices = function (lang) {
	return 'The Latest Threat to Crypto Prices? The Federal Reserve';
};
var author$project$Strings$Translations$press_launches_money_markets = function (lang) {
	return 'Compound Launches Money Markets for Ethereum Assets';
};
var author$project$Strings$Translations$press_lets_you_hold_and_earn = function (lang) {
	return 'Crypto Money Market Compound Lets You HODL and Earn';
};
var author$project$Strings$Translations$press_makes_it_easy = function (lang) {
	return 'Compound makes it easy to borrow and lend cryptocurrencies';
};
var author$project$Strings$Translations$press_money_markets_in_the_works = function (lang) {
	return 'Money Markets for Crypto Assets Are in the Works';
};
var author$project$Strings$Translations$press_put_your_bitcoins_in = function (lang) {
	return 'Put Your Bitcoins in the Money Market';
};
var author$project$Strings$Translations$press_this_company_enables_interest = function (lang) {
	return 'This company will enable you to earn interest on your cryptocurrency';
};
var author$project$Strings$Translations$press_tokenization = function (lang) {
	return 'Tokenization: The world of ICOs';
};
var author$project$Strings$Translations$robert_description = function (lang) {
	return 'Chartered Financial Analyst, former economist, and founder of two software startups';
};
var author$project$Strings$Translations$senior_engineer = function (lang) {
	return 'Senior Engineer';
};
var author$project$Strings$Translations$software_engineer = function (lang) {
	return 'Software Engineer';
};
var author$project$Strings$Translations$strategy_lead = function (lang) {
	return 'Strategy Lead';
};
var author$project$Strings$Translations$torrey_description = function (lang) {
	return 'Led mobile development at Postmates, Kahuna, and Aha Mobile';
};
var author$project$Strings$Translations$we_are_compound = function (lang) {
	return 'We\'re Compound';
};
var author$project$Utils$CompoundHtmlAttributes$id = function (idName) {
	return A2(elm$html$Html$Attributes$attribute, 'id', idName);
};
var author$project$Utils$CompoundHtmlAttributes$src = function (srcName) {
	return A2(elm$html$Html$Attributes$attribute, 'src', srcName);
};
var elm$html$Html$h1 = _VirtualDom_node('h1');
var elm$html$Html$h2 = _VirtualDom_node('h2');
var elm$html$Html$h4 = _VirtualDom_node('h4');
var elm$html$Html$img = _VirtualDom_node('img');
var elm$html$Html$li = _VirtualDom_node('li');
var elm$html$Html$p = _VirtualDom_node('p');
var elm$html$Html$section = _VirtualDom_node('section');
var elm$html$Html$ul = _VirtualDom_node('ul');
var author$project$LandingSite$About$view = F2(
	function (userLanguage, model) {
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('landing-overview'),
							author$project$Utils$CompoundHtmlAttributes$class('bg-dark')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('mars-city')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-right-1')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-right-2')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-left-1')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-left-2')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('monorail-track')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('car')
										]),
									_List_Nil)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('sand')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('monorail')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('container-small text-center')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$we_are_compound(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('text-large')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$about_page_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('jobs')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text(
											author$project$Strings$Translations$open_positions(userLanguage))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('hire-jobs')
										]),
									_List_Nil)
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('team')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$h2,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('text-center')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											author$project$Strings$Translations$our_team(userLanguage))
										])),
									A2(
									elm$html$Html$ul,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('text-center')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_robert.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Robert Leshner')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$ceo(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$robert_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_geoff.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Geoffrey Hayes')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$cto(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$geoff_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_torrey.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Torrey Atcitty')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$application_lead(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$torrey_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_calvin.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Calvin Liu')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$strategy_lead(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$calvin_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_emily.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Emily Blanchard')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$people_lead(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$emily_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_coburn.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Coburn Berry')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$software_engineer(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$coburn_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_jared.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Jared Flatow')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$senior_engineer(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$jared_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_jayson.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Jayson Hobby')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$head_of_design(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$jayson_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_jake.jpeg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Jake Chervinsky')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$general_counsel(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$jake_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$li,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('team')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$img,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$src('images/team_max.jpg')
														]),
													_List_Nil),
													A2(
													elm$html$Html$h4,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('name')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('Max Wolff')
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('title')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$software_engineer(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('description')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$max_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('press')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row align-center')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('text-center')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$press_and_announcements(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'http://fortune.com/2018/11/03/crypto-interest-rates/'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_fortune.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Fortune')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_latest_threat_to_crypto_prices(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_nov_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.marketwatch.com/story/this-company-will-enable-you-to-earn-interest-on-your-cryptocurrency-2018-10-02'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_marketwatch.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('MarketWatch')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_this_company_enables_interest(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_oct_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://techcrunch.com/2018/09/27/short-ethereum-zrx-bat-rep/'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_tc.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Techcrunch')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_easy_way_to_short(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_sept_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.coindesk.com/crypto-money-market-compound-lets-you-hodl-and-earn-interest/'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_coindesk.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Coindesk')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_lets_you_hold_and_earn(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_sept_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://cheddar.com/videos/compound-launches-money-markets-for-ethereum-assets'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_cheddar.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('cheddar')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_launches_money_markets(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_sept_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/compound-launches-money-markets-for-ethereum-assets-f50920f04488'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_medium.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Compound')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_launches_money_markets(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_sept_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://thenextweb.com/hardfork/2018/08/10/compound-makes-it-easy-to-borrow-and-lend-cryptocurrencies/'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_tnw.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('TNW')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_makes_it_easy(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_aug_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/the-compound-ecosystem-fund-partners-43ec431e4d69'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_medium.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Compound')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_fund_partners(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_aug_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.cnbc.com/2018/07/13/initial-coin-offering-ico-what-are-they-how-do-they-work.html'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_cnbc.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('CNBC')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_tokenization(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_july_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.bloomberg.com/view/articles/2018-05-17/put-your-bitcoins-in-the-money-market'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_bloomberg.jpeg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Bloomberg')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_put_your_bitcoins_in(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://techcrunch.com/2018/05/16/cryptocurrency-compound-interest/'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_tc.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Techcrunch')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_coinbase_first_investment(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.wsj.com/articles/money-markets-for-crypto-assets-are-in-the-works-1526470201'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_wsj.jpg')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Wall Street Journal')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_money_markets_in_the_works(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/compound-raises-8-2-million-to-create-money-markets-for-crypto-assets-6dfa593f8e5e'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_medium.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Compound')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_compound_raises(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/introducing-compound-the-money-market-protocol-4b9546bac87'),
													_List_fromArray(
														[
															A2(
															elm$html$Html$div,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-2')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$img,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$src('/images/press_medium.png')
																				]),
																			_List_Nil)
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-7')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('publisher')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('Compound')
																				])),
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('title')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Strings$Translations$press_introducing_compound(userLanguage))
																				]))
																		])),
																	A2(
																	elm$html$Html$div,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$date_jan_2018(userLanguage))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var author$project$Eth$Ethereum$getContractAddressString = function (contractAddress) {
	var addressString = contractAddress;
	return addressString;
};
var author$project$Utils$CompoundHtmlAttributes$property = F2(
	function (propertyName, propertyValue) {
		return A2(elm$html$Html$Attributes$attribute, propertyName, propertyValue);
	});
var elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _n0 = f(mx);
		if (!_n0.$) {
			var x = _n0.a;
			return A2(elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var elm$core$List$sortWith = _List_sortWith;
var elm$html$Html$table = _VirtualDom_node('table');
var elm$html$Html$tbody = _VirtualDom_node('tbody');
var elm$html$Html$td = _VirtualDom_node('td');
var elm$html$Html$th = _VirtualDom_node('th');
var elm$html$Html$thead = _VirtualDom_node('thead');
var elm$html$Html$tr = _VirtualDom_node('tr');
var author$project$LandingSite$Developers$contractsView = function (configs) {
	var networkSortOrder = elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('mainnet', 1),
				_Utils_Tuple2('rinkeby', 2),
				_Utils_Tuple2('kovan', 3),
				_Utils_Tuple2('ropsten', 4)
			]));
	var networkFriendlyNames = elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('mainnet', 'MainNet'),
				_Utils_Tuple2('rinkeby', 'Rinkeby'),
				_Utils_Tuple2('kovan', 'Kovan'),
				_Utils_Tuple2('ropsten', 'Ropsten')
			]));
	var configsSorter = F2(
		function (a, b) {
			var bValue = A2(
				elm$core$Maybe$withDefault,
				999,
				A2(elm$core$Dict$get, b.a, networkSortOrder));
			var aValue = A2(
				elm$core$Maybe$withDefault,
				999,
				A2(elm$core$Dict$get, a.a, networkSortOrder));
			return A2(elm$core$Basics$compare, aValue, bValue);
		});
	return A2(
		elm$core$List$filterMap,
		function (_n0) {
			var networkName = _n0.a;
			var maybeNetworkConfig = _n0.b;
			if (!maybeNetworkConfig.$) {
				var networkConfig = maybeNetworkConfig.a;
				var friendlyNetworkName = A2(
					elm$core$Maybe$withDefault,
					networkName,
					A2(elm$core$Dict$get, networkName, networkFriendlyNames));
				return elm$core$Maybe$Just(
					A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('tab'),
								A2(author$project$Utils$CompoundHtmlAttributes$property, 'data-network', networkName)
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(friendlyNetworkName)
									])),
								A2(
								elm$html$Html$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Contract')
															])),
														A2(
														elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('ABI')
															])),
														A2(
														elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Address')
															]))
													]))
											])),
										A2(
										elm$html$Html$tbody,
										_List_Nil,
										_Utils_ap(
											_List_Nil,
											_Utils_ap(
												A2(
													elm$core$List$map,
													function (_n2) {
														var cTokenSymbol = _n2.a;
														var cTokenConfig = _n2.b;
														var contractType = (cTokenSymbol === 'cETH') ? 'CEther' : 'CErc20';
														return A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('contract ' + contractType)
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(cTokenSymbol)
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('ABI')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$a,
																			A2(
																				author$project$Utils$CompoundHtmlAttributes$href,
																				0,
																				author$project$LandingSite$Page$getHrefUrl(
																					A2(author$project$LandingSite$Page$DevelopersABIView, networkName, cTokenSymbol))),
																			_List_fromArray(
																				[
																					elm$html$Html$text('JSON')
																				]))
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$id(cTokenSymbol + '_contract_address'),
																					author$project$Utils$CompoundHtmlAttributes$class('amount')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(
																					author$project$Eth$Ethereum$getContractAddressString(cTokenConfig.o))
																				]))
																		]))
																]));
													},
													elm$core$Dict$toList(networkConfig.bH)),
												_Utils_ap(
													A2(
														elm$core$List$filterMap,
														function (_n3) {
															var contractName = _n3.a;
															var contractAddress = _n3.b;
															switch (contractName) {
																case 'Unitroller':
																	return elm$core$Maybe$Just(
																		A2(
																			elm$html$Html$tr,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					elm$html$Html$td,
																					_List_fromArray(
																						[
																							author$project$Utils$CompoundHtmlAttributes$class('contract')
																						]),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Comptroller')
																						])),
																					A2(
																					elm$html$Html$td,
																					_List_fromArray(
																						[
																							author$project$Utils$CompoundHtmlAttributes$class('ABI')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							elm$html$Html$a,
																							A2(
																								author$project$Utils$CompoundHtmlAttributes$href,
																								0,
																								author$project$LandingSite$Page$getHrefUrl(
																									A2(author$project$LandingSite$Page$DevelopersABIView, networkName, 'Unitroller'))),
																							_List_fromArray(
																								[
																									elm$html$Html$text('JSON')
																								]))
																						])),
																					A2(
																					elm$html$Html$td,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							elm$html$Html$div,
																							_List_fromArray(
																								[
																									author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																									author$project$Utils$CompoundHtmlAttributes$class('amount')
																								]),
																							_List_fromArray(
																								[
																									elm$html$Html$text(
																									author$project$Eth$Ethereum$getContractAddressString(contractAddress))
																								]))
																						]))
																				])));
																case 'PriceOracle':
																	return elm$core$Maybe$Just(
																		A2(
																			elm$html$Html$tr,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					elm$html$Html$td,
																					_List_fromArray(
																						[
																							author$project$Utils$CompoundHtmlAttributes$class('contract')
																						]),
																					_List_fromArray(
																						[
																							elm$html$Html$text('PriceOracle')
																						])),
																					A2(
																					elm$html$Html$td,
																					_List_fromArray(
																						[
																							author$project$Utils$CompoundHtmlAttributes$class('ABI')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							elm$html$Html$a,
																							A2(
																								author$project$Utils$CompoundHtmlAttributes$href,
																								0,
																								author$project$LandingSite$Page$getHrefUrl(
																									A2(author$project$LandingSite$Page$DevelopersABIView, networkName, 'PriceOracle'))),
																							_List_fromArray(
																								[
																									elm$html$Html$text('JSON')
																								]))
																						])),
																					A2(
																					elm$html$Html$td,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							elm$html$Html$div,
																							_List_fromArray(
																								[
																									author$project$Utils$CompoundHtmlAttributes$id('price_oracle_contract_address'),
																									author$project$Utils$CompoundHtmlAttributes$class('amount')
																								]),
																							_List_fromArray(
																								[
																									elm$html$Html$text(
																									author$project$Eth$Ethereum$getContractAddressString(contractAddress))
																								]))
																						]))
																				])));
																default:
																	return elm$core$Maybe$Nothing;
															}
														},
														elm$core$Dict$toList(networkConfig.bM)),
													A2(
														elm$core$List$map,
														function (_n5) {
															var modelRealName = _n5.a;
															var modelConfig = _n5.b;
															return A2(
																elm$html$Html$tr,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		elm$html$Html$td,
																		_List_fromArray(
																			[
																				author$project$Utils$CompoundHtmlAttributes$class('contract')
																			]),
																		_List_fromArray(
																			[
																				elm$html$Html$text(modelConfig.c8)
																			])),
																		A2(
																		elm$html$Html$td,
																		_List_fromArray(
																			[
																				author$project$Utils$CompoundHtmlAttributes$class('ABI')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				elm$html$Html$a,
																				A2(
																					author$project$Utils$CompoundHtmlAttributes$href,
																					0,
																					author$project$LandingSite$Page$getHrefUrl(
																						A2(author$project$LandingSite$Page$DevelopersABIView, networkName, modelRealName))),
																				_List_fromArray(
																					[
																						elm$html$Html$text('JSON')
																					]))
																			])),
																		A2(
																		elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				elm$html$Html$div,
																				_List_fromArray(
																					[
																						author$project$Utils$CompoundHtmlAttributes$id(modelRealName + '_contract_address'),
																						author$project$Utils$CompoundHtmlAttributes$class('amount')
																					]),
																				_List_fromArray(
																					[
																						elm$html$Html$text(
																						author$project$Eth$Ethereum$getContractAddressString(modelConfig.o))
																					]))
																			]))
																	]));
														},
														elm$core$Dict$toList(networkConfig.dr))))))
									]))
							])));
			} else {
				return elm$core$Maybe$Nothing;
			}
		},
		A2(
			elm$core$List$sortWith,
			configsSorter,
			elm$core$Dict$toList(configs)));
};
var author$project$Strings$Translations$appendix = function (lang) {
	return 'Appendix';
};
var author$project$Strings$Translations$borrow = function (lang) {
	return 'Borrow';
};
var author$project$Strings$Translations$borrow_balance = function (lang) {
	return 'Borrow Balance';
};
var author$project$Strings$Translations$borrow_rate = function (lang) {
	return 'Borrow Rate';
};
var author$project$Strings$Translations$cether = function (lang) {
	return 'CEther';
};
var author$project$Strings$Translations$collateral = function (lang) {
	return 'Collateral';
};
var author$project$Strings$Translations$compound_presidio = function (lang) {
	return 'Compound Presidio';
};
var author$project$Strings$Translations$comptroller = function (lang) {
	return 'Comptroller';
};
var author$project$Strings$Translations$ctoken_helpers = function (lang) {
	return 'cToken Helpers';
};
var author$project$Strings$Translations$ctokens = function (lang) {
	return 'cTokens';
};
var author$project$Strings$Translations$docs_account_liquidity_account_description = function (lang) {
	return 'The account whose liquidity shall be calculated.';
};
var author$project$Strings$Translations$docs_account_liquidity_description2 = function (lang) {
	return 'Users who do not have positive account liquidity do not have the ability to withdraw or borrow any assets until they bring their account liquidity back positive by supplying more assets or paying back outstanding borrows.';
};
var author$project$Strings$Translations$docs_account_liquidity_description3 = function (lang) {
	return 'Sometimes account liquidity refers to a single signed value, rather than two unsigned values - however the Compound Protocol only deals with unsigned integers. A negative value for account liquidity also means the user is subject to liquidation to bring their account liquidity back to zero.';
};
var author$project$Strings$Translations$docs_account_liquidity_description_part1 = function (lang) {
	return 'Within the Compound Protocol, account liquidity is defined as the total estimated ether value of an account\'s collateral (supply balances multiplied by the protocol ';
};
var author$project$Strings$Translations$docs_account_liquidity_description_part2 = function (lang) {
	return 'collateral factor';
};
var author$project$Strings$Translations$docs_account_liquidity_description_part3 = function (lang) {
	return ', minus the total value of that account\'s borrow balances. These values are calculated using only the markets which the account has ';
};
var author$project$Strings$Translations$docs_account_liquidity_description_part4 = function (lang) {
	return 'entered';
};
var author$project$Strings$Translations$docs_account_liquidity_description_part5 = function (lang) {
	return ' into.';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description1 = function (lang) {
	return 'Tuple of values (error, liquidity, shortfall). The error shall be 0 on success, otherwise an ';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description2 = function (lang) {
	return 'error code';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description3 = function (lang) {
	return '. A non-zero liquidity value indicates the account has available ';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description4 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description5 = function (lang) {
	return '. A non-zero shortfall value indicates the account is currently below his/her ';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description6 = function (lang) {
	return 'collateral requirement';
};
var author$project$Strings$Translations$docs_account_liquidity_return_description7 = function (lang) {
	return ' and is subject to liquidation. At most one of liquidity or shortfall shall be non-zero.';
};
var author$project$Strings$Translations$docs_appendix_description_part1 = function (lang) {
	return 'Supplementary discussion of some considerations for using the protocol. If you have other questions which are not answered here, please feel free to reach out for ';
};
var author$project$Strings$Translations$docs_appendix_description_part2 = function (lang) {
	return 'support';
};
var author$project$Strings$Translations$docs_assets_in_account_description = function (lang) {
	return 'The account whose list of entered markets shall be queried.';
};
var author$project$Strings$Translations$docs_assets_in_description_part1 = function (lang) {
	return 'Get the list of markets an account is currently entered into. In order to supply collateral or borrow in a market, it must be entered first. Entered markets count towards ';
};
var author$project$Strings$Translations$docs_assets_in_description_part2 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_assets_in_description_part3 = function (lang) {
	return ' calculations.';
};
var author$project$Strings$Translations$docs_assets_in_return_description = function (lang) {
	return 'The address of each market which is currently entered into.';
};
var author$project$Strings$Translations$docs_borrow_balance_account_description = function (lang) {
	return 'The account which borrowed the assets.';
};
var author$project$Strings$Translations$docs_borrow_balance_description_part1 = function (lang) {
	return 'A user who borrows assets from the protocol is subject to accumulated interest based on the current ';
};
var author$project$Strings$Translations$docs_borrow_balance_description_part2 = function (lang) {
	return 'borrow rate';
};
var author$project$Strings$Translations$docs_borrow_balance_description_part3 = function (lang) {
	return '. Interest is accumulated every block and integrations may use this function to obtain the current value of a user\'s borrow balance with interest.';
};
var author$project$Strings$Translations$docs_borrow_balance_return_description = function (lang) {
	return 'The user\'s current borrow balance (with interest) in units of the underlying asset.';
};
var author$project$Strings$Translations$docs_borrow_borrow_amount_description = function (lang) {
	return 'The amount of the underlying asset to be borrowed.';
};
var author$project$Strings$Translations$docs_borrow_description1_part1 = function (lang) {
	return 'The borrow function transfers an asset from the money market to the user, and creates a borrow balance which begins accumulating interest based on the ';
};
var author$project$Strings$Translations$docs_borrow_description1_part2 = function (lang) {
	return 'borrow rate';
};
var author$project$Strings$Translations$docs_borrow_description1_part3 = function (lang) {
	return ' for the asset.';
};
var author$project$Strings$Translations$docs_borrow_description2_part1 = function (lang) {
	return 'The amount borrowed must be less than the user\'s ';
};
var author$project$Strings$Translations$docs_borrow_description2_part2 = function (lang) {
	return 'borrow capacity';
};
var author$project$Strings$Translations$docs_borrow_description2_part3 = function (lang) {
	return ' and the market\'s available liquidity. Users must maintain a ';
};
var author$project$Strings$Translations$docs_borrow_description2_part4 = function (lang) {
	return 'collateral requirement';
};
var author$project$Strings$Translations$docs_borrow_description2_part5 = function (lang) {
	return ' to avoid liquidation.';
};
var author$project$Strings$Translations$docs_borrow_description3 = function (lang) {
	return 'Note that the borrower will receive a transfer of the underlying asset. For CEther, this will be ether and thus the borrower must be payable (for Solidity).';
};
var author$project$Strings$Translations$docs_borrow_msg_value_description = function (lang) {
	return 'The account to which borrowed funds shall be transferred.';
};
var author$project$Strings$Translations$docs_borrow_rate_description = function (lang) {
	return 'At any point in time one may query the contract to get the current borrow rate per block.';
};
var author$project$Strings$Translations$docs_borrow_rate_return_description = function (lang) {
	return 'The current borrow rate as an unsigned integer, scaled by 1e18.';
};
var author$project$Strings$Translations$docs_borrow_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_cash_description = function (lang) {
	return 'Cash is the amount of underlying balance owned by this cToken contract. One may query the total amount of cash currently available to this market.';
};
var author$project$Strings$Translations$docs_cash_return_description = function (lang) {
	return 'The quantity of underlying asset owned by the contract.';
};
var author$project$Strings$Translations$docs_cerc20 = function (lang) {
	return 'CErc20';
};
var author$project$Strings$Translations$docs_collateral_description1 = function (lang) {
	return 'In order to borrow from the protocol, accounts must provide enough collateral. One of the greatest motivating factors for Compound v2: Presidio was the ability to set different collateral requirements, depending on the asset being borrowed. With Presidio, the protocol no longer has a global collateral requirement and instead opens it up to individual asset communities to determine what is sufficient collateral in order to borrow their asset.';
};
var author$project$Strings$Translations$docs_collateral_description2 = function (lang) {
	return 'More details about how this works now and how it will evolve will be coming in the next few weeks as we prepare for mainnet launch.';
};
var author$project$Strings$Translations$docs_compound_api_docs = function (lang) {
	return 'Compound API docs';
};
var author$project$Strings$Translations$docs_comptroller_description1 = function (lang) {
	return 'The comptroller contract manages the risk associated with the Compound Protocol v2. It is responsible for determining when account\'s are underwater and can be liquidated. It determines how much collateral can be seized in exchange for liquidating an underwater account. It also provides a defense mechanism to protect the protocol against unforeseen future attacks on the market.';
};
var author$project$Strings$Translations$docs_comptroller_description2_part1 = function (lang) {
	return 'In order to borrow from a market, users are required to supply collateral in some other market(s). Collateral protects the borrowed market, by incentivizing the borrower and/or a liquidator to repay debt. In v1, all markets had the same ';
};
var author$project$Strings$Translations$docs_comptroller_description2_part2 = function (lang) {
	return 'collateral factor';
};
var author$project$Strings$Translations$docs_comptroller_description2_part3 = function (lang) {
	return '. In addition, any market an account supplied to automatically became collateral for any borrows opened by that account.';
};
var author$project$Strings$Translations$docs_comptroller_description3_part1 = function (lang) {
	return 'In v2, we open the door for each market to determine what is sufficient collateral for a borrow of its asset. We also require that users explicitly enter the markets which they wish to either use as collateral or borrow from. This cuts down on the cost of supporting a large number of markets, while giving users the choice to not use all of their assets as collateral. The cost is a small bit of management overhead for users wishing to borrow, since they must now ';
};
var author$project$Strings$Translations$docs_comptroller_description3_part2 = function (lang) {
	return 'enter';
};
var author$project$Strings$Translations$docs_comptroller_description3_part3 = function (lang) {
	return ' and ';
};
var author$project$Strings$Translations$docs_comptroller_description3_part4 = function (lang) {
	return 'exit';
};
var author$project$Strings$Translations$docs_comptroller_description3_part5 = function (lang) {
	return ' markets.';
};
var author$project$Strings$Translations$docs_ctoken_helpers_description = function (lang) {
	return 'In addition to the core market functions, the cToken contracts implement a number of helper functions to aid developers in building on top of the protocol.';
};
var author$project$Strings$Translations$docs_ctokens_description1_part1 = function (lang) {
	return 'Every asset supported by the Compound Protocol is now integrated through a cToken smart contract, which is an ';
};
var author$project$Strings$Translations$docs_ctokens_description1_part2 = function (lang) {
	return 'EIP-20';
};
var author$project$Strings$Translations$docs_ctokens_description1_part3 = function (lang) {
	return ' compliant representation of balances supplied to the protocol. Users supply to the protocol by minting tokens (cTokens), which strictly increase in value relative to their underlying asset.';
};
var author$project$Strings$Translations$docs_ctokens_description2 = function (lang) {
	return 'cTokens are the primary way of interacting with the Compound Protocol. Each cToken contract creates its own money market. When a user mints, redeems, borrows, repays a borrow, liquidates a borrow, or transfers cTokens, she will do so using the cToken contract.';
};
var author$project$Strings$Translations$docs_ctokens_description3 = function (lang) {
	return 'There are currently two types of cTokens: CErc20 and CEther. Though both types expose the EIP-20 interface, CErc20 wraps an underlying ERC-20 asset, while CEther simply wraps Ether itself. As such, the core functions which involve transferring an asset into the protocol have slightly different interfaces depending on the type, each of which is shown below.';
};
var author$project$Strings$Translations$docs_enter_markets_ctokens_description = function (lang) {
	return 'The addresses of the cToken markets to enter.';
};
var author$project$Strings$Translations$docs_enter_markets_description1 = function (lang) {
	return 'Enter into a list of markets - it is not an error to enter the same market more than once. In order to supply collateral or borrow in a market, it must be entered first.';
};
var author$project$Strings$Translations$docs_enter_markets_msg_sender_description = function (lang) {
	return 'The account which shall enter the given markets.';
};
var author$project$Strings$Translations$docs_enter_markets_return_description = F2(
	function (lang, str0) {
		return 'For each market, returns an error code indicating whether or not it was entered. Each is 0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_exchange_rate_description = function (lang) {
	return 'Each cToken is convertible into an ever increasing quantity of the underlying asset, as interest accrues in the market. The exchange rate between a cToken and the underlying asset is equal to:';
};
var author$project$Strings$Translations$docs_exchange_rate_return_description = function (lang) {
	return 'The current exchange rate as an unsigned integer, scaled by 1e18.';
};
var author$project$Strings$Translations$docs_exit_market_ctoken_description = function (lang) {
	return 'The addresses of the cToken market to exit.';
};
var author$project$Strings$Translations$docs_exit_market_description = function (lang) {
	return 'Exit a market - it is not an error to exit a market which is not currently entered. Exited markets will not count towards account liquidity calculations.';
};
var author$project$Strings$Translations$docs_exit_market_msg_sender_description = function (lang) {
	return 'The account which shall exit the given market.';
};
var author$project$Strings$Translations$docs_exit_market_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_exponential_math_description = F2(
	function (lang, str0) {
		return 'The Compound smart contracts use a system of exponential math in order to represent fractional quantities with sufficient precision. Throughout the documentation and code we make reference to mantissas, which are unsigned integers scaled up by a factor of 1e18 from their nominal value. By using mantissas within our contracts, we may perform basic mathematical operations like multiplication and division at a higher resolution than working with the unscaled quantities directly as integers. To gain a better understanding of how this works, see ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_for_more_information = function (lang) {
	return 'For information on the Compound API, please visit the ';
};
var author$project$Strings$Translations$docs_gas_costs_description_part1 = function (lang) {
	return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
};
var author$project$Strings$Translations$docs_gas_costs_description_part2 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_gas_costs_description_part3 = function (lang) {
	return ', have gas costs that increase with the number of ';
};
var author$project$Strings$Translations$docs_gas_costs_description_part4 = function (lang) {
	return 'entered markets';
};
var author$project$Strings$Translations$docs_gas_costs_description_part5 = function (lang) {
	return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
};
var author$project$Strings$Translations$docs_liquidate_borrower_description1 = function (lang) {
	return 'The account with negative ';
};
var author$project$Strings$Translations$docs_liquidate_borrower_description2 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_liquidate_borrower_description3 = function (lang) {
	return ' that shall be liquidated.';
};
var author$project$Strings$Translations$docs_liquidate_ctoken_collateral_description = function (lang) {
	return 'The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.';
};
var author$project$Strings$Translations$docs_liquidate_description1_part1 = function (lang) {
	return 'A user who has negative ';
};
var author$project$Strings$Translations$docs_liquidate_description1_part2 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_liquidate_description1_part3 = function (lang) {
	return ' is subject to ';
};
var author$project$Strings$Translations$docs_liquidate_description1_part4 = function (lang) {
	return 'liquidation';
};
var author$project$Strings$Translations$docs_liquidate_description1_part5 = function (lang) {
	return ' by other users of the protocol to return his/her account liquidity back to positive (i.e. above the ';
};
var author$project$Strings$Translations$docs_liquidate_description1_part6 = function (lang) {
	return 'collateral requirement';
};
var author$project$Strings$Translations$docs_liquidate_description1_part7 = function (lang) {
	return '). When a liquidation occurs, a liquidator may repay some or all of an outstanding borrow on behalf of a borrower and in return receive a discounted amount of collateral held by the borrower; this discount is defined as the ';
};
var author$project$Strings$Translations$docs_liquidate_description1_part8 = function (lang) {
	return 'liquidation incentive';
};
var author$project$Strings$Translations$docs_liquidate_description2_part1 = function (lang) {
	return 'A liquidator may close up to a certain fixed percentage (i.e. ';
};
var author$project$Strings$Translations$docs_liquidate_description2_part2 = function (lang) {
	return 'close factor';
};
var author$project$Strings$Translations$docs_liquidate_description2_part3 = function (lang) {
	return ') of any individual outstanding borrow of the underwater account. Unlike in v1, liquidators must interact with each cToken contract in which they wish to repay a borrow and seize another asset as collateral. When collateral is seized, the liquidator is transferred cTokens, which they may redeem the same as if they had supplied the asset themselves. Users must approve each cToken contract before calling liquidate (i.e. on the borrowed asset which they are repaying), as they are transferring funds into the contract.';
};
var author$project$Strings$Translations$docs_liquidate_description3_part1 = function (lang) {
	return 'Before supplying an asset, users must first ';
};
var author$project$Strings$Translations$docs_liquidate_description3_part2 = function (lang) {
	return 'approve';
};
var author$project$Strings$Translations$docs_liquidate_description3_part3 = function (lang) {
	return ' the cToken to access their token balance.';
};
var author$project$Strings$Translations$docs_liquidate_msg_sender_description = function (lang) {
	return 'The account which shall liquidate the borrower by repaying their debt and seizing their collateral.';
};
var author$project$Strings$Translations$docs_liquidate_payable_borrower_description1 = function (lang) {
	return 'The account with negative ';
};
var author$project$Strings$Translations$docs_liquidate_payable_borrower_description2 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_liquidate_payable_borrower_description3 = function (lang) {
	return ' that shall be liquidated.';
};
var author$project$Strings$Translations$docs_liquidate_payable_ctoken_collateral_description = function (lang) {
	return 'The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.';
};
var author$project$Strings$Translations$docs_liquidate_payable_msg_sender_description = function (lang) {
	return 'The account which shall liquidate the borrower by repaying their debt and seizing their collateral.';
};
var author$project$Strings$Translations$docs_liquidate_payable_msg_value_description = function (lang) {
	return 'The amount of ether to be repaid and converted into collateral, in wei.';
};
var author$project$Strings$Translations$docs_liquidate_payable_return_description = function (lang) {
	return 'No return, reverts on error.';
};
var author$project$Strings$Translations$docs_liquidate_repay_amount_description = function (lang) {
	return 'The amount of the borrowed asset to be repaid and converted into collateral, specified in units of the underlying borrowed asset.';
};
var author$project$Strings$Translations$docs_liquidate_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_mint_description1_part1 = function (lang) {
	return 'The mint function transfers an asset into the money market, which begins accumulating interest based on the current ';
};
var author$project$Strings$Translations$docs_mint_description1_part2 = function (lang) {
	return 'supply rate';
};
var author$project$Strings$Translations$docs_mint_description1_part3 = function (lang) {
	return ' for the asset. The number of tokens minted is the amount of underlying asset being provided divided by the current ';
};
var author$project$Strings$Translations$docs_mint_description1_part4 = function (lang) {
	return 'exchange rate';
};
var author$project$Strings$Translations$docs_mint_description2 = function (lang) {
	return 'Mint is analagous to supply from the Compound v1 Protocol.';
};
var author$project$Strings$Translations$docs_mint_mint_amount_description = function (lang) {
	return 'The amount of the asset to be supplied, in units of the underlying asset.';
};
var author$project$Strings$Translations$docs_mint_msg_sender_description = function (lang) {
	return 'The account which shall supply the asset, and own the minted cTokens.';
};
var author$project$Strings$Translations$docs_mint_payable_msg_sender_description = function (lang) {
	return 'The account which shall supply the ether, and own the minted cTokens.';
};
var author$project$Strings$Translations$docs_mint_payable_msg_value_description = function (lang) {
	return 'The amount of ether to be supplied, in wei.';
};
var author$project$Strings$Translations$docs_mint_payable_return_description = function (lang) {
	return 'No return, reverts on error.';
};
var author$project$Strings$Translations$docs_mint_prereq_description_part1 = function (lang) {
	return 'Before supplying an asset, users must first ';
};
var author$project$Strings$Translations$docs_mint_prereq_description_part2 = function (lang) {
	return 'approve';
};
var author$project$Strings$Translations$docs_mint_prereq_description_part3 = function (lang) {
	return ' the cToken to access their token balance.';
};
var author$project$Strings$Translations$docs_mint_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_presidio_description = function (lang) {
	return 'Compound v2 (a.k.a. Presidio) is a set of smart contracts deployed on the Ethereum blockchain, which allows supplying and borrowing of ERC-20 tokens. This page details the on-chain function \'ABI\' for developing smart contracts or building Web3-enabled dApps.';
};
var author$project$Strings$Translations$docs_redeem_description1_part1 = function (lang) {
	return 'The redeem function transfers the underlying asset from the money market to the user in exchange for previously minted cTokens. The amount of underlying redeemed is the number of cTokens multiplied by the current ';
};
var author$project$Strings$Translations$docs_redeem_description1_part2 = function (lang) {
	return 'Exchange Rate';
};
var author$project$Strings$Translations$docs_redeem_description1_part3 = function (lang) {
	return '. The amount redeemed must be less than the user\'s ';
};
var author$project$Strings$Translations$docs_redeem_description1_part4 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_redeem_description1_part5 = function (lang) {
	return ' and the market\'s available liquidity.';
};
var author$project$Strings$Translations$docs_redeem_description2 = function (lang) {
	return 'Redeem is analagous to withdraw from the Compound v1 Protocol.';
};
var author$project$Strings$Translations$docs_redeem_msg_sender_description = function (lang) {
	return 'The account to which redeemed funds shall be transferred.';
};
var author$project$Strings$Translations$docs_redeem_redeem_tokens_description = function (lang) {
	return 'The number of cTokens to be redeemed.';
};
var author$project$Strings$Translations$docs_redeem_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_redeem_underlying_description1_part1 = function (lang) {
	return 'The redeem underlying function transfers the underlying asset from the money market to the user in exchange for previously minted cTokens. The number of cTokens redeemed is the amount of underlying divided by the current ';
};
var author$project$Strings$Translations$docs_redeem_underlying_description1_part2 = function (lang) {
	return 'Exchange Rate';
};
var author$project$Strings$Translations$docs_redeem_underlying_description1_part3 = function (lang) {
	return '. The amount redeemed must be less than the user\'s ';
};
var author$project$Strings$Translations$docs_redeem_underlying_description1_part4 = function (lang) {
	return 'account liquidity';
};
var author$project$Strings$Translations$docs_redeem_underlying_description1_part5 = function (lang) {
	return ' and the market\'s available liquidity.';
};
var author$project$Strings$Translations$docs_redeem_underlying_msg_sender_description = function (lang) {
	return 'The account to which redeemed funds shall be transferred.';
};
var author$project$Strings$Translations$docs_redeem_underlying_redeem_amount_description = function (lang) {
	return 'The amount of underlying to be redeemed.';
};
var author$project$Strings$Translations$docs_redeem_underlying_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_repay_borrow_behalf_borrower_description = function (lang) {
	return 'The account which borrowed the asset to be repaid.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_description1 = function (lang) {
	return 'The repay function transfers an asset into the money market, reducing the user\'s borrow balance.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part1 = function (lang) {
	return 'Before supplying an asset, users must first ';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part2 = function (lang) {
	return 'approve';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part3 = function (lang) {
	return ' the cToken to access their token balance.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_msg_sender_description = function (lang) {
	return 'The account which shall repay the borrow.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_payable_borrower_description = function (lang) {
	return 'The account which borrowed the asset to be repaid.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_sender_description = function (lang) {
	return 'The account which shall repay the borrow.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_value_description = function (lang) {
	return 'The amount of ether to be repaid, in wei.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_payable_return_description = function (lang) {
	return 'No return, reverts on error.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description1 = function (lang) {
	return 'The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. 2';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description2 = function (lang) {
	return '256';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description3 = function (lang) {
	return ' - 1) can be used to repay the full amount.';
};
var author$project$Strings$Translations$docs_repay_borrow_behalf_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_repay_borrow_description1 = function (lang) {
	return 'The repay function transfers an asset into the money market, reducing the user\'s borrow balance.';
};
var author$project$Strings$Translations$docs_repay_borrow_description2_part1 = function (lang) {
	return 'Before supplying an asset, users must first ';
};
var author$project$Strings$Translations$docs_repay_borrow_description2_part2 = function (lang) {
	return 'approve';
};
var author$project$Strings$Translations$docs_repay_borrow_description2_part3 = function (lang) {
	return ' the cToken to access their token balance.';
};
var author$project$Strings$Translations$docs_repay_borrow_msg_sender_description = function (lang) {
	return 'The account which borrowed the asset, and shall repay the borrow.';
};
var author$project$Strings$Translations$docs_repay_borrow_payable_msg_sender_description = function (lang) {
	return 'The account which borrowed the asset, and shall repay the borrow.';
};
var author$project$Strings$Translations$docs_repay_borrow_payable_msg_value_description = function (lang) {
	return 'The amount of ether to be repaid, in wei.';
};
var author$project$Strings$Translations$docs_repay_borrow_payable_return_description = function (lang) {
	return 'No return, reverts on error.';
};
var author$project$Strings$Translations$docs_repay_borrow_repay_amount_description1 = function (lang) {
	return 'The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. 2';
};
var author$project$Strings$Translations$docs_repay_borrow_repay_amount_description2 = function (lang) {
	return '256';
};
var author$project$Strings$Translations$docs_repay_borrow_repay_amount_description3 = function (lang) {
	return ' - 1) can be used to repay the full amount.';
};
var author$project$Strings$Translations$docs_repay_borrow_return_description = F2(
	function (lang, str0) {
		return '0 on success, otherwise an ' + (str0 + '');
	});
var author$project$Strings$Translations$docs_reserve_factor_description_part1 = function (lang) {
	return 'The reserve factor defines the small slice of interest that is accrued into ';
};
var author$project$Strings$Translations$docs_reserve_factor_description_part2 = function (lang) {
	return 'reserves';
};
var author$project$Strings$Translations$docs_reserve_factor_return_description = function (lang) {
	return 'The current reserve factor as an unsigned integer, scaled by 1e18.';
};
var author$project$Strings$Translations$docs_supply_balance_account_description = function (lang) {
	return 'The account to get the token balance of.';
};
var author$project$Strings$Translations$docs_supply_balance_description_part1 = function (lang) {
	return 'A user who supplies assets to the protocol receives tokens which accumulate interest based on the current ';
};
var author$project$Strings$Translations$docs_supply_balance_description_part2 = function (lang) {
	return 'supply rate';
};
var author$project$Strings$Translations$docs_supply_balance_description_part3 = function (lang) {
	return '. At any given time, the value of a token with interest may be queried via the ';
};
var author$project$Strings$Translations$docs_supply_balance_description_part4 = function (lang) {
	return 'exchange rate';
};
var author$project$Strings$Translations$docs_supply_balance_description_part5 = function (lang) {
	return '. The number of tokens owned by a particular user may also be queried, which is part of the EIP-20 interface of the cToken contract.';
};
var author$project$Strings$Translations$docs_supply_balance_return_description = function (lang) {
	return 'The number of tokens currently owned by the account.';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_account_description = function (lang) {
	return 'The account to get the underlying balance of.';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_description_part1 = function (lang) {
	return 'CTokens also have a convenience method for determining the supply balance in terms of the amount of underlying (i.e. ';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_description_part2 = function (lang) {
	return 'supply balance';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_description_part3 = function (lang) {
	return ' multiplied by the ';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_description_part4 = function (lang) {
	return 'exchange rate';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_description_part5 = function (lang) {
	return ').';
};
var author$project$Strings$Translations$docs_supply_balance_underlying_return_description = function (lang) {
	return 'The amount of underlying currently owned by the account.';
};
var author$project$Strings$Translations$docs_supply_rate_description_part1 = function (lang) {
	return 'At any point in time one may query the contract to get the current supply rate per block. The supply rate is derived from the ';
};
var author$project$Strings$Translations$docs_supply_rate_description_part2 = function (lang) {
	return 'borrow rate';
};
var author$project$Strings$Translations$docs_supply_rate_description_part3 = function (lang) {
	return 'reserve factor';
};
var author$project$Strings$Translations$docs_supply_rate_description_part4 = function (lang) {
	return ' and the amount of ';
};
var author$project$Strings$Translations$docs_supply_rate_description_part5 = function (lang) {
	return 'total borrows';
};
var author$project$Strings$Translations$docs_supply_rate_return_description = function (lang) {
	return 'The current supply rate as an unsigned integer, scaled by 1e18.';
};
var author$project$Strings$Translations$docs_support_description_part1 = function (lang) {
	return 'For support requests, please reach out to us in the #development channel in our ';
};
var author$project$Strings$Translations$docs_support_description_part2 = function (lang) {
	return 'Discord';
};
var author$project$Strings$Translations$docs_support_description_part3 = function (lang) {
	return '. We\'re happy to help out and grow the Compound community. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
};
var author$project$Strings$Translations$docs_supported_networks = function (lang) {
	return 'The Compound Protocol v2 is currently deployed on the following networks:';
};
var author$project$Strings$Translations$docs_total_borrow_description = function (lang) {
	return 'Total Borrows is the amount of underlying currently loaned out by the market, and the amount upon which interest is accumulated to suppliers of the market.';
};
var author$project$Strings$Translations$docs_total_borrow_return_description = function (lang) {
	return 'The total amount of borrowed underlying, with interest.';
};
var author$project$Strings$Translations$docs_total_reserves_description_part1 = function (lang) {
	return 'Reserves are the equity accrued to the protocol itself, in order to fund its operation. Reserves also form part of the ';
};
var author$project$Strings$Translations$docs_total_reserves_description_part2 = function (lang) {
	return 'cash';
};
var author$project$Strings$Translations$docs_total_reserves_description_part3 = function (lang) {
	return ' which may be loaned out to borrowers in the market. A small portion of borrower interest accrues into the protocol, determined by the ';
};
var author$project$Strings$Translations$docs_total_reserves_description_part4 = function (lang) {
	return 'reserve factor';
};
var author$project$Strings$Translations$docs_total_reserves_return_description = function (lang) {
	return 'The total amount of reserves held by the protocol.';
};
var author$project$Strings$Translations$docs_total_supply_description = function (lang) {
	return 'Total Supply is the number of tokens currently in circulation in this cToken market. It is part of the EIP-20 interface of the cToken contract.';
};
var author$project$Strings$Translations$docs_total_supply_return_description = function (lang) {
	return 'The total number of tokens in circulation for the market.';
};
var author$project$Strings$Translations$enter_markets = function (lang) {
	return 'Enter Markets';
};
var author$project$Strings$Translations$error_codes = function (lang) {
	return 'Error codes';
};
var author$project$Strings$Translations$exchange_rate = function (lang) {
	return 'Exchange Rate';
};
var author$project$Strings$Translations$exit_market = function (lang) {
	return 'Exit Market';
};
var author$project$Strings$Translations$exponential_math = function (lang) {
	return 'Exponential Math';
};
var author$project$Strings$Translations$gas_costs = function (lang) {
	return 'Gas Costs';
};
var author$project$Strings$Translations$get_account_liquidity = function (lang) {
	return 'Get Account Liquidity';
};
var author$project$Strings$Translations$get_assets_in = function (lang) {
	return 'Get Assets In';
};
var author$project$Strings$Translations$get_cash = function (lang) {
	return 'Get Cash';
};
var author$project$Strings$Translations$getting_started = function (lang) {
	return 'Getting Started';
};
var author$project$Strings$Translations$glossary = function (lang) {
	return 'Glossary';
};
var author$project$Strings$Translations$key_events = function (lang) {
	return 'Key Events';
};
var author$project$Strings$Translations$liquidate_borrow = function (lang) {
	return 'Liquidate Borrow';
};
var author$project$Strings$Translations$mint = function (lang) {
	return 'Mint';
};
var author$project$Strings$Translations$redeem = function (lang) {
	return 'Redeem';
};
var author$project$Strings$Translations$redeem_underlying = function (lang) {
	return 'Redeem Underlying';
};
var author$project$Strings$Translations$repay_borrow = function (lang) {
	return 'Repay Borrow';
};
var author$project$Strings$Translations$repay_borrow_behalf = function (lang) {
	return 'Repay Borrow Behalf';
};
var author$project$Strings$Translations$reserve_factor = function (lang) {
	return 'Reserve Factor';
};
var author$project$Strings$Translations$solidity = function (lang) {
	return 'Solidity';
};
var author$project$Strings$Translations$supply_balance = function (lang) {
	return 'Supply Balance';
};
var author$project$Strings$Translations$supply_balance_underlying = function (lang) {
	return 'Supply Balance Underlying';
};
var author$project$Strings$Translations$supply_rate = function (lang) {
	return 'Supply Rate';
};
var author$project$Strings$Translations$support = function (lang) {
	return 'Support';
};
var author$project$Strings$Translations$total_borrow = function (lang) {
	return 'Total Borrow';
};
var author$project$Strings$Translations$total_reserves = function (lang) {
	return 'Total Reserves';
};
var author$project$Strings$Translations$total_supply = function (lang) {
	return 'Total Supply';
};
var author$project$SyntaxHighlight$HCode = elm$core$Basics$identity;
var author$project$SyntaxHighlight$Style$Style1 = 2;
var author$project$SyntaxHighlight$Style$Style2 = 3;
var author$project$SyntaxHighlight$Style$Style3 = 4;
var author$project$SyntaxHighlight$Style$Style4 = 5;
var author$project$SyntaxHighlight$Style$Style5 = 6;
var author$project$SyntaxHighlight$Style$Style6 = 7;
var author$project$SyntaxHighlight$Style$Style7 = 8;
var author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(5, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var elm$parser$Parser$UnexpectedChar = {$: 11};
var elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$parser$Parser$Advanced$Parser = elm$core$Basics$identity;
var elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bK: col, c7: contextStack, cl: problem, cw: row};
	});
var elm$parser$Parser$Advanced$Empty = {$: 0};
var elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, s.cw, s.bK, x, s.e));
	});
var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bK: 1, e: s.e, g: s.g, b: s.b + 1, cw: s.cw + 1, a: s.a}) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bK: s.bK + 1, e: s.e, g: s.g, b: newOffset, cw: s.cw, a: s.a}));
		};
	});
var elm$parser$Parser$chompIf = function (isGood) {
	return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
};
var elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{bK: col, e: s0.e, g: s0.g, b: offset, cw: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.cw, s.bK, s);
	};
};
var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
var elm$core$Basics$always = F2(
	function (a, _n0) {
		return a;
	});
var elm$parser$Parser$Advanced$map2 = F3(
	function (func, _n0, _n1) {
		var parseA = _n0;
		var parseB = _n1;
		return function (s0) {
			var _n2 = parseA(s0);
			if (_n2.$ === 1) {
				var p = _n2.a;
				var x = _n2.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n2.a;
				var a = _n2.b;
				var s1 = _n2.c;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(
						elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
	});
var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
var elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
var author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$chompIf(isNotRelevant)),
		elm$parser$Parser$chompWhile(isNotRelevant));
};
var elm$core$Set$Set_elm_builtin = elm$core$Basics$identity;
var elm$core$Set$empty = elm$core$Dict$empty;
var elm$core$Set$insert = F2(
	function (key, _n0) {
		var dict = _n0;
		return A3(elm$core$Dict$insert, key, 0, dict);
	});
var elm$core$Set$fromList = function (list) {
	return A3(elm$core$List$foldl, elm$core$Set$insert, elm$core$Set$empty, list);
};
var author$project$SyntaxHighlight$Language$Javascript$groupSet = elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';']));
var elm$core$Dict$member = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$get, key, dict);
		if (!_n0.$) {
			return true;
		} else {
			return false;
		}
	});
var elm$core$Set$member = F2(
	function (key, _n0) {
		var dict = _n0;
		return A2(elm$core$Dict$member, key, dict);
	});
var author$project$SyntaxHighlight$Language$Javascript$isGroupChar = function (c) {
	return A2(elm$core$Set$member, c, author$project$SyntaxHighlight$Language$Javascript$groupSet);
};
var author$project$SyntaxHighlight$Language$Type$Normal = {$: 0};
var elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3(elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
};
var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
var elm$parser$Parser$Advanced$map = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
var author$project$SyntaxHighlight$Language$Javascript$groupChar = A2(
	elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, b);
	},
	elm$parser$Parser$getChompedString(
		author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isGroupChar)));
var author$project$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var author$project$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var author$project$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return author$project$SyntaxHighlight$Language$Helpers$isSpace(c) || author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var author$project$SyntaxHighlight$Language$Javascript$isCommentChar = function (c) {
	return c === '/';
};
var author$project$SyntaxHighlight$Language$Javascript$operatorSet = elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%', '.']));
var elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3(elm$core$Dict$foldl, elm$core$Dict$insert, t2, t1);
	});
var elm$core$Set$union = F2(
	function (_n0, _n1) {
		var dict1 = _n0;
		var dict2 = _n1;
		return A2(elm$core$Dict$union, dict1, dict2);
	});
var author$project$SyntaxHighlight$Language$Javascript$punctuactorSet = A2(elm$core$Set$union, author$project$SyntaxHighlight$Language$Javascript$operatorSet, author$project$SyntaxHighlight$Language$Javascript$groupSet);
var author$project$SyntaxHighlight$Language$Javascript$isPunctuaction = function (c) {
	return A2(elm$core$Set$member, c, author$project$SyntaxHighlight$Language$Javascript$punctuactorSet);
};
var author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar = function (c) {
	return (c === '\"') || ((c === '\'') || (c === '`'));
};
var elm$core$Basics$not = _Basics_not;
var author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar = function (c) {
	return !(author$project$SyntaxHighlight$Language$Javascript$isPunctuaction(c) || (author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar(c) || (author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var author$project$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var author$project$SyntaxHighlight$Language$Javascript$Function = 5;
var author$project$SyntaxHighlight$Language$Javascript$Keyword = 2;
var author$project$SyntaxHighlight$Language$Javascript$LiteralKeyword = 6;
var author$project$SyntaxHighlight$Language$Javascript$Param = 7;
var author$project$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var author$project$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(
	function (isNotRelevant, previousParser) {
		return A2(
			elm$parser$Parser$ignorer,
			previousParser,
			elm$parser$Parser$chompWhile(isNotRelevant));
	});
var author$project$SyntaxHighlight$Language$Type$Comment = {$: 1};
var elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var elm$parser$Parser$Advanced$token = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	var progress = !elm$core$String$isEmpty(str);
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.b, s.cw, s.bK, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bK: newCol, e: s.e, g: s.g, b: newOffset, cw: newRow, a: s.a});
	};
};
var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
var elm$parser$Parser$symbol = function (str) {
	return elm$parser$Parser$Advanced$symbol(
		A2(
			elm$parser$Parser$Advanced$Token,
			str,
			elm$parser$Parser$ExpectingSymbol(str)));
};
var author$project$SyntaxHighlight$Language$Javascript$inlineComment = A2(
	elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	elm$parser$Parser$getChompedString(
		A2(
			author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2(elm$core$Basics$composeL, elm$core$Basics$not, author$project$SyntaxHighlight$Language$Helpers$isLineBreak),
			elm$parser$Parser$symbol('//'))));
var elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _n0) {
		var parseA = _n0;
		return function (s0) {
			var _n1 = parseA(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				var _n2 = callback(a);
				var parseB = _n2;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
var author$project$SyntaxHighlight$Language$Helpers$addThen = F3(
	function (f, list, plist) {
		return A2(
			elm$parser$Parser$andThen,
			function (n) {
				return f(
					_Utils_ap(n, list));
			},
			plist);
	});
var author$project$SyntaxHighlight$Language$Helpers$consThen = F3(
	function (f, list, pn) {
		return A2(
			elm$parser$Parser$andThen,
			function (n) {
				return f(
					A2(elm$core$List$cons, n, list));
			},
			pn);
	});
var elm$parser$Parser$ExpectingEnd = {$: 10};
var elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			elm$core$String$length(s.a),
			s.b) ? A3(elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
var elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2(elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _n1 = parse(s0);
				if (!_n1.$) {
					var step = _n1;
					return step;
				} else {
					var step = _n1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
var author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(
	function (options, revAList) {
		var defaultMap = options.bP;
		var isNotRelevant = options.b2;
		var end = options.aZ;
		var innerParsers = options.b$;
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$map,
					elm$core$Basics$always(
						A2(
							elm$core$List$cons,
							defaultMap(end),
							revAList)),
					elm$parser$Parser$symbol(end)),
					A2(
					elm$parser$Parser$map,
					elm$core$Basics$always(revAList),
					elm$parser$Parser$end),
					A3(
					author$project$SyntaxHighlight$Language$Helpers$addThen,
					author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					elm$parser$Parser$oneOf(innerParsers)),
					A3(
					author$project$SyntaxHighlight$Language$Helpers$consThen,
					author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					A2(
						elm$parser$Parser$map,
						defaultMap,
						elm$parser$Parser$getChompedString(
							A2(
								author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								elm$parser$Parser$chompIf(
									elm$core$Basics$always(true))))))
				]));
	});
var author$project$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(
	function (nestLevel, options, revAList) {
		var defaultMap = options.bP;
		var isNotRelevant = options.b2;
		var start = options.bv;
		var end = options.aZ;
		var innerParsers = options.b$;
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$andThen,
					function (n) {
						return (nestLevel === 1) ? elm$parser$Parser$succeed(n) : A3(author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
					},
					A2(
						elm$parser$Parser$map,
						elm$core$Basics$always(
							A2(
								elm$core$List$cons,
								defaultMap(end),
								revAList)),
						elm$parser$Parser$symbol(end))),
					A3(
					author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2(author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
					revAList,
					A2(
						elm$parser$Parser$map,
						defaultMap,
						elm$parser$Parser$getChompedString(
							A2(
								author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								elm$parser$Parser$symbol(start))))),
					A3(
					author$project$SyntaxHighlight$Language$Helpers$addThen,
					author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					elm$parser$Parser$oneOf(innerParsers)),
					A2(
					elm$parser$Parser$map,
					elm$core$Basics$always(revAList),
					elm$parser$Parser$end),
					A3(
					author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2(author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
					revAList,
					A2(
						elm$parser$Parser$map,
						defaultMap,
						elm$parser$Parser$getChompedString(
							A2(
								author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								elm$parser$Parser$chompIf(
									elm$core$Basics$always(true))))))
				]));
	});
var elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$problem = function (msg) {
	return elm$parser$Parser$Advanced$problem(
		elm$parser$Parser$Problem(msg));
};
var author$project$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(
	function (options, revAList) {
		var start = options.bv;
		var end = options.aZ;
		var isNotRelevant = options.b2;
		var _n0 = _Utils_Tuple2(
			elm$core$String$uncons(options.bv),
			elm$core$String$uncons(options.aZ));
		if (_n0.a.$ === 1) {
			var _n1 = _n0.a;
			return elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
		} else {
			if (_n0.b.$ === 1) {
				var _n2 = _n0.b;
				return elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
			} else {
				var _n3 = _n0.a.a;
				var startChar = _n3.a;
				var _n4 = _n0.b.a;
				var endChar = _n4.a;
				return options.b1 ? A3(
					author$project$SyntaxHighlight$Language$Helpers$delimitedNestable,
					1,
					_Utils_update(
						options,
						{
							b2: function (c) {
								return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
							}
						}),
					revAList) : A2(
					author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable,
					_Utils_update(
						options,
						{
							b2: function (c) {
								return isNotRelevant(c) && (!_Utils_eq(c, endChar));
							}
						}),
					revAList);
			}
		}
	});
var author$project$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var start = options.bv;
	var isNotRelevant = options.b2;
	var defaultMap = options.bP;
	return A2(
		elm$parser$Parser$andThen,
		function (n) {
			return A2(
				author$project$SyntaxHighlight$Language$Helpers$delimitedHelp,
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			elm$parser$Parser$map,
			elm$core$Basics$always(
				defaultMap(start)),
			elm$parser$Parser$symbol(start)));
};
var author$project$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var author$project$SyntaxHighlight$Language$Javascript$lineBreakList = A2(
	elm$parser$Parser$map,
	function (_n0) {
		return _List_fromArray(
			[
				_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	elm$parser$Parser$symbol('\n'));
var author$project$SyntaxHighlight$Language$Javascript$multilineComment = author$project$SyntaxHighlight$Language$Helpers$delimited(
	{
		bP: function (b) {
			return _Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Comment, b);
		},
		aZ: '*/',
		b$: _List_fromArray(
			[author$project$SyntaxHighlight$Language$Javascript$lineBreakList]),
		b1: false,
		b2: function (c) {
			return !author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		bv: '/*'
	});
var author$project$SyntaxHighlight$Language$Javascript$comment = elm$parser$Parser$oneOf(
	_List_fromArray(
		[author$project$SyntaxHighlight$Language$Javascript$inlineComment, author$project$SyntaxHighlight$Language$Javascript$multilineComment]));
var elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$map,
				function (b) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				elm$parser$Parser$map,
				function (ns) {
					return elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				author$project$SyntaxHighlight$Language$Javascript$lineBreakList),
				A2(
				elm$parser$Parser$map,
				function (ns) {
					return elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				author$project$SyntaxHighlight$Language$Javascript$comment)
			]));
};
var author$project$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				elm$parser$Parser$map,
				function (b) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(
								author$project$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				elm$parser$Parser$succeed(
				elm$parser$Parser$Done(revTokens))
			]));
};
var elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return elm$parser$Parser$Advanced$Done(a);
	}
};
var elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _n0 = callback(state);
			var parse = _n0;
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p1 = _n1.a;
				var step = _n1.b;
				var s1 = _n1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					elm$parser$Parser$map,
					elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						elm$parser$Parser$map,
						elm$parser$Parser$Loop,
						A2(
							elm$parser$Parser$loop,
							A2(
								elm$core$List$cons,
								_Utils_Tuple2(
									author$project$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop)) : elm$parser$Parser$succeed(
						elm$parser$Parser$Loop(
							A2(
								elm$core$List$cons,
								_Utils_Tuple2(
									author$project$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				elm$parser$Parser$succeed(
				elm$parser$Parser$Done(revTokens))
			]));
};
var author$project$SyntaxHighlight$Language$Javascript$argLoop = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				elm$parser$Parser$map,
				function (b) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(
								author$project$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !(author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || (author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				elm$parser$Parser$map,
				function (b) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				elm$parser$Parser$succeed(
				elm$parser$Parser$Done(revTokens))
			]));
};
var author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				elm$parser$Parser$map,
				function (b) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(
								author$project$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				elm$parser$Parser$getChompedString(
					author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				A2(
				elm$parser$Parser$map,
				function (_n0) {
					return elm$parser$Parser$Loop(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(
								author$project$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				elm$parser$Parser$symbol('*')),
				A2(
				elm$parser$Parser$map,
				elm$parser$Parser$Loop,
				A2(
					elm$parser$Parser$andThen,
					function (_n1) {
						return A2(
							elm$parser$Parser$loop,
							A2(
								elm$core$List$cons,
								_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							author$project$SyntaxHighlight$Language$Javascript$argLoop);
					},
					elm$parser$Parser$symbol('('))),
				elm$parser$Parser$succeed(
				elm$parser$Parser$Done(revTokens))
			]));
};
var author$project$SyntaxHighlight$Language$Javascript$FunctionEval = 4;
var author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop = F3(
	function (identifier, revTokens, thisRevToken) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(thisRevToken),
					A2(
					elm$parser$Parser$map,
					function (_n0) {
						return elm$parser$Parser$Done(
							_Utils_ap(
								A2(
									elm$core$List$cons,
									_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, '('),
									thisRevToken),
								A2(
									elm$core$List$cons,
									_Utils_Tuple2(
										author$project$SyntaxHighlight$Language$Type$C(4),
										identifier),
									revTokens)));
					},
					elm$parser$Parser$symbol('(')),
					elm$parser$Parser$succeed(
					elm$parser$Parser$Done(
						_Utils_ap(
							thisRevToken,
							A2(
								elm$core$List$cons,
								_Utils_Tuple2(author$project$SyntaxHighlight$Language$Type$Normal, identifier),
								revTokens))))
				]));
	});
var author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet = elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let']));
var author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword = function (str) {
	return A2(elm$core$Set$member, str, author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet);
};
var author$project$SyntaxHighlight$Language$Javascript$keywordSet = elm$core$Set$fromList(
	_List_fromArray(
		['break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected']));
var author$project$SyntaxHighlight$Language$Javascript$isKeyword = function (str) {
	return A2(elm$core$Set$member, str, author$project$SyntaxHighlight$Language$Javascript$keywordSet);
};
var author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet = elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword = function (str) {
	return A2(elm$core$Set$member, str, author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet);
};
var author$project$SyntaxHighlight$Language$Javascript$keywordParser = F2(
	function (revTokens, n) {
		return ((n === 'function') || (n === 'static')) ? A2(
			elm$parser$Parser$loop,
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ((n === 'class') ? A2(
			elm$parser$Parser$loop,
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? elm$parser$Parser$succeed(
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(7),
					n),
				revTokens)) : ((n === 'constructor') ? A2(
			elm$parser$Parser$loop,
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : (author$project$SyntaxHighlight$Language$Javascript$isKeyword(n) ? elm$parser$Parser$succeed(
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(2),
					n),
				revTokens)) : (author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword(n) ? elm$parser$Parser$succeed(
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens)) : (author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword(n) ? elm$parser$Parser$succeed(
			A2(
				elm$core$List$cons,
				_Utils_Tuple2(
					author$project$SyntaxHighlight$Language$Type$C(6),
					n),
				revTokens)) : A2(
			elm$parser$Parser$loop,
			_List_Nil,
			A2(author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop, n, revTokens))))))));
	});
var author$project$SyntaxHighlight$Language$Helpers$isNumber = function (c) {
	return elm$core$Char$isDigit(c) || (c === '.');
};
var author$project$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	elm$parser$Parser$ignorer,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(0),
		elm$parser$Parser$chompIf(author$project$SyntaxHighlight$Language$Helpers$isNumber)),
	elm$parser$Parser$chompWhile(author$project$SyntaxHighlight$Language$Helpers$isNumber));
var elm$parser$Parser$Advanced$backtrackable = function (_n0) {
	var parse = _n0;
	return function (s0) {
		var _n1 = parse(s0);
		if (_n1.$ === 1) {
			var x = _n1.b;
			return A2(elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _n1.b;
			var s1 = _n1.c;
			return A3(elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var elm$parser$Parser$backtrackable = elm$parser$Parser$Advanced$backtrackable;
var author$project$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	elm$parser$Parser$ignorer,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(0),
		elm$parser$Parser$backtrackable(
			elm$parser$Parser$symbol('-'))),
	author$project$SyntaxHighlight$Language$Helpers$positiveNumber);
var author$project$SyntaxHighlight$Language$Helpers$number = elm$parser$Parser$oneOf(
	_List_fromArray(
		[author$project$SyntaxHighlight$Language$Helpers$positiveNumber, author$project$SyntaxHighlight$Language$Helpers$negativeNumber]));
var author$project$SyntaxHighlight$Language$Javascript$Number = 0;
var author$project$SyntaxHighlight$Language$Javascript$number = A2(
	elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			author$project$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	elm$parser$Parser$getChompedString(author$project$SyntaxHighlight$Language$Helpers$number));
var author$project$SyntaxHighlight$Language$Javascript$isOperatorChar = function (c) {
	return A2(elm$core$Set$member, c, author$project$SyntaxHighlight$Language$Javascript$operatorSet);
};
var author$project$SyntaxHighlight$Language$Javascript$operatorChar = A2(
	elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			author$project$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	elm$parser$Parser$getChompedString(
		author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isOperatorChar)));
var author$project$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var author$project$SyntaxHighlight$Language$Javascript$String = 1;
var author$project$SyntaxHighlight$Language$Helpers$escapableSet = elm$core$Set$fromList(
	_List_fromArray(
		['\'', '\"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var author$project$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return A2(elm$core$Set$member, c, author$project$SyntaxHighlight$Language$Helpers$escapableSet);
};
var author$project$SyntaxHighlight$Language$Helpers$escapable = A2(
	elm$parser$Parser$ignorer,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(0),
		elm$parser$Parser$backtrackable(
			elm$parser$Parser$symbol('\\'))),
	elm$parser$Parser$chompIf(author$project$SyntaxHighlight$Language$Helpers$isEscapableChar));
var author$project$SyntaxHighlight$Language$Javascript$jsEscapable = A2(
	elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				author$project$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	elm$parser$Parser$getChompedString(author$project$SyntaxHighlight$Language$Helpers$escapable));
var author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter = {
	bP: function (b) {
		return _Utils_Tuple2(
			author$project$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	aZ: '\'',
	b$: _List_fromArray(
		[author$project$SyntaxHighlight$Language$Javascript$lineBreakList, author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
	b1: false,
	b2: function (c) {
		return !(author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	bv: '\''
};
var author$project$SyntaxHighlight$Language$Javascript$doubleQuote = author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{aZ: '\"', bv: '\"'}));
var author$project$SyntaxHighlight$Language$Javascript$quote = author$project$SyntaxHighlight$Language$Helpers$delimited(author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter);
var author$project$SyntaxHighlight$Language$Javascript$templateString = author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{
			aZ: '`',
			b$: _List_fromArray(
				[author$project$SyntaxHighlight$Language$Javascript$lineBreakList, author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
			b2: function (c) {
				return !(author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			bv: '`'
		}));
var author$project$SyntaxHighlight$Language$Javascript$stringLiteral = elm$parser$Parser$oneOf(
	_List_fromArray(
		[author$project$SyntaxHighlight$Language$Javascript$quote, author$project$SyntaxHighlight$Language$Javascript$doubleQuote, author$project$SyntaxHighlight$Language$Javascript$templateString]));
var author$project$SyntaxHighlight$Language$Javascript$mainLoop = function (revTokens) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				elm$parser$Parser$map,
				function (s) {
					return elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				author$project$SyntaxHighlight$Language$Javascript$stringLiteral),
				A2(
				elm$parser$Parser$map,
				function (s) {
					return elm$parser$Parser$Loop(
						A2(elm$core$List$cons, s, revTokens));
				},
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[author$project$SyntaxHighlight$Language$Javascript$operatorChar, author$project$SyntaxHighlight$Language$Javascript$groupChar, author$project$SyntaxHighlight$Language$Javascript$number]))),
				A2(
				elm$parser$Parser$map,
				elm$parser$Parser$Loop,
				A2(
					elm$parser$Parser$andThen,
					author$project$SyntaxHighlight$Language$Javascript$keywordParser(revTokens),
					elm$parser$Parser$getChompedString(
						author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar)))),
				elm$parser$Parser$succeed(
				elm$parser$Parser$Done(revTokens))
			]));
};
var author$project$SyntaxHighlight$Language$Javascript$toRevTokens = A2(elm$parser$Parser$loop, _List_Nil, author$project$SyntaxHighlight$Language$Javascript$mainLoop);
var author$project$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {dk: fragments, dn: elm$core$Maybe$Nothing};
};
var author$project$SyntaxHighlight$Style$Comment = 1;
var author$project$SyntaxHighlight$Style$Default = 0;
var author$project$SyntaxHighlight$Line$Helpers$toFragment = F2(
	function (toStyle, _n0) {
		var syntax = _n0.a;
		var text = _n0.b;
		switch (syntax.$) {
			case 0:
				return {cU: '', dL: 0, d0: text};
			case 1:
				return {cU: '', dL: 1, d0: text};
			case 2:
				return {cU: '', dL: 0, d0: text};
			default:
				var c = syntax.a;
				var _n2 = toStyle(c);
				var requiredStyle = _n2.a;
				var additionalClass = _n2.b;
				return {cU: additionalClass, dL: requiredStyle, d0: text};
		}
	});
var author$project$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(
	function (toStyle, _n0, _n1) {
		var syntax = _n0.a;
		var text = _n0.b;
		var lines = _n1.a;
		var fragments = _n1.b;
		var maybeLastSyntax = _n1.c;
		if (_Utils_eq(syntax, author$project$SyntaxHighlight$Language$Type$LineBreak)) {
			return _Utils_Tuple3(
				A2(
					elm$core$List$cons,
					author$project$SyntaxHighlight$Line$Helpers$newLine(fragments),
					lines),
				_List_fromArray(
					[
						A2(
						author$project$SyntaxHighlight$Line$Helpers$toFragment,
						toStyle,
						_Utils_Tuple2(syntax, text))
					]),
				elm$core$Maybe$Nothing);
		} else {
			if (_Utils_eq(
				elm$core$Maybe$Just(syntax),
				maybeLastSyntax)) {
				if (fragments.b) {
					var headFrag = fragments.a;
					var tailFrags = fragments.b;
					return _Utils_Tuple3(
						lines,
						A2(
							elm$core$List$cons,
							_Utils_update(
								headFrag,
								{
									d0: _Utils_ap(text, headFrag.d0)
								}),
							tailFrags),
						maybeLastSyntax);
				} else {
					return _Utils_Tuple3(
						lines,
						A2(
							elm$core$List$cons,
							A2(
								author$project$SyntaxHighlight$Line$Helpers$toFragment,
								toStyle,
								_Utils_Tuple2(syntax, text)),
							fragments),
						maybeLastSyntax);
				}
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						elm$core$List$cons,
						A2(
							author$project$SyntaxHighlight$Line$Helpers$toFragment,
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					elm$core$Maybe$Just(syntax));
			}
		}
	});
var author$project$SyntaxHighlight$Line$Helpers$toLines = F2(
	function (toStyle, revTokens) {
		return function (_n0) {
			var lines = _n0.a;
			var frags = _n0.b;
			return A2(
				elm$core$List$cons,
				author$project$SyntaxHighlight$Line$Helpers$newLine(frags),
				lines);
		}(
			A3(
				elm$core$List$foldl,
				author$project$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
				_Utils_Tuple3(_List_Nil, _List_Nil, elm$core$Maybe$Nothing),
				revTokens));
	});
var elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {bK: col, cl: problem, cw: row};
	});
var elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3(elm$parser$Parser$DeadEnd, p.cw, p.bK, p.cl);
};
var elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var elm$parser$Parser$Advanced$run = F2(
	function (_n0, src) {
		var parse = _n0;
		var _n1 = parse(
			{bK: 1, e: _List_Nil, g: 1, b: 0, cw: 1, a: src});
		if (!_n1.$) {
			var value = _n1.b;
			return elm$core$Result$Ok(value);
		} else {
			var bag = _n1.b;
			return elm$core$Result$Err(
				A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var elm$parser$Parser$run = F2(
	function (parser, source) {
		var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
		if (!_n0.$) {
			var a = _n0.a;
			return elm$core$Result$Ok(a);
		} else {
			var problems = _n0.a;
			return elm$core$Result$Err(
				A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var author$project$SyntaxHighlight$Language$Javascript$toLines = A2(
	elm$core$Basics$composeR,
	elm$parser$Parser$run(author$project$SyntaxHighlight$Language$Javascript$toRevTokens),
	elm$core$Result$map(
		author$project$SyntaxHighlight$Line$Helpers$toLines(author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle)));
var author$project$SyntaxHighlight$javascript = A2(
	elm$core$Basics$composeR,
	author$project$SyntaxHighlight$Language$Javascript$toLines,
	elm$core$Result$map(elm$core$Basics$identity));
var author$project$SyntaxHighlight$Line$Add = 1;
var author$project$SyntaxHighlight$Line$Del = 2;
var author$project$SyntaxHighlight$Line$Normal = 0;
var author$project$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var elm$core$Tuple$second = function (_n0) {
	var y = _n0.b;
	return y;
};
var elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$string(string));
	});
var elm$html$Html$Attributes$class = elm$html$Html$Attributes$stringProperty('className');
var elm$html$Html$Attributes$classList = function (classes) {
	return elm$html$Html$Attributes$class(
		A2(
			elm$core$String$join,
			' ',
			A2(
				elm$core$List$map,
				elm$core$Tuple$first,
				A2(elm$core$List$filter, elm$core$Tuple$second, classes))));
};
var author$project$SyntaxHighlight$View$fragmentView = function (_n0) {
	var text = _n0.d0;
	var requiredStyle = _n0.dL;
	var additionalClass = _n0.cU;
	return ((!requiredStyle) && elm$core$String$isEmpty(additionalClass)) ? elm$html$Html$text(text) : A2(
		elm$html$Html$span,
		_List_fromArray(
			[
				elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						author$project$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						requiredStyle),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				elm$html$Html$text(text)
			]));
};
var author$project$SyntaxHighlight$View$lineView = F3(
	function (start, index, _n0) {
		var fragments = _n0.dk;
		var highlight = _n0.dn;
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('elmsh-line', true),
							_Utils_Tuple2(
							'elmsh-hl',
							_Utils_eq(
								highlight,
								elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'elmsh-add',
							_Utils_eq(
								highlight,
								elm$core$Maybe$Just(1))),
							_Utils_Tuple2(
							'elmsh-del',
							_Utils_eq(
								highlight,
								elm$core$Maybe$Just(2)))
						])),
					A2(
					elm$html$Html$Attributes$attribute,
					'data-elmsh-lc',
					elm$core$String$fromInt(start + index))
				]),
			A2(elm$core$List$map, author$project$SyntaxHighlight$View$fragmentView, fragments));
	});
var elm$html$Html$code = _VirtualDom_node('code');
var author$project$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		elm$html$Html$code,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('elmsh')
			]),
		elm$core$List$concat(
			A2(
				elm$core$List$map,
				function (_n0) {
					var highlight = _n0.dn;
					var fragments = _n0.dk;
					return _Utils_eq(highlight, elm$core$Maybe$Nothing) ? A2(elm$core$List$map, author$project$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_fromArray(
								[
									elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												elm$core$Maybe$Just(2)))
										]))
								]),
							A2(elm$core$List$map, author$project$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var author$project$SyntaxHighlight$View$toBlockHtml = F2(
	function (maybeStart, lines) {
		if (maybeStart.$ === 1) {
			return A2(
				elm$html$Html$pre,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('elmsh')
					]),
				_List_fromArray(
					[
						author$project$SyntaxHighlight$View$toInlineHtml(lines)
					]));
		} else {
			var start = maybeStart.a;
			return A2(
				elm$html$Html$pre,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('elmsh')
					]),
				elm$core$List$singleton(
					A2(
						elm$html$Html$code,
						_List_Nil,
						A2(
							elm$core$List$indexedMap,
							author$project$SyntaxHighlight$View$lineView(start),
							lines))));
		}
	});
var author$project$SyntaxHighlight$toBlockHtml = F2(
	function (maybeStart, _n0) {
		var lines = _n0;
		return A2(author$project$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
	});
var author$project$Utils$Highlighter$highlight = function (jsCode) {
	return A2(
		elm$core$Result$withDefault,
		A2(
			elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					elm$html$Html$text(jsCode)
				])),
		A2(
			elm$core$Result$map,
			author$project$SyntaxHighlight$toBlockHtml(
				elm$core$Maybe$Just(1)),
			author$project$SyntaxHighlight$javascript(jsCode)));
};
var author$project$SyntaxHighlight$toInlineHtml = function (_n0) {
	var lines = _n0;
	return author$project$SyntaxHighlight$View$toInlineHtml(lines);
};
var author$project$Utils$Highlighter$highlightInline = function (jsCode) {
	return A2(
		elm$core$Result$withDefault,
		A2(
			elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					elm$html$Html$text(jsCode)
				])),
		A2(
			elm$core$Result$map,
			author$project$SyntaxHighlight$toInlineHtml,
			author$project$SyntaxHighlight$javascript(jsCode)));
};
var author$project$Utils$Highlighter$highlightSol = author$project$Utils$Highlighter$highlight;
var author$project$Utils$Highlighter$highlighted = A2(elm$html$Html$span, _List_Nil, _List_Nil);
var elm$html$Html$b = _VirtualDom_node('b');
var elm$html$Html$h3 = _VirtualDom_node('h3');
var elm$html$Html$h5 = _VirtualDom_node('h5');
var elm$html$Html$sup = _VirtualDom_node('sup');
var author$project$LandingSite$Developers$view = F3(
	function (userLanguage, configs, model) {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('documentation'),
					author$project$Utils$CompoundHtmlAttributes$id('documentation')
				]),
			_List_fromArray(
				[
					author$project$Utils$Highlighter$highlighted,
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('container-large')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('navigation')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#getting-started')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$getting_started(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctokens')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$ctokens(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#mint')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$mint(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#redeem')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$redeem(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#redeem-underlying')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$redeem_underlying(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#repay-borrow')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$repay_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#repay-borrow-behalf')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$repay_borrow_behalf(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidate-borrow')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$liquidate_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-events')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$key_events(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$error_codes(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-helpers')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$ctoken_helpers(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exchange_rate(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#cash')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_cash(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-borrows')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-balance')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_balance(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_rate(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-supply')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_supply(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-balance')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_balance(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-rate')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_rate(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-reserves')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_reserves(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#reserve-factor')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$reserve_factor(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$comptroller(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$enter_markets(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exit-market')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exit_market(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#assets-in')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_assets_in(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_account_liquidity(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller-events')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$key_events(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller-error-codes')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$error_codes(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#appendix')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$appendix(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$collateral(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exponential-math')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exponential_math(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#gas-costs')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$gas_costs(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('subsection')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#glossary')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$glossary(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('section')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#support')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$support(userLanguage))
														]))
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-sm-9 content')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('getting-started')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														elm$html$Html$h1,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text(
																author$project$Strings$Translations$compound_presidio(userLanguage))
															])),
														A2(
														elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text(
																author$project$Strings$Translations$docs_presidio_description(userLanguage))
															])),
														A2(
														elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text(
																author$project$Strings$Translations$docs_for_more_information(userLanguage)),
																A2(
																elm$html$Html$a,
																A2(
																	author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	author$project$LandingSite$Page$getHrefUrl(
																		author$project$LandingSite$Page$DevelopersAPI(elm$core$Maybe$Nothing))),
																_List_fromArray(
																	[
																		elm$html$Html$text(
																		author$project$Strings$Translations$docs_compound_api_docs(userLanguage))
																	])),
																elm$html$Html$text('.')
															])),
														A2(
														elm$html$Html$h2,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text(
																author$project$Strings$Translations$getting_started(userLanguage))
															])),
														A2(
														elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text(
																author$project$Strings$Translations$docs_supported_networks(userLanguage))
															]))
													]),
												author$project$LandingSite$Developers$contractsView(configs))),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('ctokens')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$ctokens(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_ctokens_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_ctokens_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_ctokens_description1_part3(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_ctokens_description2(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_ctokens_description3(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('mint')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$mint(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_mint_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_mint_description1_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_description1_part4(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_mint_description2(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function mint(uint mintAmount) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('mintAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_mint_amount_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_mint_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_mint_prereq_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_prereq_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_mint_prereq_description_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function mint() payable'),
													A2(
													elm$html$Html$ul,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('payable')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.value')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_payable_msg_value_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_payable_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_mint_payable_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('Erc20 underlying = Erc20(0xToken...);     // get a handle for the underlying asset contract\nCErc20 cToken = CErc20(0x3FDA...);        // get a handle for the corresponding cToken contract\nunderlying.approve(address(cToken), 100); // approve the transfer\nassert(cToken.mint(100) == 0);            // mint the cTokens and assert there is no error'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nawait cToken.methods.mint().send({from: myAccount, value: 50});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('redeem')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$redeem(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_description1_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_description1_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_description1_part5(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_description2(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function redeem(uint redeemTokens) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('redeemTokens')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_redeem_tokens_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_redeem_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeem(7) == 0, "something went wrong");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeem(1).send({from: ...});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('redeem-underlying')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$redeem_underlying(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_underlying_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_underlying_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_underlying_description1_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_underlying_description1_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_redeem_underlying_description1_part5(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function redeemUnderlying(uint redeemAmount) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_underlying_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('redeemAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_redeem_underlying_redeem_amount_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_redeem_underlying_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeemUnderlying(50) == 0, "something went wrong");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeemUnderlying(10).send({from: ...});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('borrow')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description1_part3(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description2_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_description2_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description2_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_description2_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description2_part5(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_description3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function borrow(uint borrowAmount) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_msg_value_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrowAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_borrow_amount_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_borrow_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CErc20(0x3FDA...);\nrequire(cToken.borrow(100) == 0, "got collateral?");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nawait cToken.methods.borrow(50).send({from: 0xMyAccount});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('repay-borrow')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$repay_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_description1(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function repayBorrow(uint repayAmount) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('repayAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_repay_amount_description1(userLanguage)),
																	A2(
																	elm$html$Html$sup,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_repay_borrow_repay_amount_description2(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_repay_amount_description3(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_repay_borrow_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_description2_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_description2_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_description2_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function repayBorrow() payable'),
													A2(
													elm$html$Html$ul,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('payable')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.value')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_payable_msg_value_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_payable_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_payable_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrow.value(100)() == 0, "transfer approved?");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.repayBorrow(10000).send({from: ...});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('repay-borrow-behalf')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$repay_borrow_behalf(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_behalf_description1(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function repayBorrowBehalf(address borrower, uint repayAmount) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrower')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_borrower_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('repayAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description1(userLanguage)),
																	A2(
																	elm$html$Html$sup,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description2(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description3(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_repay_borrow_behalf_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_repay_borrow_behalf_description2_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function repayBorrowBehalf(address borrower) payable'),
													A2(
													elm$html$Html$ul,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('payable')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.value')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_value_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrower')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_payable_borrower_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_repay_borrow_behalf_payable_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrowBehalf.value(100)(0xBorrower) == 0, "transfer approved?");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\nawait cToken.methods.repayBorrowBehalf(0xBorrower, 10000).send({from: 0xPayer});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('liquidate-borrow')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$liquidate_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description1_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description1_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description1_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description1_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description1_part5(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description1_part6(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description1_part7(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidation-incentive'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description1_part8(userLanguage))
																])),
															elm$html$Html$text('.')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description2_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#close-factor'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description2_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description2_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function liquidateBorrow(address borrower, uint amount, address collateral) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrower')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_borrower_description1(userLanguage)),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_liquidate_borrower_description2(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_borrower_description3(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('repayAmount')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_repay_amount_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('cTokenCollateral')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_ctoken_collateral_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_liquidate_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		]))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description3_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_description3_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_liquidate_description3_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function liquidateBorrow(address borrower, address cTokenCollateral) payable'),
													A2(
													elm$html$Html$ul,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('payable')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.value')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_msg_value_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrower')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_borrower_description1(userLanguage)),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_liquidate_payable_borrower_description2(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_borrower_description3(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('cTokenCollateral')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_ctoken_collateral_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_liquidate_payable_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nCErc20 cTokenCollateral = CErc20(0x3FDA...);\nrequire(cToken.liquidateBorrow.value(100)(0xBorrower, cTokenCollateral) == 0, "borrower underwater??");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\nconst cTokenCollateral = CEther.at(0x3FDB...);\nawait cToken.methods.liquidateBorrow(0xBorrower, 33, cTokenCollateral).send({from: 0xLiquidator});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('ctoken-events')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Key Events')
														])),
													A2(
													elm$html$Html$table,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Event')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Description')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Mint(address minter, uint mintTokens, uint mintAmount)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#mint'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Mint')
																						])),
																					elm$html$Html$text('.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Redeem(address redeemer, uint redeemTokens, uint redeemAmount)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#redeem'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Redeem')
																						])),
																					elm$html$Html$text('.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Borrow(address borrower, uint borrowAmount, uint accountBorrows, uint totalBorrows)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Borrow')
																						])),
																					elm$html$Html$text('.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('RepayBorrow(address payer, address borrower, uint repayAmount, uint accountBorrows, uint totalBorrows)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#repay-borrow'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Repay Borrow')
																						])),
																					elm$html$Html$text('.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LiquidateBorrow(address liquidator, address borrower, uint repayAmount, address cTokenCollateral, uint seizeTokens)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidate-borrow'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Liquidate Borrow')
																						])),
																					elm$html$Html$text('.')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('ctoken-error-codes')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Error Codes')
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('errors')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Error Code')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Error Name')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Further Details')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('green')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('0')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('NO_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Not a failure.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('1')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('UNAUTHORIZED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The sender is not authorized to perform this action.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('2')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BAD_INPUT')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('An invalid argument was supplied by the caller.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('3')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('COMPTROLLER_REJECTION')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The action would violate the comptroller policy.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('4')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('COMPTROLLER_CALCULATION_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('An internal calculation has failed in the comptroller.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('5')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INTEREST_RATE_MODEL_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The interest rate model returned an invalid value.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('6')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_ACCOUNT_PAIR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The specified combination of accounts is invalid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('7')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_CLOSE_AMOUNT_REQUESTED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The amount to liquidate is invalid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('8')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_COLLATERAL_FACTOR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The collateral factor is invalid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('9')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MATH_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('A math calculation error occurred.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('10')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MARKET_NOT_FRESH')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Interest has not been properly accrued.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('11')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MARKET_NOT_LISTED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The market is not currently listed by its comptroller.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('12')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOKEN_INSUFFICIENT_ALLOWANCE')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ERC-20 contract must *allow* Money Market contract to call `transferFrom`. The current allowance is either 0 or less than the requested supply, repayBorrow or liquidate amount.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('13')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOKEN_INSUFFICIENT_BALANCE')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Caller does not have sufficient balance in the ERC-20 contract to complete the desired action.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('14')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOKEN_INSUFFICIENT_CASH')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The market does not have a sufficient cash balance to complete the transaction. You may attempt this transaction again later.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('15')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOKEN_TRANSFER_IN_FAILED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure in ERC-20 when transfering token into the market.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('16')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOKEN_TRANSFER_OUT_FAILED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure in ERC-20 when transfering token out of the market.')
																				]))
																		]))
																]))
														])),
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Failure Info')
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('failure-infos')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure Code')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure Name')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('0')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCEPT_ADMIN_PENDING_ADMIN_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('1')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_ACCUMULATED_INTEREST_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('2')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_BORROW_RATE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('3')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_NEW_BORROW_INDEX_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('4')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_NEW_TOTAL_BORROWS_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('5')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_NEW_TOTAL_RESERVES_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('6')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCRUE_INTEREST_SIMPLE_INTEREST_FACTOR_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('7')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('8')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('9')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_CASH_NOT_AVAILABLE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('10')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('11')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('12')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('13')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_MARKET_NOT_LISTED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('14')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('BORROW_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('15')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_ACCRUE_BORROW_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('16')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_ACCRUE_COLLATERAL_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('17')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_COLLATERAL_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('18')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('19')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_COMPTROLLER_CALCULATE_AMOUNT_SEIZE_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('20')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_CLOSE_AMOUNT_IS_UINT_MAX')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('21')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_CLOSE_AMOUNT_IS_ZERO')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('22')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('23')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_LIQUIDATOR_IS_BORROWER')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('24')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_REPAY_BORROW_FRESH_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('25')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_SEIZE_BALANCE_INCREMENT_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('26')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_SEIZE_BALANCE_DECREMENT_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('27')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_SEIZE_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('28')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_SEIZE_LIQUIDATOR_IS_BORROWER')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('29')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('LIQUIDATE_SEIZE_TOO_MUCH')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('30')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('31')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('32')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_EXCHANGE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('33')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_EXCHANGE_RATE_READ_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('34')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('35')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('36')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_NEW_TOTAL_SUPPLY_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('37')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_TRANSFER_IN_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('38')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MINT_TRANSFER_IN_NOT_POSSIBLE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('39')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('40')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('41')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_EXCHANGE_TOKENS_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('42')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_EXCHANGE_AMOUNT_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('43')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_EXCHANGE_RATE_READ_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('44')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('45')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('46')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_NEW_TOTAL_SUPPLY_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('47')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDEEM_TRANSFER_OUT_NOT_POSSIBLE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('48')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDUCE_RESERVES_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('49')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDUCE_RESERVES_ADMIN_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('50')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDUCE_RESERVES_CASH_NOT_AVAILABLE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('51')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDUCE_RESERVES_FRESH_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('52')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REDUCE_RESERVES_VALIDATION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('53')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BEHALF_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('54')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('55')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('56')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('57')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_FRESHNESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('58')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('59')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('60')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REPAY_BORROW_TRANSFER_IN_NOT_POSSIBLE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('61')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('62')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_VALIDATION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('63')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COMPTROLLER_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('64')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_INTEREST_RATE_MODEL_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('65')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_INTEREST_RATE_MODEL_FRESH_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('66')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_INTEREST_RATE_MODEL_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('67')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_MAX_ASSETS_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('68')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_ORACLE_MARKET_NOT_LISTED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('69')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_PENDING_ADMIN_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('70')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_RESERVE_FACTOR_ACCRUE_INTEREST_FAILED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('71')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_RESERVE_FACTOR_ADMIN_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('72')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_RESERVE_FACTOR_FRESH_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('73')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_RESERVE_FACTOR_BOUNDS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('74')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TRANSFER_COMPTROLLER_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('75')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TRANSFER_NOT_ALLOWED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('76')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TRANSFER_NOT_ENOUGH')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('77')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TRANSFER_TOO_MUCH')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('ctoken-helpers')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$ctoken_helpers(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_ctoken_helpers_description(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('exchange-rate')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exchange_rate(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_exchange_rate_description(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('exchangeRate = (getCash() + totalBorrows() - totalReserves()) / totalSupply()'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function exchangeRateCurrent() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_exchange_rate_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint exchangeRateMantissa = cToken.exchangeRateCurrent();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst exchangeRate = (await cToken.methods.exchangeRateCurrent().call()) / 1e18;'),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Tip: note the use of '),
															A2(
															elm$html$Html$code,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('call')
																])),
															elm$html$Html$text(' vs. '),
															A2(
															elm$html$Html$code,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															elm$html$Html$text(' to invoke the function from off-chain without incurring gas costs.')
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('cash')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_cash(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cash_description(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function getCash() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_cash_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint cash = cToken.getCash();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst cash = (await cToken.methods.getCash().call());')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('total-borrows')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_borrow(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_total_borrow_description(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function totalBorrowsCurrent() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_total_borrow_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.totalBorrowsCurrent();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrows = (await cToken.methods.totalBorrowsCurrent().call());')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('borrow-balance')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_balance(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_balance_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_balance_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_balance_description_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function borrowBalanceCurrent(address account) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('account')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_balance_account_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_balance_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.borrowBalanceCurrent(msg.caller);'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrows = await cToken.methods.borrowBalanceCurrent(account).call();')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('borrow-rate')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_rate(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_borrow_rate_description(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function borrowRatePerBlock() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_borrow_rate_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint borrowRateMantissa = cToken.borrowRatePerBlock();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrowRate = (await cToken.methods.borrowRatePerBlock().call()) / 1e18;')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('total-supply')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_supply(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_total_supply_description(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function totalSupply() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_total_supply_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.totalSupply();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst tokens = (await cToken.methods.totalSupply().call());')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('supply-balance')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_balance(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_description_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_description_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_description_part5(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function balanceOf(address account) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('account')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_account_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.balanceOf(msg.caller);'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst tokens = await cToken.methods.balanceOf(account).call();')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('supply-balance-underlying')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_balance_underlying(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_underlying_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-balance'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_underlying_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_underlying_description_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_underlying_description_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_balance_underlying_description_part5(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('function balanceOfUnderlying(address account) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('account')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_underlying_account_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_balance_underlying_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.balanceOfUnderlying(msg.caller);'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst tokens = await cToken.methods.balanceOfUnderlying(account).call();')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('supply-rate')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_rate(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_rate_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_rate_description_part2(userLanguage))
																])),
															elm$html$Html$text(', '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#reserve-factor'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_rate_description_part3(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_supply_rate_description_part4(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-borrows'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_rate_description_part5(userLanguage))
																])),
															elm$html$Html$text('.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function supplyRatePerBlock() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_supply_rate_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint supplyRateMantissa = cToken.supplyRatePerBlock();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst supplyRate = (await cToken.methods.supplyRatePerBlock().call()) / 1e18;')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('total-reserves')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$total_reserves(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_total_reserves_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#cash'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_total_reserves_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_total_reserves_description_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#reserve-factor'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_total_reserves_description_part4(userLanguage))
																])),
															elm$html$Html$text('.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function totalReserves() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_total_reserves_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint reserves = cToken.totalReserves();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst reserves = (await cToken.methods.totalReserves().call());')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('reserve-factor')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$reserve_factor(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_reserve_factor_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-reserves'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_reserve_factor_description_part2(userLanguage))
																])),
															elm$html$Html$text('.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_cerc20(userLanguage)),
															elm$html$Html$text(' / '),
															elm$html$Html$text(
															author$project$Strings$Translations$cether(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function reserveFactorMantissa() returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_reserve_factor_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('CErc20 cToken = CToken(0x3FDA...);\nuint reserveFactorMantissa = cToken.reserveFactorMantissa();'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst reserveFactor = (await cToken.methods.reserveFactorMantissa().call()) / 1e18;')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('comptroller')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$comptroller(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description1(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description2_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral-factor'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_comptroller_description2_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description2_part3(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description3_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_comptroller_description3_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description3_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exit-market'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_comptroller_description3_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_comptroller_description3_part5(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('enter-markets')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$enter_markets(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_enter_markets_description1(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$comptroller(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function enterMarkets(address[] calldata cTokens) returns (uint[] memory)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_enter_markets_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('cTokens')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_enter_markets_ctokens_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_enter_markets_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		])),
																	elm$html$Html$text('.')
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('Comptroller troll = Comptroller(0xABCD...);\nCToken[] memory cTokens = new CToken[](2);\ncTokens[0] = CErc20(0x3FDA...);\ncTokens[1] = CEther(0x3FDB...);\nuint[] memory errors = troll.enterMarkets(cTokens);'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst cTokens = [CErc20.at(0x3FDA...), CEther.at(0x3FDB...)];\nconst errors = await troll.methods.enterMarkets(cTokens).send({from: ...});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('exit-market')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exit_market(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_exit_market_description(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$comptroller(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function exitMarket(address cToken) returns (uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('msg.sender')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_exit_market_msg_sender_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('cTokens')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_exit_market_ctoken_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	A2(author$project$Strings$Translations$docs_exit_market_return_description, userLanguage, '')),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$error_codes(userLanguage))
																		])),
																	elm$html$Html$text('.')
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('Comptroller troll = Comptroller(0xABCD...);\nuint error = troll.exitMarket(CToken(0x3FDA...));'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst errors = await troll.methods.exitMarket(CEther.at(0x3FDB...)).send({from: ...});')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('assets-in')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_assets_in(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_assets_in_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_assets_in_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_assets_in_description_part3(userLanguage))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$comptroller(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function getAssetsIn(address account) view returns (address[] memory)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('account')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_assets_in_account_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_assets_in_return_description(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('"Comptroller troll = Comptroller(0xABCD...);\naddress[] memory markets = troll.getAssetsIn(0xMyAccount);'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst markets = await troll.methods.getAssetsIn(cTokens).call();')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('account-liquidity')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$get_assets_in(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_account_liquidity_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral-factor'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_account_liquidity_description_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_description_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_account_liquidity_description_part5(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_account_liquidity_description2(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_account_liquidity_description3(userLanguage))
														])),
													author$project$Utils$Highlighter$highlightInline('function getAccountLiquidity(address account) view returns (uint, uint, uint)'),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('account')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_account_description(userLanguage))
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$b,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('RETURN')
																		])),
																	elm$html$Html$text(' - '),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_return_description1(userLanguage)),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_account_liquidity_return_description2(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_return_description3(userLanguage)),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_account_liquidity_return_description4(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_return_description5(userLanguage)),
																	A2(
																	elm$html$Html$a,
																	A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral'),
																	_List_fromArray(
																		[
																			elm$html$Html$text(
																			author$project$Strings$Translations$docs_account_liquidity_return_description6(userLanguage))
																		])),
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_account_liquidity_return_description7(userLanguage))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$solidity(userLanguage))
														])),
													author$project$Utils$Highlighter$highlight('Comptroller troll = Comptroller(0xABCD...);\n(uint error, uint liquidity, uint shortfall) = troll.getAccountLiquidity(msg.caller);\nrequire(error == 0, "join the Discord");\nrequire(shortfall == 0, "account underwater");\nrequire(liquidity > 0, "account has excess collateral");'),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Web3 1.0')
														])),
													author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst result = await troll.methods.getAccountLiquidity(0xBorrower).call();\nconst {0: error, 1: liquidity, 2: shortfall} = result;')
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('comptroller-events')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Key Events')
														])),
													A2(
													elm$html$Html$table,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Event')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Description')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MarketEntered(CToken cToken, address account)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Enter Market')
																						])),
																					elm$html$Html$text('.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('event')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MarketExited(CToken cToken, address account)')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Emitted upon a successful '),
																					A2(
																					elm$html$Html$a,
																					A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#exit-market'),
																					_List_fromArray(
																						[
																							elm$html$Html$text('Exit Market')
																						])),
																					elm$html$Html$text('.')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('comptroller-error-codes')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Error Codes')
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('errors')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Error Code')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Error Name')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Further Details')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('green')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('0')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('NO_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Not a failure.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('1')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('UNAUTHORIZED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The sender is not authorized to perform this action.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('2')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('COMPTROLLER_MISMATCH')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Liquidation cannot be performed in markets with different comptrollers.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('3')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INSUFFICIENT_SHORTFALL')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The account does not have sufficient shortfall to perform this action.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('4')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INSUFFICIENT_LIQUIDITY')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The account does not have sufficient liquidity to perform this action.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('5')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_CLOSE_FACTOR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The close factor is not valid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('6')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_COLLATERAL_FACTOR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The collateral factor is not valid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('7')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('INVALID_LIQUIDATION_INCENTIVE')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The liquidation incentive is invalid.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('8')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MARKET_NOT_ENTERED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The market has not been entered by the account.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('9')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MARKET_NOT_LISTED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The market is not currently listed by the comptroller.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('10')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MARKET_ALREADY_LISTED')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('An admin tried to list the same market more than once.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('11')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('MATH_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('A math calculation error occurred.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('12')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('NONZERO_BORROW_BALANCE')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The action cannot be performed since the account carries a borrow balance.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('13')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('PRICE_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The comptroller could not obtain a required price of an asset.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('14')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('REJECTION')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The comptroller rejects the action requested by the market.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('15')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SNAPSHOT_ERROR')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The comptroller could not get the account borrows and exchange rate from the market.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('16')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOO_MANY_ASSETS')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Attempted to enter more markets than are currently supported.')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('17')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('TOO_MUCH_REPAY')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Attempted to repay more than is allowed by the protocol.')
																				]))
																		]))
																]))
														])),
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Failure Info')
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('failure-infos')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure Code')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Failure Name')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('0')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCEPT_ADMIN_PENDING_ADMIN_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('1')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('ACCEPT_PENDING_IMPLEMENTATION_ADDRESS_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('2')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('EXIT_MARKET_BALANCE_OWED')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('3')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('EXIT_MARKET_REJECTION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('4')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_CLOSE_FACTOR_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('5')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_CLOSE_FACTOR_VALIDATION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('6')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('7')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_NO_EXISTS')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('8')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_VALIDATION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('9')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_COLLATERAL_FACTOR_WITHOUT_PRICE')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('10')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_IMPLEMENTATION_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('11')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_LIQUIDATION_INCENTIVE_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('12')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_LIQUIDATION_INCENTIVE_VALIDATION')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('13')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_MAX_ASSETS_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('14')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_PENDING_ADMIN_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('15')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_PENDING_IMPLEMENTATION_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('16')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SET_PRICE_ORACLE_OWNER_CHECK')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('17')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SUPPORT_MARKET_EXISTS')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('18')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('SUPPORT_MARKET_OWNER_CHECK')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('appendix')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$appendix(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_appendix_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#support'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_appendix_description_part2(userLanguage))
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('collateral')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$collateral(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_collateral_description1(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_collateral_description2(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('exponential-math')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$exponential_math(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															A2(author$project$Strings$Translations$docs_exponential_math_description, userLanguage, '')),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-money-market/blob/master/contracts/Exponential.sol'),
															_List_fromArray(
																[
																	elm$html$Html$text('Exponential.sol')
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('gas-costs')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$gas_costs(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_gas_costs_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_gas_costs_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_gas_costs_description_part3(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_gas_costs_description_part4(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_gas_costs_description_part5(userLanguage))
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('costs')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Function')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Typical Gas Cost')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Mint')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('< 90K')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Redeem, Transfer')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('< 250K if borrowing, otherwise < 90K')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Borrow')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('< 300K')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Repay Borrow')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('< 90K')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Liquidate Borrow')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('< 400K')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('glossary')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$glossary(userLanguage))
														])),
													A2(
													elm$html$Html$table,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('definitions')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$thead,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Term')
																				])),
																			A2(
																			elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Description')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('collateral-factor')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Collateral Factor')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The amount of an asset that may be borrowed for each unit of collateral provided.                  The collateral factor is defined per market.                ')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('close-factor')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Close Factor')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The portion of a borrow in a single market that may be closed by a liquidator during a single liquidation.                  For example, if Joe borrows 100 ZRX and the close factor is 0.3, then a liquidator may close 30 ZRX.                  The close factor is globally defined across all markets.                ')
																				]))
																		])),
																	A2(
																	elm$html$Html$tr,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('liquidation-incentive')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('Liquidation Incentive')
																				])),
																			A2(
																			elm$html$Html$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('The additional collateral given to liquidators as an incentive to perform liquidation of underwater accounts.                  For example, if the liquidation incentive is 1.1, liquidators receive an extra 10% of the borrowers collateral for every unit they close.                  The liquidation incentive is globally defined across all markets.                ')
																				]))
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('support')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$support(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$docs_support_description_part1(userLanguage)),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$docs_support_description_part2(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$docs_support_description_part3(userLanguage))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var author$project$Utils$RenderHelper$toAttribute = function (_n0) {
	var name = _n0.a;
	var value = _n0.b;
	return A2(elm$html$Html$Attributes$attribute, name, value);
};
var elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$node = elm$virtual_dom$VirtualDom$node;
var author$project$Utils$RenderHelper$toVirtualDom = function (nodes) {
	return A2(elm$core$List$map, author$project$Utils$RenderHelper$toVirtualDomEach, nodes);
};
var author$project$Utils$RenderHelper$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			if ((((node.a === 'code') && node.c.b) && (!node.c.a.$)) && (!node.c.b.b)) {
				var attrs = node.b;
				var _n1 = node.c;
				var s = _n1.a.a;
				return author$project$Utils$Highlighter$highlight(s);
			} else {
				var name = node.a;
				var attrs = node.b;
				var children = node.c;
				return A3(
					elm$html$Html$node,
					name,
					A2(elm$core$List$map, author$project$Utils$RenderHelper$toAttribute, attrs),
					author$project$Utils$RenderHelper$toVirtualDom(children));
			}
		case 0:
			var s = node.a;
			return elm$html$Html$text(s);
		default:
			return elm$html$Html$text('');
	}
};
var elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
	});
var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
var hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$chompIf(fn),
		elm$parser$Parser$chompWhile(fn));
};
var hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000d') || ((c === '\u000c') || (c === '\u00a0')))));
};
var hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				elm$core$String$toLower(closingName),
				name) ? elm$parser$Parser$succeed(0) : elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		elm$parser$Parser$getChompedString(
			hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('<')),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('/'))),
				chompName),
			elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		elm$parser$Parser$chompIf(
			elm$core$Basics$eq('>')));
};
var elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toToken = function (str) {
	return A2(
		elm$parser$Parser$Advanced$Token,
		str,
		elm$parser$Parser$Expecting(str));
};
var elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var elm$parser$Parser$Advanced$chompUntil = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$findSubString, str, s.b, s.cw, s.bK, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A4(elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.e)) : A3(
			elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.b, newOffset) < 0,
			0,
			{bK: newCol, e: s.e, g: s.g, b: newOffset, cw: newRow, a: s.a});
	};
};
var elm$parser$Parser$chompUntil = function (str) {
	return elm$parser$Parser$Advanced$chompUntil(
		elm$parser$Parser$toToken(str));
};
var elm$parser$Parser$token = function (str) {
	return elm$parser$Parser$Advanced$token(
		elm$parser$Parser$toToken(str));
};
var hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var hecrj$html_parser$Html$Parser$comment = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(hecrj$html_parser$Html$Parser$Comment),
			elm$parser$Parser$token('<!')),
		elm$parser$Parser$token('--')),
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompUntil('-->')),
		elm$parser$Parser$token('-->')));
var elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2(elm$core$List$member, name, hecrj$html_parser$Html$Parser$voidElements);
};
var hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$map,
						function (_new) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, _new, list));
						},
						parser_),
						elm$parser$Parser$succeed(
						elm$parser$Parser$Done(
							elm$core$List$reverse(list)))
					]));
		});
};
var hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	elm$parser$Parser$map,
	elm$core$String$toLower,
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var hecrj$html_parser$Html$Parser$chompSemicolon = elm$parser$Parser$chompIf(
	elm$core$Basics$eq(';'));
var hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\ud835\udd04'),
			_Utils_Tuple2('afr', '\ud835\udd1e'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\ud835\udd38'),
			_Utils_Tuple2('aopf', '\ud835\udd52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\ud835\udc9c'),
			_Utils_Tuple2('ascr', '\ud835\udcb6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\ud835\udd05'),
			_Utils_Tuple2('bfr', '\ud835\udd1f'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\ud835\udd39'),
			_Utils_Tuple2('bopf', '\ud835\udd53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\ud835\udcb7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\ud835\udd20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\ud835\udd54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\ud835\udc9e'),
			_Utils_Tuple2('cscr', '\ud835\udcb8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\ud835\udd07'),
			_Utils_Tuple2('dfr', '\ud835\udd21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\ud835\udd3b'),
			_Utils_Tuple2('dopf', '\ud835\udd55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\ud835\udc9f'),
			_Utils_Tuple2('dscr', '\ud835\udcb9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\ud835\udd08'),
			_Utils_Tuple2('efr', '\ud835\udd22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\ud835\udd3c'),
			_Utils_Tuple2('eopf', '\ud835\udd56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\ud835\udd09'),
			_Utils_Tuple2('ffr', '\ud835\udd23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\ud835\udd3d'),
			_Utils_Tuple2('fopf', '\ud835\udd57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\ud835\udcbb'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\ud835\udd0a'),
			_Utils_Tuple2('gfr', '\ud835\udd24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\ud835\udd3e'),
			_Utils_Tuple2('gopf', '\ud835\udd58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\ud835\udca2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200a'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\ud835\udd25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\ud835\udd59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\ud835\udcbd'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\ud835\udd26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\ud835\udd40'),
			_Utils_Tuple2('iopf', '\ud835\udd5a'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\ud835\udcbe'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\ud835\udd0d'),
			_Utils_Tuple2('jfr', '\ud835\udd27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\ud835\udd41'),
			_Utils_Tuple2('jopf', '\ud835\udd5b'),
			_Utils_Tuple2('Jscr', '\ud835\udca5'),
			_Utils_Tuple2('jscr', '\ud835\udcbf'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\ud835\udd0e'),
			_Utils_Tuple2('kfr', '\ud835\udd28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\ud835\udd42'),
			_Utils_Tuple2('kopf', '\ud835\udd5c'),
			_Utils_Tuple2('Kscr', '\ud835\udca6'),
			_Utils_Tuple2('kscr', '\ud835\udcc0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\ud835\udd0f'),
			_Utils_Tuple2('lfr', '\ud835\udd29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\ud835\udd43'),
			_Utils_Tuple2('lopf', '\ud835\udd5d'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200e'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\ud835\udcc1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205f'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\ud835\udd10'),
			_Utils_Tuple2('mfr', '\ud835\udd2a'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\ud835\udd44'),
			_Utils_Tuple2('mopf', '\ud835\udd5e'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\ud835\udcc2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00a0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200b'),
			_Utils_Tuple2('NegativeThickSpace', '\u200b'),
			_Utils_Tuple2('NegativeThinSpace', '\u200b'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200b'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\ud835\udd11'),
			_Utils_Tuple2('nfr', '\ud835\udd2b'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00a0'),
			_Utils_Tuple2('nopf', '\ud835\udd5f'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\ud835\udca9'),
			_Utils_Tuple2('nscr', '\ud835\udcc3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\ud835\udd12'),
			_Utils_Tuple2('ofr', '\ud835\udd2c'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\ud835\udd46'),
			_Utils_Tuple2('oopf', '\ud835\udd60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\ud835\udcaa'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\ud835\udd13'),
			_Utils_Tuple2('pfr', '\ud835\udd2d'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\ud835\udd61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\ud835\udcab'),
			_Utils_Tuple2('pscr', '\ud835\udcc5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\ud835\udd14'),
			_Utils_Tuple2('qfr', '\ud835\udd2e'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\ud835\udd62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\ud835\udcac'),
			_Utils_Tuple2('qscr', '\ud835\udcc6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\ud835\udd2f'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200f'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\ud835\udd63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\ud835\udcc7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\ud835\udd16'),
			_Utils_Tuple2('sfr', '\ud835\udd30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00ad'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\ud835\udd4a'),
			_Utils_Tuple2('sopf', '\ud835\udd64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\ud835\udcae'),
			_Utils_Tuple2('sscr', '\ud835\udcc8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\ud835\udd17'),
			_Utils_Tuple2('tfr', '\ud835\udd31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205f\u200a'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\ud835\udd4b'),
			_Utils_Tuple2('topf', '\ud835\udd65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\ud835\udcaf'),
			_Utils_Tuple2('tscr', '\ud835\udcc9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\ud835\udd18'),
			_Utils_Tuple2('ufr', '\ud835\udd32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\ud835\udd4c'),
			_Utils_Tuple2('uopf', '\ud835\udd66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\ud835\udcb0'),
			_Utils_Tuple2('uscr', '\ud835\udcca'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200a'),
			_Utils_Tuple2('Vfr', '\ud835\udd19'),
			_Utils_Tuple2('vfr', '\ud835\udd33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\ud835\udd4d'),
			_Utils_Tuple2('vopf', '\ud835\udd67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\ud835\udcb1'),
			_Utils_Tuple2('vscr', '\ud835\udccb'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\ud835\udd1a'),
			_Utils_Tuple2('wfr', '\ud835\udd34'),
			_Utils_Tuple2('Wopf', '\ud835\udd4e'),
			_Utils_Tuple2('wopf', '\ud835\udd68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\ud835\udcb2'),
			_Utils_Tuple2('wscr', '\ud835\udccc'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\ud835\udd1b'),
			_Utils_Tuple2('xfr', '\ud835\udd35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\ud835\udd4f'),
			_Utils_Tuple2('xopf', '\ud835\udd69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\ud835\udcb3'),
			_Utils_Tuple2('xscr', '\ud835\udccd'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\ud835\udd1c'),
			_Utils_Tuple2('yfr', '\ud835\udd36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\ud835\udd50'),
			_Utils_Tuple2('yopf', '\ud835\udd6a'),
			_Utils_Tuple2('Yscr', '\ud835\udcb4'),
			_Utils_Tuple2('yscr', '\ud835\udcce'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200b'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\ud835\udd37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\ud835\udd6b'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\ud835\udcb5'),
			_Utils_Tuple2('zscr', '\ud835\udccf'),
			_Utils_Tuple2('zwj', '\u200d'),
			_Utils_Tuple2('zwnj', '\u200c')
		]));
var hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	elm$parser$Parser$map,
	function (reference) {
		return A2(
			elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2(elm$core$Dict$get, reference, hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(elm$core$Char$isAlpha)));
var elm$core$Char$fromCode = _Char_fromCode;
var elm$core$String$cons = _String_cons;
var elm$core$String$fromChar = function (_char) {
	return A2(elm$core$String$cons, _char, '');
};
var elm$parser$Parser$ExpectingInt = {$: 1};
var elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var elm$core$String$toFloat = _String_toFloat;
var elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {bK: s.bK + (newOffset - s.b), e: s.e, g: s.g, b: newOffset, cw: s.cw, a: s.a};
	});
var elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3(elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2(elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3(elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			elm$parser$Parser$Advanced$consumeExp,
			A2(elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2(elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _n0, s) {
		var endOffset = _n0.a;
		var n = _n0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A2(elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.b, startOffset) < 0,
				A2(elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2(elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2(elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.a);
		if (floatOffset < 0) {
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A4(elm$parser$Parser$Advanced$fromInfo, s.cw, s.bK - (floatOffset + s.b), invalid, s.e));
		} else {
			if (_Utils_eq(s.b, floatOffset)) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5(elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.b, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							elm$parser$Parser$Advanced$Bad,
							true,
							A2(elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _n1 = elm$core$String$toFloat(
							A3(elm$core$String$slice, s.b, floatOffset, s.a));
						if (_n1.$ === 1) {
							return A2(
								elm$parser$Parser$Advanced$Bad,
								true,
								A2(elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _n1.a;
							return A3(
								elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2(elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 48, s.b, s.a)) {
			var zeroOffset = s.b + 1;
			var baseOffset = zeroOffset + 1;
			return A3(elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dt,
				c.dl,
				baseOffset,
				A2(elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dt,
				c.cf,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.dt,
				c.bE,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.a),
				s) : A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.dt,
				c.bR,
				c.b0,
				c.bT,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.dt,
				c.bR,
				c.b0,
				c.bT,
				A3(elm$parser$Parser$Advanced$consumeBase, 10, s.b, s.a),
				s);
		}
	};
};
var elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return elm$parser$Parser$Advanced$number(
			{
				bE: elm$core$Result$Err(invalid),
				bR: expecting,
				bT: elm$core$Result$Err(invalid),
				dl: elm$core$Result$Err(invalid),
				b0: elm$core$Result$Ok(elm$core$Basics$identity),
				dt: invalid,
				cf: elm$core$Result$Err(invalid)
			});
	});
var elm$parser$Parser$int = A2(elm$parser$Parser$Advanced$int, elm$parser$Parser$ExpectingInt, elm$parser$Parser$ExpectingInt);
var elm$core$Char$isHexDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(xs);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return elm$core$Result$Err(
				f(e));
		}
	});
var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return elm$core$Result$Err(
							elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var rtfeldman$elm_hex$Hex$fromString = function (str) {
	if (elm$core$String$isEmpty(str)) {
		return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2(elm$core$String$startsWith, '-', str)) {
				var list = A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(
						elm$core$String$toList(str)));
				return A2(
					elm$core$Result$map,
					elm$core$Basics$negate,
					A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					rtfeldman$elm_hex$Hex$fromStringHelp,
					elm$core$String$length(str) - 1,
					elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2(elm$core$Result$mapError, formatError, result);
	}
};
var hecrj$html_parser$Html$Parser$hexadecimal = A2(
	elm$parser$Parser$andThen,
	function (hex) {
		var _n0 = rtfeldman$elm_hex$Hex$fromString(
			elm$core$String$toLower(hex));
		if (!_n0.$) {
			var value = _n0.a;
			return elm$parser$Parser$succeed(value);
		} else {
			var error = _n0.a;
			return elm$parser$Parser$problem(error);
		}
	},
	elm$parser$Parser$getChompedString(
		hecrj$html_parser$Html$Parser$chompOneOrMore(elm$core$Char$isHexDigit)));
var hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompWhile(
						elm$core$Basics$eq('0'))),
				elm$parser$Parser$int)
			]));
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq('#'))),
		A2(
			elm$parser$Parser$map,
			A2(elm$core$Basics$composeR, elm$core$Char$fromCode, elm$core$String$fromChar),
			codepoint));
}();
var hecrj$html_parser$Html$Parser$characterReference = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$chompIf(
			elm$core$Basics$eq('&'))),
	elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$backtrackable(hecrj$html_parser$Html$Parser$namedCharacterReference),
				hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$backtrackable(hecrj$html_parser$Html$Parser$numericCharacterReference),
				hecrj$html_parser$Html$Parser$chompSemicolon),
				elm$parser$Parser$succeed('&')
			])));
var hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq(quote))),
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$map,
				elm$core$String$join(''),
				hecrj$html_parser$Html$Parser$many(
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								elm$parser$Parser$getChompedString(
								hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								hecrj$html_parser$Html$Parser$characterReference
							])))),
			elm$parser$Parser$chompIf(
				elm$core$Basics$eq(quote))));
};
var hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$map,
							function (_new) {
								return elm$parser$Parser$Loop(
									A2(elm$core$List$cons, _new, list));
							},
							parser_),
							elm$core$List$isEmpty(list) ? elm$parser$Parser$problem('expecting at least one ' + type_) : elm$parser$Parser$succeed(
							elm$parser$Parser$Done(
								elm$core$List$reverse(list)))
						]));
			});
	});
var hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		elm$parser$Parser$map,
		elm$core$String$join(''),
		A2(
			hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						elm$parser$Parser$getChompedString(
						hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var hecrj$html_parser$Html$Parser$tagAttributeValue = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('='))),
				elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			elm$parser$Parser$succeed('')
		]));
var hecrj$html_parser$Html$Parser$tagAttribute = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$keeper,
		elm$parser$Parser$succeed(elm$core$Tuple$pair),
		A2(
			elm$parser$Parser$ignorer,
			hecrj$html_parser$Html$Parser$tagAttributeName,
			elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		elm$parser$Parser$ignorer,
		hecrj$html_parser$Html$Parser$tagAttributeValue,
		elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var hecrj$html_parser$Html$Parser$tagAttributes = hecrj$html_parser$Html$Parser$many(hecrj$html_parser$Html$Parser$tagAttribute);
var hecrj$html_parser$Html$Parser$tagName = A2(
	elm$parser$Parser$map,
	elm$core$String$toLower,
	elm$parser$Parser$getChompedString(
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$chompIf(elm$core$Char$isAlphaNum),
			elm$parser$Parser$chompWhile(
				function (c) {
					return elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var hecrj$html_parser$Html$Parser$text = A2(
	elm$parser$Parser$map,
	A2(
		elm$core$Basics$composeR,
		elm$core$String$join(''),
		hecrj$html_parser$Html$Parser$Text),
	A2(
		hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					elm$parser$Parser$getChompedString(
					hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					hecrj$html_parser$Html$Parser$characterReference
				]))));
function hecrj$html_parser$Html$Parser$cyclic$node() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				hecrj$html_parser$Html$Parser$text,
				hecrj$html_parser$Html$Parser$comment,
				hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		elm$parser$Parser$andThen,
		function (_n0) {
			var name = _n0.a;
			var attributes = _n0.b;
			return hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A3(hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								elm$parser$Parser$chompIf(
								elm$core$Basics$eq('/')),
								elm$parser$Parser$succeed(0)
							]))),
				elm$parser$Parser$chompIf(
					elm$core$Basics$eq('>'))) : A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(hecrj$html_parser$Html$Parser$Element, name, attributes)),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('>'))),
				A2(
					elm$parser$Parser$ignorer,
					hecrj$html_parser$Html$Parser$many(
						elm$parser$Parser$backtrackable(
							hecrj$html_parser$Html$Parser$cyclic$node())),
					hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Tuple$pair),
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq('<'))),
				A2(
					elm$parser$Parser$ignorer,
					hecrj$html_parser$Html$Parser$tagName,
					elm$parser$Parser$chompWhile(hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			hecrj$html_parser$Html$Parser$tagAttributes));
}
var hecrj$html_parser$Html$Parser$node = hecrj$html_parser$Html$Parser$cyclic$node();
hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return hecrj$html_parser$Html$Parser$node;
};
var hecrj$html_parser$Html$Parser$element = hecrj$html_parser$Html$Parser$cyclic$element();
hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return hecrj$html_parser$Html$Parser$element;
};
var hecrj$html_parser$Html$Parser$run = function (str) {
	return elm$core$String$isEmpty(str) ? elm$core$Result$Ok(_List_Nil) : A2(
		elm$parser$Parser$run,
		A2(hecrj$html_parser$Html$Parser$oneOrMore, 'node', hecrj$html_parser$Html$Parser$node),
		str);
};
var author$project$LandingSite$DevelopersAPI$renderDescription = function (description) {
	return A2(
		elm$core$Result$withDefault,
		A2(elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			elm$core$Result$map,
			elm$html$Html$div(_List_Nil),
			A2(
				elm$core$Result$map,
				author$project$Utils$RenderHelper$toVirtualDom,
				hecrj$html_parser$Html$Parser$run(description))));
};
var author$project$LandingSite$DevelopersAPI$renderLink = F2(
	function (isSectionHeader, name) {
		var cls = isSectionHeader ? 'section' : 'subsection';
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class(cls)
				]),
			A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#' + name));
		return A2(
			elm$html$Html$a,
			attrs,
			_List_fromArray(
				[
					elm$html$Html$text(name)
				]));
	});
var elm$html$Html$small = _VirtualDom_node('small');
var author$project$LandingSite$DevelopersAPI$renderField = function (_n0) {
	var name = _n0.dA;
	var description = _n0.A;
	var fieldType = _n0.P;
	return A2(
		elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text(fieldType)
							]))
					])),
				A2(
				elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(name)
					])),
				A2(
				elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						author$project$LandingSite$DevelopersAPI$renderDescription(description)
					]))
			]));
};
var author$project$LandingSite$DevelopersAPI$renderMessage = F2(
	function (isToc, message) {
		return isToc ? A2(author$project$LandingSite$DevelopersAPI$renderLink, false, message.dA) : A2(
			elm$html$Html$section,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('function'),
					author$project$Utils$CompoundHtmlAttributes$id(message.dA)
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(message.dA)
						])),
					author$project$LandingSite$DevelopersAPI$renderDescription(message.A),
					A2(
					elm$html$Html$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$tbody,
							_List_Nil,
							A2(elm$core$List$map, author$project$LandingSite$DevelopersAPI$renderField, message.bS))
						]))
				]));
	});
var elm$core$Dict$values = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2(elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var author$project$LandingSite$DevelopersAPI$renderMethod = F3(
	function (messages, isToc, method) {
		var restMessagesHtml = A2(
			elm$core$List$map,
			author$project$LandingSite$DevelopersAPI$renderMessage(isToc),
			elm$core$Dict$values(
				A2(
					elm$core$Dict$remove,
					method.cv,
					A2(elm$core$Dict$remove, method.ct, messages))));
		var responseMessageHtml = A2(
			elm$core$Maybe$withDefault,
			A2(elm$html$Html$div, _List_Nil, _List_Nil),
			A2(
				elm$core$Maybe$map,
				author$project$LandingSite$DevelopersAPI$renderMessage(isToc),
				A2(elm$core$Dict$get, method.cv, messages)));
		var requestMessageHtml = A2(
			elm$core$Maybe$withDefault,
			A2(elm$html$Html$div, _List_Nil, _List_Nil),
			A2(
				elm$core$Maybe$map,
				author$project$LandingSite$DevelopersAPI$renderMessage(isToc),
				A2(elm$core$Dict$get, method.ct, messages)));
		return isToc ? _Utils_ap(
			_List_fromArray(
				[requestMessageHtml, responseMessageHtml]),
			restMessagesHtml) : _List_fromArray(
			[
				elm$html$Html$text(method.dA),
				requestMessageHtml,
				responseMessageHtml,
				A2(elm$html$Html$div, _List_Nil, restMessagesHtml)
			]);
	});
var author$project$LandingSite$DevelopersAPI$serviceView = F3(
	function (messages, isToc, service) {
		var rest = elm$core$List$concat(
			A2(
				elm$core$List$map,
				A2(author$project$LandingSite$DevelopersAPI$renderMethod, messages, isToc),
				A2(
					elm$core$List$filter,
					A2(
						elm$core$Basics$composeR,
						function ($) {
							return $.dA;
						},
						A2(
							elm$core$Basics$composeR,
							elm$core$String$startsWith('post_'),
							elm$core$Basics$not)),
					service.dy)));
		return isToc ? _Utils_ap(
			_List_fromArray(
				[
					A2(author$project$LandingSite$DevelopersAPI$renderLink, true, service.dA)
				]),
			rest) : _List_fromArray(
			[
				A2(
				elm$html$Html$section,
				_List_fromArray(
					[
						author$project$Utils$CompoundHtmlAttributes$id(service.dA)
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text(service.dA)
							])),
						author$project$LandingSite$DevelopersAPI$renderDescription(service.A),
						A2(elm$html$Html$div, _List_Nil, rest)
					]))
			]);
	});
var author$project$LandingSite$DevelopersAPI$docView = F2(
	function (doc, isToc) {
		return elm$core$List$concat(
			A2(
				elm$core$List$map,
				A2(author$project$LandingSite$DevelopersAPI$serviceView, doc.dw, isToc),
				elm$core$Dict$values(doc.dQ)));
	});
var author$project$LandingSite$DevelopersAPI$docsView = F3(
	function (protoDoc, docs, isToc) {
		return elm$core$List$concat(
			A2(
				elm$core$List$map,
				function (docName) {
					var _n0 = A2(elm$core$Dict$get, docName, protoDoc);
					if (_n0.$ === 1) {
						return _List_Nil;
					} else {
						var doc = _n0.a;
						return A2(author$project$LandingSite$DevelopersAPI$docView, doc, isToc);
					}
				},
				docs));
	});
var author$project$LandingSite$DevelopersAPI$protos = _List_fromArray(
	['account.proto', 'ctoken.proto', 'market_history_api.proto']);
var author$project$LandingSite$DevelopersAPI$view = F2(
	function (userLanguage, _n0) {
		var protoDoc = _n0.aM;
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('documentation')
				]),
			_List_fromArray(
				[
					author$project$Utils$Highlighter$highlighted,
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('container-large')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('navigation')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														elm$html$Html$a,
														_Utils_ap(
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('section selected')
																]),
															A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#compound-api')),
														_List_fromArray(
															[
																elm$html$Html$text('Compound API')
															]))
													]),
												_Utils_ap(
													A3(author$project$LandingSite$DevelopersAPI$docsView, protoDoc, author$project$LandingSite$DevelopersAPI$protos, true),
													_List_fromArray(
														[
															A2(
															elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		author$project$Utils$CompoundHtmlAttributes$class('section')
																	]),
																A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#SharedDataTypes')),
															_List_fromArray(
																[
																	elm$html$Html$text('Shared Data Types')
																])),
															A2(
															elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		author$project$Utils$CompoundHtmlAttributes$class('subsection')
																	]),
																A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#PaginationSummary')),
															_List_fromArray(
																[
																	elm$html$Html$text('Pagination Summary')
																])),
															A2(
															elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		author$project$Utils$CompoundHtmlAttributes$class('subsection')
																	]),
																A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '#Precise')),
															_List_fromArray(
																[
																	elm$html$Html$text('Precise')
																]))
														]))))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-sm-9 content')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('compound-api')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Compound API')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('The Compound API input and output formats are specified by '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://developers.google.com/protocol-buffers/'),
															_List_fromArray(
																[
																	elm$html$Html$text('Protocol Buffers')
																])),
															elm$html$Html$text(', known colloquially as protobufs. Unlike typical protobufs endpoints, the Compound endpoints support JSON for input and output in addition to the protobufs binary format. To use JSON in both the input and the output, specify the headers '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('\"Content-Type: application/json\"')
																])),
															elm$html$Html$text('and '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('\"Accept: application/json\"')
																])),
															elm$html$Html$text('in the request.')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Please request an API key from Compound in the #development channel in our '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
															_List_fromArray(
																[
																	elm$html$Html$text('Discord')
																])),
															elm$html$Html$text('. It should be included in the HTTP header '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('compound-api-key')
																])),
															elm$html$Html$text('. We require separate api keys for staging and production.')
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											A3(author$project$LandingSite$DevelopersAPI$docsView, protoDoc, author$project$LandingSite$DevelopersAPI$protos, false)),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('SharedDataTypes')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Shared Data Types')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Custom data types that are shared between services.')
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function'),
													author$project$Utils$CompoundHtmlAttributes$id('PaginationSummary')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Pagination Summary ')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Used for paginating results.')
														])),
													A2(
													elm$html$Html$table,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	author$project$LandingSite$DevelopersAPI$renderField(
																	{A: 'The current page number', P: 'uint32', R: '', dA: 'page_number'}),
																	author$project$LandingSite$DevelopersAPI$renderField(
																	{A: 'The number of entries to show per page.', P: 'uint32', R: '', dA: 'page_size'}),
																	author$project$LandingSite$DevelopersAPI$renderField(
																	{A: 'The number of items matching the request across all pages.', P: 'uint32', R: '', dA: 'total_entries'}),
																	author$project$LandingSite$DevelopersAPI$renderField(
																	{A: 'The number of pages need to show total_entries at the given page_size.', P: 'uint32', R: '', dA: 'total_pages'})
																]))
														]))
												])),
											A2(
											elm$html$Html$section,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function'),
													author$project$Utils$CompoundHtmlAttributes$id('Precise')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Precise ')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('For non-negative numbers only.')
														])),
													A2(
													elm$html$Html$table,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tbody,
															_List_Nil,
															_List_fromArray(
																[
																	author$project$LandingSite$DevelopersAPI$renderField(
																	{A: 'The full UNSIGNED number in string form. max value is 2^257 - 1,aka 231584178474632390847141970017375815706539969331281128078915168015826259279871', P: 'string', R: '', dA: 'value'})
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var elm$html$Html$br = _VirtualDom_node('br');
var elm$html$Html$em = _VirtualDom_node('em');
var elm$html$Html$i = _VirtualDom_node('i');
var author$project$LandingSite$DevelopersLegacy$view = A2(
	elm$html$Html$div,
	_List_fromArray(
		[
			author$project$Utils$CompoundHtmlAttributes$class('documentation')
		]),
	_List_fromArray(
		[
			A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('container-large')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('navigation')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#getting-started'),
											_List_fromArray(
												[
													elm$html$Html$text('Getting Started')
												])),
											A2(
											elm$html$Html$a,
											A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#money-market'),
											_List_fromArray(
												[
													elm$html$Html$text('Money Market')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#supply-function')),
											_List_fromArray(
												[
													elm$html$Html$text('Supply')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#withdraw')),
											_List_fromArray(
												[
													elm$html$Html$text('Withdraw')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#borrow-function')),
											_List_fromArray(
												[
													elm$html$Html$text('Borrow')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#repay-borrow')),
											_List_fromArray(
												[
													elm$html$Html$text('Repay Borrow')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#get-account-liquidity')),
											_List_fromArray(
												[
													elm$html$Html$text('Get Account Liquidity')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#get-supply-balance')),
											_List_fromArray(
												[
													elm$html$Html$text('Get Supply Balance')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#get-borrow-balance')),
											_List_fromArray(
												[
													elm$html$Html$text('Get Borrow Balance')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#liquidate')),
											_List_fromArray(
												[
													elm$html$Html$text('Liquidate')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#definitions')),
											_List_fromArray(
												[
													elm$html$Html$text('Definitions')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#error-codes')),
											_List_fromArray(
												[
													elm$html$Html$text('Error codes')
												])),
											A2(
											elm$html$Html$a,
											A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#compound-api'),
											_List_fromArray(
												[
													elm$html$Html$text('Compound API')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#risk-api')),
											_List_fromArray(
												[
													elm$html$Html$text('Risk API')
												])),
											A2(
											elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('subsection')
													]),
												A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#market-history-api')),
											_List_fromArray(
												[
													elm$html$Html$text('Market History API')
												])),
											A2(
											elm$html$Html$a,
											A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#support'),
											_List_fromArray(
												[
													elm$html$Html$text('Support')
												]))
										]))
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('col-sm-9 content')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('getting-started')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Getting Started')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The Compound protocol is currently deployed on Mainnet and the Rinkeby testnet.')
												])),
											A2(
											elm$html$Html$table,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Contract')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('ABI')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Address')
																		]))
																]))
														])),
													A2(
													elm$html$Html$tbody,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('contract')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('MoneyMarket')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('ABI')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$a,
																			A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/abis/legacy/MoneyMarket'),
																			_List_fromArray(
																				[
																					elm$html$Html$text('JSON')
																				]))
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('amount'),
																					author$project$Utils$CompoundHtmlAttributes$id('money_market_contract_address')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('0x3fda67f7583380e67ef93072294a7fac882fd7e7                ')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('contract')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('PriceOracle')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('ABI')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$a,
																			A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/abis/legacy/PriceOracle'),
																			_List_fromArray(
																				[
																					elm$html$Html$text('JSON')
																				]))
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('amount'),
																					author$project$Utils$CompoundHtmlAttributes$id('price_oracle_contract_address')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('0x02557a5e05defeffd4cae6d83ea3d173b272c904                ')
																				]))
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('contract')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('InterestRateModel')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('ABI')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$a,
																			A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/abis/legacy/StandardInterestRateModel'),
																			_List_fromArray(
																				[
																					elm$html$Html$text('JSON')
																				]))
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$div,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('amount'),
																					author$project$Utils$CompoundHtmlAttributes$id('standard_interest_rate_model_contract_address')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('0xd25c029a607ee888bdbdbe054515e25ec6f3fff9                ')
																				]))
																		]))
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('money-market')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Money Market')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The Money Market is the primary smart contract used to interact with the Compound Protocol. The primary functions of the protocol are as follows:')
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('supply-function')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Supply')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supply')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('uint amount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token to be supplied.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('amount')
																])),
															elm$html$Html$text('- The amount of the asset to be supplied specified in the smallest unit available for the asset. For example, amount should be specified in wei for a user for wrapped ether.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- 0 on success, otherwise an '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#error-codes'),
															_List_fromArray(
																[
																	elm$html$Html$text('error code')
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Before supplying an asset, users must first '),
													A2(
													elm$html$Html$i,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('approve')
														])),
													elm$html$Html$text('the Money Market to access their token balance.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The supply function transfers an asset into the Money Market, which begins accumulating interest based on the current supply rate for the asset.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															elm$html$Html$text('token '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															elm$html$Html$text('xToken'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('approve')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('address')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('uint errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supply')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supply')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('address'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('50')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('from')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(':')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('on')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token string')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('\'transactionHash\'')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('trxHash'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`View your supply trx at: https://etherscan.io/tx/')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('trxHash'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('withdraw')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Withdraw')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('withdraw')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('uint requestedAmount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token to be withdrawn.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('amount')
																])),
															elm$html$Html$text('- The amount of the asset to be withdrawn specified in the smallest unit available for the asset. For example, amount should be specified in wei for a user withdrawing wrapped ether. A value of '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#-1'),
															_List_fromArray(
																[
																	elm$html$Html$text('-1')
																])),
															elm$html$Html$text('can be used to withdraw the maximum amount allowed.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- 0 on success, otherwise an '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#error-codes'),
															_List_fromArray(
																[
																	elm$html$Html$text('error code')
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The withdraw function transfers an asset from the Money Market to the user, reducing the user\'s supply balance.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The amount withdrawn must be less than the user\'s '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#account-liquidity'),
													_List_fromArray(
														[
															elm$html$Html$text('account liquidity')
														])),
													elm$html$Html$text('and the market\'s available liquidity. Specifying an amount of '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#-1'),
													_List_fromArray(
														[
															elm$html$Html$text('-1')
														])),
													elm$html$Html$text('withdraws the maximum quantity of tokens available.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// Ensure you have a balance which was supplied, see `supply` above')
																])),
															elm$html$Html$text('uint errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('withdraw')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('withdraw')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('address'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('50')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('from')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(':')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('on')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token string')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('\'transactionHash\'')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('trxHash'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`View your withdraw trx at: https://etherscan.io/tx/')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('trxHash'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('borrow-function')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Borrow')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('borrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('uint amount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token to be borrowed.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('amount')
																])),
															elm$html$Html$text('- The amount of the asset to be borrowed specified in the smallest unit available for the asset. For example, amount should be specified in wei for a user borrowing wrapped ether.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- 0 on success, otherwise an '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#error-codes'),
															_List_fromArray(
																[
																	elm$html$Html$text('error code')
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The borrow function transfers an asset from the Money Market to the user, which begins accumulating interest based on the current borrow rate for the asset.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The amount borrowed must be less than the user\'s '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#borrow-capacity'),
													_List_fromArray(
														[
															elm$html$Html$text('borrow capacity')
														])),
													elm$html$Html$text('and the market\'s available liquidity.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Users must maintain a '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#collateral-requirement'),
													_List_fromArray(
														[
															elm$html$Html$text('collateral requirement')
														])),
													elm$html$Html$text('to avoid liquidation.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// Ensure you have a balance which was supplied, see `supply` above')
																])),
															elm$html$Html$text('uint errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('borrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('balance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('borrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('address'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('50')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('from')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(':')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('on')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token string')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('\'transactionHash\'')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('trxHash'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`View your borrow trx at: https://etherscan.io/tx/')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('trxHash'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('repay-borrow')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Repay Borrow')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('repayBorrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('uint amount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('Asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token to be repaid.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('Amount')
																])),
															elm$html$Html$text('- The amount of the asset to be repaid specified in the smallest unit available for the asset. For example, amount should be specified in Wei for a user desiring to repay Wrapped Ether. A value of -1 can be used to repay the maximum amount allowed.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- 0 on Success, otherwise a failure. ')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Before repaying a borrowed asset, users must first '),
													A2(
													elm$html$Html$i,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('approve')
														])),
													elm$html$Html$text('the Money Market to access their token balance.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The repay function transfers an asset into the Money Market, reducing the user\'s borrow balance. Users may specify an amount of '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#-1'),
													_List_fromArray(
														[
															elm$html$Html$text('-1')
														])),
													elm$html$Html$text('in order to repay the maximum tokens available.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															elm$html$Html$text('token '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															elm$html$Html$text('xToken'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('token'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('approve')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('address')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('uint errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('repayBorrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('100')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('balance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('borrowBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('repayBorrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('tokenB'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('address'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('50')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('from')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(':')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('on')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token string')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('\'transactionHash\'')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('trxHash'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`View your repay borrow trx at: https://etherscan.io/tx/')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('trxHash'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('get-account-liquidity')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Get Account Liquidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getAccountLiquidity')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															elm$html$Html$text('view '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('int'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('account')
																])),
															elm$html$Html$text('- The address of the user\'s Compound Protocol account.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- Signed integer where a positive value indicates the user\'s available '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text('account liquidity')
																])),
															elm$html$Html$text('. A negative value, however, indicates the user is below his/her '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#collateral-requirement'),
															_List_fromArray(
																[
																	elm$html$Html$text('collateral requirement')
																])),
															elm$html$Html$text('and this shortfall may be liquidated to bring the user back to a positive account liquidity.')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Within the Compound Protocol, account liquidity is defined as the total value of a user\'s supply balances subtracted by the total value of that user\'s borrow balances multiplied by the protocol            '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#collateral-ratio'),
													_List_fromArray(
														[
															elm$html$Html$text('collateral ratio')
														])),
													elm$html$Html$text('. Users who do not have positive account liquidity do not have the ability to withdraw or borrow any assets until they bring their account liquidity back positive by supplying more assets or paying back outstanding borrows. A negative value for account liquidity also means the user is subject to liquidation to bring their account liquidity back to zero.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The return value of this function is a signed integer denominated in eth-wei (i.e. a real scaled by 1e18 and truncated). For example, a user who has only supplied 0.1 eth into the protocol and has no outstanding borrows would have an account liquidity of 0.1e18 = 1e17 = 100000000000000000.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// user does supplies and borrows')
																])),
															elm$html$Html$text('int accountLiquidity '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getAccountLiquidity')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// assert user\'s account is in good standing')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('accountLiquidity '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('>=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getAccountLiquidity')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('call')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('then')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('liquidity'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`Account ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('account'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('has ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('liquidity'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('liquidity. This account is ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('liquidity '),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token operator')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('>')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token number')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('0')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token operator')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('?')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token string')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('\'safe\'')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text(':')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token string')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('\'at risk\'')
																				])),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('.`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('get-supply-balance')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Get Supply Balance')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getSupplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															elm$html$Html$text('view '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('account')
																])),
															elm$html$Html$text('- The address of the user\'s Compound Protocol account where he/she originally supplied assets from')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token originally supplied by the user for which to obtain the current balance')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- The user\'s current supply balance (with interest) for the specified asset given in the smallest unit available for the asset')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('A user who supplies assets into the protocol accumulates interest based on the continuous supply rate. Interest is accumulated every block and integrations may use `getSupplyBalance` to check the user\'s supply balance with interest.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Note: a user may not be able to withdraw his or her entire supply balance if that user has an outstanding borrow and therefore must maintain a '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#collateral-requirement'),
													_List_fromArray(
														[
															elm$html$Html$text('collateral requirement')
														])),
													elm$html$Html$text('.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// user does supplies and borrows')
																])),
															elm$html$Html$text('uint currentSupplyBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getSupplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// assert user\'s account has a non-zero supply')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('currentSupplyBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('>=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('asset '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getSupplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('call')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('then')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('supplyBalance'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`Account ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('account'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('has ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('supplyBalance'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('supply balance of ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('asset'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('get-borrow-balance')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Get Borrow Balance')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getBorrowBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('address asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															elm$html$Html$text('view '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('account')
																])),
															elm$html$Html$text('- The address of the user\'s Compound Protocol account where he/she originally borrowed assets from')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('- The address of the ERC-20 token originally borrowed by the user for which to obtain the current balance for')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- The user\'s current borrow balance (with interest) for the specified asset given in the smallest unit available for the asset')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('A user who borrows assets from the protocol is subject to accumulated interest based on the current continuous borrow rate. Interest is accumulated every block and integrations may use `getBorrowBalance` to obtain the current value of a user\'s borrow balance with interest, which will be updated every block.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// user does supplies and borrows')
																])),
															elm$html$Html$text('uint currentBorrowBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getBorrowBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('caller'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// assert user\'s account has a non-zero borrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('currentBorrowBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('>=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('account '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('asset '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('getBorrowBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('account'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('asset'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('call')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('then')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('borrowBalance'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`Account ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('account'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('has ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('borrowBalance'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrow balance of ')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('asset'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('liquidate')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$id('liquidation')
												]),
											_List_fromArray(
												[
													elm$html$Html$text('Liquidate')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' signature language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('function')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('liquidateBorrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('address targetAccount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('address assetBorrow'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('address assetCollateral'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('uint requestedAmountClose'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('public')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('returns')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('uint'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																]))
														]))
												])),
											A2(
											elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('targetAccount')
																])),
															elm$html$Html$text('- The address of the liquidatee\'s Compound Protocol account that currently has negative '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text('account liquidity')
																]))
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('assetBorrow')
																])),
															elm$html$Html$text('- The address of an ERC-20 token originally borrowed by the liquidatee which currently has an outstanding balance')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('assetCollateral')
																])),
															elm$html$Html$text('- The address of an ERC-20 token currently held as collateral by a liquidatee that the liquidator wishes to seize')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('requestedAmountClose')
																])),
															elm$html$Html$text('- The amount of the borrowed asset to be repaid specified in the smallest unit available for the asset. For example, amount should be specified in wei for a liquidator desiring to liquidate a wrapped ether borrow. A value of '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#-1'),
															_List_fromArray(
																[
																	elm$html$Html$text('-1')
																])),
															elm$html$Html$text('can be used to liquidate the maximum amount allowed of the liquidatee\'s outstanding borrow balance given their current collateral balance and negative '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#account-liquidity'),
															_List_fromArray(
																[
																	elm$html$Html$text('account liquidity')
																])),
															elm$html$Html$text('remaining.')
														])),
													A2(
													elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('RETURN')
																])),
															elm$html$Html$text('- 0 on success, otherwise an '),
															A2(
															elm$html$Html$a,
															A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#error-codes'),
															_List_fromArray(
																[
																	elm$html$Html$text('error code')
																])),
															elm$html$Html$text('.')
														]))
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('A user who has negative '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#account-liquidity'),
													_List_fromArray(
														[
															elm$html$Html$text('account liquidity')
														])),
													elm$html$Html$text('is subject to '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#liquidation'),
													_List_fromArray(
														[
															elm$html$Html$text('liquidation')
														])),
													elm$html$Html$text('by other users of the protocol to return his/her account liquidity back to 0 (i.e., exactly at the '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#collateral-requirement'),
													_List_fromArray(
														[
															elm$html$Html$text('collateral requirement')
														])),
													elm$html$Html$text('), reducing the risk of that account. When a liquidation occurs, a liquidator may repay some or all of an outstanding borrow on behalf of a liquidatee and in return receive a discounted amount of collateral held by the liquidatee; this discount is defined as the '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#liquidation-discount'),
													_List_fromArray(
														[
															elm$html$Html$text('liquidation discount')
														])),
													elm$html$Html$text(', and at launch will be 5%.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('As with many other functions, you can specify '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '#-1'),
													_List_fromArray(
														[
															elm$html$Html$text('-1')
														])),
													elm$html$Html$text('to close as much of the borrow as possible. This is provided since it\'s impossible to know '),
													A2(
													elm$html$Html$em,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('exactly')
														])),
													elm$html$Html$text('how much can be liquidated given the prices can move and interest grows in a few blocks before a transaction is accepted by Ethereum. Note, however, that you need a sufficient balance to close the entire position if you specify max. Otherwise: you should simply close the most that you can provide.')
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Solidity')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' solidity language-javascript')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('MoneyMarket moneyMarket '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('MoneyMarket')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															elm$html$Html$text('assetBorrow '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// asset target borrowed (in default)')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token constant')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('ERC20')
																])),
															elm$html$Html$text('assetCollateral '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// asset target supplied as collateral')
																])),
															elm$html$Html$text('address targetAccount '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// user to liquidate')
																])),
															elm$html$Html$text('uint requestAmountClose '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// amount (in wei) of asset borrow to close')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// track positions prior to liqudation')
																])),
															elm$html$Html$text('uint myBorrowWalletBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('assetBorrow'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('balanceOf')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('sender'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('uint myCollateralSupplyBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('sender'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('uint targetCollateralSupplyBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('targetAccount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('uint errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('liquidateBorrow')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('targetAccount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('address')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('assetBorrow'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('address')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('assetCollateral'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('requestAmountClose'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('errorCode '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('==')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// Liquidators wallet balance should decrease by amount of borrow closed')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('assetBorrow'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('balanceOf')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('sender'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															elm$html$Html$text('myBorrowWalletBalance '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('-')
																])),
															elm$html$Html$text('requestAmountClose'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// Delta in my (liquidators) supply balance in Compound as signed integer')
																])),
															elm$html$Html$text('int mySupplyChange '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('int')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('msg'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('sender'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('-')
																])),
															elm$html$Html$text('myCollateralSupplyBalance'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('mySupplyChange '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('int targetSupplyChange '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('int')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('supplyBalance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('targetAccount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('-')
																])),
															elm$html$Html$text('targetCollateralSupplyBalance'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// Verify liquidator received the target\'s collateral as supply balance')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('assert')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('mySupplyChange '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('-')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('1')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('*')
																])),
															elm$html$Html$text('targetSupplyChange'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												])),
											A2(
											elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Web3 1.0')
												])),
											A2(
											elm$html$Html$pre,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$code,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-javascript')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('myAccount '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// account of liquidator')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('targetAccount '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// account in default')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('assetBorrow '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// asset target borrowed (in default)')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('assetCollateral '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// asset target supplied as collateral')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('requestAmountClose '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token comment')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('// amount (in wei) of asset borrow to close')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('const')
																])),
															elm$html$Html$text('moneyMarket MoneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('at')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token number')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('0x3FDA')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('...')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															elm$html$Html$text('moneyMarket'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															elm$html$Html$text('methods'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('liquidiate')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('targetAccount'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('assetBorrow'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('assetCollateral'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															elm$html$Html$text('requestAmountClose'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('send')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('from')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(':')
																])),
															elm$html$Html$text('myAccount '),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('on')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token string')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('\'transactionHash\'')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(',')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															elm$html$Html$text('trxHash'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token operator')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('=>')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('{')
																])),
															elm$html$Html$text('console'),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('.')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token function')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('log')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('(')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token template-string')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`View your liquidation trx at: https://etherscan.io/tx/')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token interpolation')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('${')
																				])),
																			elm$html$Html$text('trxHash'),
																			A2(
																			elm$html$Html$span,
																			_List_fromArray(
																				[
																					author$project$Utils$CompoundHtmlAttributes$class('token interpolation-punctuation punctuation')
																				]),
																			_List_fromArray(
																				[
																					elm$html$Html$text('}')
																				]))
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('`')
																		]))
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text('}')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(')')
																])),
															A2(
															elm$html$Html$span,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(';')
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('definitions')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Defintions')
												])),
											A2(
											elm$html$Html$table,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Constant')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Description')
																		]))
																]))
														])),
													A2(
													elm$html$Html$tbody,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('collateral-ratio')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('collateral ratio')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The amount of supply value required to be held for each unit of borrow value to initiate an action (borrow, withdraw), must be strictly greater than 1, e.g. 2.0.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('liquidation-discount')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('liquidation discount')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('A multiplier representing the percent value that a user calling liquidate receives, e.g. 0.05 for 5%')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('borrow-fee')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrow fee')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The percent fee that a user originating a borrow has added to their balance, e.g. 0.0005.')
																		]))
																]))
														]))
												])),
											A2(elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											elm$html$Html$table,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Value')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Description')
																		]))
																]))
														])),
													A2(
													elm$html$Html$tbody,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('supply-current')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('supply current')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The user’s supply of a given asset, including accrued interest as of the current block')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('borrow-current')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrow current')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The user’s borrow of a given asset, including accrued interest as of the current block')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('account-liquidity')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('account liquidity')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The value of a user’s account, denominated in Ether, above the user’s collateral requirement')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('collateral-requirement')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('collateral requirement')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Similar to account liquidity above, but as a ratio of total supply value divided by total borrow value. Thus an account with collateralRequirement greater than collateralRatio is in good standing.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('withdraw-capacity')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('withdraw capacity')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The quantity of tokens, denominated in the specified asset, that the user is able to withdraw from Compound, or accountLiquidity divided by the oracle price of the asset.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('borrow-capacity')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('borrow capacity')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The quantity of tokens, denominated in the specified asset, that the user is able to borrow from Compound')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('shortfall')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('shortfall')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The amount of value, denominated in Ether, that a target user can have seized')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('aount-close')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('amount close')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The amount of asset that a target user can have closed')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('amount-seize')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('amount seize')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The amount of collateral, denominated in its own asset, to seize from a target user')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('total-supply')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('total supply')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The sum of supply of an asset in its respective money market, excluding accrued interest')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('total-borrow')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('total borrow')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The sum of borrow of an asset in its respective money market, excluding accrued interest')
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$table,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Item')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Description')
																		]))
																]))
														])),
													A2(
													elm$html$Html$tbody,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$id('-1')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('-1')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('2'),
																			A2(
																			elm$html$Html$sup,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('256')
																				])),
																			elm$html$Html$text('- 1, or the maximum value that can be stored in a 256-bit integer (0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF). The binary representation of the signed integer -1, so in Solidity, we often cast `uint(-1)` to obtain this value. In the Compound Protocol, the value of an operation may depend on the exact block it\'s mined in (e.g. if you want to withdraw, you accumlate interest each block, so you do not know how much '),
																			A2(
																			elm$html$Html$em,
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('exactly')
																				])),
																			elm$html$Html$text('how much balance you will have when your transaction is mined). For this reason, we allow users to specify this value in some operations to mean \"as much as possible.\" Thus, '),
																			A3(
																			elm$html$Html$node,
																			'tt',
																			_List_Nil,
																			_List_fromArray(
																				[
																					elm$html$Html$text('withdraw(asset, uint(-1))')
																				])),
																			elm$html$Html$text('will withdraw all available funds at the time the transaction is mined.')
																		]))
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('error-codes')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Error Codes')
												])),
											A2(
											elm$html$Html$table,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Error')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Description of Error')
																		])),
																	A2(
																	elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Further Details')
																		]))
																]))
														])),
													A2(
													elm$html$Html$tbody,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$tr,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class('green')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('0')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('NO_ERROR')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Not a failure.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('1')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('OPAQUE_ERROR')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('An error has occured in a third-party contract (see Detail field for more information)')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('2')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('UNAUTHORIZED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('You are not authorized for this action.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('3')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INTEGER_OVERFLOW')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Tried to add two numbers that summed greater than 10^32. (See Info for details)')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('4')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INTEGER_UNDERFLOW')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Tried to subtract a larger number from a smaller number (See Info for details)')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('5')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('DIVISION_BY_ZERO')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Division by zero is undefined.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('6')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('BAD_INPUT')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Unused')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('7')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('TOKEN_INSUFFICIENT_ALLOWANCE')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('ERC-20 contract must *allow* Money Market contract to call `transferFrom`. The current allowance is either 0 or less than the requested supply, repayBorrow or liquidate amount.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('8')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('TOKEN_INSUFFICIENT_BALANCE')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('You do not have sufficient balance in ERC-20 contract to complete the desired action.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('9')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('TOKEN_TRANSFER_FAILED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Failure in ERC-20 when transfering token into Compound Money Market.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('10')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('MARKET_NOT_SUPPORTED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('This market is not supported by Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('11')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('SUPPLY_RATE_CALCULATION_FAILED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('12')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('BORROW_RATE_CALCULATION_FAILED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('13')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('TOKEN_INSUFFICIENT_CASH')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The Money Market does not, itself, have a sufficient cash balance to complete the transaction. You may attempt this transaction again later.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('14')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('TOKEN_TRANSFER_OUT_FAILED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('An error occured in the ERC-20 contract\'s `transfer` function.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('15')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INSUFFICIENT_LIQUIDITY')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('You would violate your collateral ratio requirements by executing this withdraw, borrow or liquidate action.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('16')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INSUFFICIENT_BALANCE')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('You do not have a sufficient balance to complete with withdraw.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('17')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INVALID_COLLATERAL_RATIO')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('18')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('MISSING_ASSET_PRICE')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('The Price Oracle has encountered an error or is paused')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('19')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('EQUITY_INSUFFICIENT_BALANCE')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('20')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INVALID_CLOSE_AMOUNT_REQUESTED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('You are attempting to liquidate a borrow beyond just bringing it back to even.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('21')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('ASSET_NOT_PRICED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('22')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INVALID_LIQUIDATION_DISCOUNT')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('23')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('INVALID_COMBINED_RISK_PARAMETERS')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('24')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('ZERO_ORACLE_ADDRESS')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																])),
															A2(
															elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('25')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('CONTRACT_PAUSED')
																		])),
																	A2(
																	elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			elm$html$Html$text('Internal error in Compound.')
																		]))
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('compound-api')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Compound API')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('The Compound API input and output formats are specified by '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://developers.google.com/protocol-buffers/'),
													_List_fromArray(
														[
															elm$html$Html$text('Protocol Buffers')
														])),
													elm$html$Html$text(', known colloquially as protobufs. Unlike typical protobufs endpoints, the Compound endpoints support JSON for input and output in addition to the protobufs binary format. To use JSON in both the input and the output, specify the headers '),
													A3(
													elm$html$Html$node,
													'tt',
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('\"Content-Type: application/json\"')
														])),
													elm$html$Html$text('and '),
													A3(
													elm$html$Html$node,
													'tt',
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('\"Accept: application/json\"')
														])),
													elm$html$Html$text('in the request.')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Please request an API key from Compound in the #development channel in our '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
													_List_fromArray(
														[
															elm$html$Html$text('Discord')
														])),
													elm$html$Html$text('. It should be included in the HTTP header '),
													A3(
													elm$html$Html$node,
													'tt',
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('compound-api-key')
														])),
													elm$html$Html$text('. We require separate api keys for staging and production.')
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('risk-api')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Risk API')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('(View '),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/protos/risk_api_service-6f6fb45ef7b9c36b6d9664182a850c61.proto?vsn=d')),
													_List_fromArray(
														[
															elm$html$Html$text('Protobuf')
														])),
													elm$html$Html$text(')')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Compound provides a Risk API that lists the ETH-equivalent values of supplies and borrows for accounts using the protocol. The underlying data is read from the blockchain and cached on Compound servers. It is updated very frequently but, to support quickly listing multiple accounts at once, is not read in real-time from the blockchain. The freshness of the data for each account is indicated by the '),
													A3(
													elm$html$Html$node,
													'tt',
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('block_updated')
														])),
													elm$html$Html$text('element given for that account.')
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('get_top_account_values')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('get_top_account_values')
																])),
															elm$html$Html$text('lists the top 100 accounts by ETH-equivalent borrow value, sorted in ascending order of collateral ratio. The prices used to compute the supply and borrow values are from the Compound Price Oracle as of the '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('block_updated')
																])),
															elm$html$Html$text('element for each account.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Request (curl)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token function')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('curl')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Accept: application/json\"')
																		])),
																	elm$html$Html$text('\\  --header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"compound-api-key: YOUR_API_KEY\"')
																		])),
																	elm$html$Html$text('\\'),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"https://api.compound.finance/api/risk/v1/get_top_account_values\"')
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Response (JSON)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-json')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-json')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"error\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token null')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('null')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"account_values\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"81553945090485352055.24170417\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"16693079517105956316.92135530\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('2934324')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0x6646f6636d15381ad847dacb8e69cd765b17d899\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"8936991420766432438.660994608\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"4365064464045375106.433805073\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('2934324')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0x3605780992537dcaae52a8da39238d6d883b7009\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		]))
																]))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('get_account_values')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('get_account_values')
																])),
															elm$html$Html$text('returns a paginated list of accounts, sorted in ascending order of collateral ratio. The prices used to compute the supply and borrow values are from the Compound Price Oracle as of the block_updated element for each account. The request object allows the client to specify the page size, the page number (starting from 1) and, optionally:')
														])),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('a minimum borrow value (defaults to 0 if not provided by caller)')
																])),
															A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('a maximum collateral ratio (defaults to 2 if not provided by caller) Accounts with a borrow value <= the specified minimum will not be included in the results. Accounts with a collateral ratio > the specified max will not be included in the results.')
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Please note that '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('min_borrow_value_in_eth')
																])),
															elm$html$Html$text('should be given in wei units.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Request (curl)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token function')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('curl')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Content-Type: application/json\"')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Accept: application/json\"')
																		])),
																	elm$html$Html$text('\\--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"compound-api-key: YOUR_API_KEY\"')
																		])),
																	elm$html$Html$text('--request POST \\--data '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\'{\"page_size\":100,\"page_number\":1, \"min_borrow_value_in_eth\":{\"value\":\"0\"}, \"max_collateral_ratio\":{\"value\":\"2\"}}\'')
																		])),
																	elm$html$Html$text('\\'),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"https://api.compound.finance/api/risk/v1/get_account_values\"')
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Response (JSON)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-json')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-json')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"request\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"page_size\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('100')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"page_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"min_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"max_collateral_ratio\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"2\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"pagination_summary\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_pages\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_entries\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('5')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"page_size\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('100')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"page_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"error\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token null')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('null')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"account_values\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"468372752391553739.9868634122\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"248190748151699414.7614623254\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231505')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xfd72981e24356f3b2b01e1d0c18cc7fead37f432\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"23704306155318340590.84549900\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"11969103774659244013.22283866\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231503')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xb50eb12ecbe6371401f9b56c2aa12fe75c129d85\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"20640026912585.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"10379520700003.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231505')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0x0e73f1de0f0ef81a315da59a40fa3a7c46cc8806\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"32380495046773.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"16230334067560.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231505')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xc88b963239b6918f74c3298bb1dc079b92671e42\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"1001596347901916851.000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"501560339915348717.4224994298\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231505')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xd840d02bb3a715027343fc8428b61a7f83dcb6e7\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		]))
																]))
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('The request element echoes the inputs. The '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('pagination_summary')
																])),
															elm$html$Html$text('element provides the information needed to make subsequent requests to get more results. The '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('account_values')
																])),
															elm$html$Html$text('element holds the account value results for the current page.')
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('get_account_value')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('get_account_value')
																])),
															elm$html$Html$text('returns the value for a specified account. Note that it may take a few minutes for balances to be populated for a new account. Until that happens, '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('total_supply_value_in_eth')
																])),
															elm$html$Html$text('and '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('total_borrow_value_in_eth')
																])),
															elm$html$Html$text('will be null.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Request (curl)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token function')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('curl')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Content-Type: application/json\"')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Accept: application/json\"')
																		])),
																	elm$html$Html$text('\\--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"compound-api-key: YOUR_API_KEY\"')
																		])),
																	elm$html$Html$text('--request POST \\--data '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\'{\"account_address\":\"0xc88b963239b6918f74c3298bb1dc079b92671e42\"}\'')
																		])),
																	elm$html$Html$text('\\'),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"https://api.compound.finance/api/risk/v1/get_account_value\"')
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Response (JSON)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-json')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-json')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"error\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token null')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('null')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"account_value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"32380577799103.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrow_value_in_eth\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"16230478797408.00000000000000\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_updated\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('3231602')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"address\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xc88b963239b6918f74c3298bb1dc079b92671e42\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		]))
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('market-history-api')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Market History API')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('(View '),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/protos/market_history_service-638b2da5ff0fa0d7f931729dfc16cb65.proto?vsn=d')),
													_List_fromArray(
														[
															elm$html$Html$text('Protobuf')
														])),
													elm$html$Html$text(')')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Compound\'s Market History API provides graph data of the Compound Money Market interest rates, as well as total supplies and borrows. The caller of the API can choose the given time period and resolution of the data (e.g. 24 buckets over the last 24 hours).')
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('function')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('get_market_history_graph')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('get_market_history_graph')
																])),
															elm$html$Html$text('(and similarly '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('post_market_history_graph')
																])),
															elm$html$Html$text(') is the main function of the market history API. You should specify the address of the '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('asset')
																])),
															elm$html$Html$text('to pull interest rates for, '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('min_block_timestamp')
																])),
															elm$html$Html$text('and '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('max_block_timestamp')
																])),
															elm$html$Html$text('for a time range, and a '),
															A3(
															elm$html$Html$node,
															'tt',
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text('num_buckets')
																])),
															elm$html$Html$text('specifying the number of points to return in the graph.')
														])),
													A2(
													elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('The result will pull the interest rates, total supplies and total borrows for that asset over that period and return the average interest rate for each bucket. For instance, if we specified a window of the last 24-hours and asked for 24 buckets, the API would return the average interest rate, total supply and total borrows, per hour, over the last day.')
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Request (curl)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-bash')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token function')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('curl')
																		])),
																	elm$html$Html$text('--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"Accept: application/json\"')
																		])),
																	elm$html$Html$text('\\--header '),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"compound-api-key: YOUR_API_KEY\"')
																		])),
																	elm$html$Html$text('\\'),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"https://api.compound.finance/api/market_history/v1/graph?asset=0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2&min_block_timestamp=1540858322&max_block_timestamp=1541463122&num_buckets=2\"')
																		]))
																]))
														])),
													A2(
													elm$html$Html$h5,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text('Response (JSON)')
														])),
													A2(
													elm$html$Html$pre,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class(' language-json')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$code,
															_List_fromArray(
																[
																	author$project$Utils$CompoundHtmlAttributes$class(' language-json')
																]),
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_supply_history\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"8981126226710001902616\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540858325')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6608318')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"8981049821028419745151\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540873110')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6609334')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total_borrows_history\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"272244478219433219687\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540858325')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6608318')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"total\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"value\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"272310439587543455907\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540873110')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6609334')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"supply_rates\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"rate\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('0.0017359425269574235')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540858325')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6608318')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"rate\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('0.0017364723271263496')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540873110')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6609334')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"error\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"message\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"field_errors\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"error_code\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('0')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"borrow_rates\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('[')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"rate\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('0.06363898632293184')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540858325')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6608318')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('{')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"rate\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('0.06364240698739985')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_timestamp\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('1540873110')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"block_number\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token number')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('6609334')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(']')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(',')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token property')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"asset\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token operator')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(':')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token string')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('\"0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2\"')
																		])),
																	A2(
																	elm$html$Html$span,
																	_List_fromArray(
																		[
																			author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text('}')
																		]))
																]))
														]))
												]))
										])),
									A2(
									elm$html$Html$section,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$id('support')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('Support')
												])),
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text('For support requests, please reach out to us in the #development channel in our '),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
													_List_fromArray(
														[
															elm$html$Html$text('Discord')
														])),
													elm$html$Html$text('. We\'re happy to help out and build the Compound community.')
												]))
										]))
								]))
						]))
				]))
		]));
var author$project$Strings$Translations$api_caps = function (lang) {
	return 'API.';
};
var author$project$Strings$Translations$api_description = function (lang) {
	return ' A REST API for market and user data, in real-time.';
};
var author$project$Strings$Translations$avoid_credit_risk = function (lang) {
	return 'Avoid credit risk.';
};
var author$project$Strings$Translations$avoid_credit_risk_description = function (lang) {
	return ' Borrowers are overcollateralized, and every aspect of the Compound protocol is transparent in real-time. The way finance should be.';
};
var author$project$Strings$Translations$borrow_assets = function (lang) {
	return 'Borrow Assets';
};
var author$project$Strings$Translations$borrow_description = function (lang) {
	return 'Seamlessly borrow assets from the Compound protocol right to your wallet.';
};
var author$project$Strings$Translations$build_on_compound = function (lang) {
	return 'Build on Compound';
};
var author$project$Strings$Translations$built_for_developers = function (lang) {
	return 'The Compound Protocol was built for developers.';
};
var author$project$Strings$Translations$compound_description = function (lang) {
	return 'Compound is an open-source protocol for algorithmic, efficient Money Markets on the Ethereum blockchain.';
};
var author$project$Strings$Translations$compound_your_crypto = function (lang) {
	return 'Compound your Crypto';
};
var author$project$Strings$Translations$download_the_whitepaper = function (lang) {
	return 'Download the Whitepaper →';
};
var author$project$Strings$Translations$earn_best_rate = function (lang) {
	return 'Always earn the best rate.';
};
var author$project$Strings$Translations$earn_best_rate_description = function (lang) {
	return ' Interest rates adjust based on the supply and demand unique to each asset; as borrowing demand increases, so will the interest you earn.';
};
var author$project$Strings$Translations$earn_interest = function (lang) {
	return 'Earn Interest';
};
var author$project$Strings$Translations$instant_liquidity = function (lang) {
	return 'Instant liquidity.';
};
var author$project$Strings$Translations$instant_liquidity_description = function (lang) {
	return ' Borrow directly from the protocol, without waiting for a counterparty or peer. Compound is the fastest borrowing platform in the world.';
};
var author$project$Strings$Translations$learn_more = function (lang) {
	return 'Learn How →';
};
var author$project$Strings$Translations$our_whitepaper = function (lang) {
	return 'Our Whitepaper.';
};
var author$project$Strings$Translations$our_whitepaper_description = function (lang) {
	return ' A platform-agnostic approach to creating money markets.';
};
var author$project$Strings$Translations$protocol = function (lang) {
	return 'Protocol.';
};
var author$project$Strings$Translations$protocol_description = function (lang) {
	return ' A full specification of the Ethereum protocol and API services.';
};
var author$project$Strings$Translations$read_the_docs = function (lang) {
	return 'Read the Docs →';
};
var author$project$Strings$Translations$repay_at_own_pace = function (lang) {
	return 'Repay at your own pace.';
};
var author$project$Strings$Translations$repay_at_own_pace_description = function (lang) {
	return ' Don\'t worry about renewing or rolling over your financing; Compound allows you to borrow indefinitely, as long as you maintain sufficient collateral.';
};
var author$project$Strings$Translations$stay_fully_liquid = function (lang) {
	return 'Stay fully liquid.';
};
var author$project$Strings$Translations$stay_fully_liquid_description = function (lang) {
	return ' Assets are supplied to the protocol, which maintains excess liquidity -- not to another user. You can withdraw your tokens at any time (even 3am).';
};
var author$project$Strings$Translations$supply_description = function (lang) {
	return 'Supply assets to the Compound protocol and earn interest.';
};
var author$project$Strings$Translations$try_compound = function (lang) {
	return 'Try Compound';
};
var author$project$Strings$Translations$use_trade_short = function (lang) {
	return 'Use, trade, and short.';
};
var author$project$Strings$Translations$use_trade_short_description = function (lang) {
	return ' You can use borrowed tokens to run protocols, or to trade on your favorite exchange for other assets.';
};
var elm$core$Basics$ge = _Utils_ge;
var elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3(elm$core$String$slice, 0, -n, string);
	});
var elm$core$Bitwise$and = _Bitwise_and;
var elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3(elm$core$String$repeatHelp, n, chunk, '');
	});
var elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			elm$core$String$slice,
			-n,
			elm$core$String$length(string),
			string);
	});
var author$project$Decimal$insert_decimal_period = F2(
	function (pos, s) {
		var extra_zeros = pos - elm$core$String$length(s);
		var padded_s = (extra_zeros >= 0) ? _Utils_ap(
			A2(elm$core$String$repeat, extra_zeros + 1, '0'),
			s) : s;
		var before = A2(elm$core$String$dropRight, pos, padded_s);
		var after = A2(elm$core$String$right, pos, padded_s);
		return before + ('.' + after);
	});
var cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _n0 = _Utils_Tuple2(xs, ys);
			if (!_n0.a.b) {
				if (!_n0.b.b) {
					return A2(elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_n0.b.b) {
					return 2;
				} else {
					var _n1 = _n0.a;
					var x_ = _n1.a;
					var xss = _n1.b;
					var _n2 = _n0.b;
					var y_ = _n2.a;
					var yss = _n2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _n0 = _Utils_Tuple2(int1, int2);
		switch (_n0.a.$) {
			case 0:
				if (!_n0.b.$) {
					var mag1 = _n0.a.a;
					var mag2 = _n0.b.a;
					return A4(cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_n0.b.$ === 1) {
					var mag1 = _n0.a.a;
					var mag2 = _n0.b.a;
					return cmditch$elm_bigint$BigInt$orderNegate(
						A4(cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_n0.b.$) {
					case 0:
						var _n1 = _n0.a;
						return 0;
					case 2:
						var _n2 = _n0.a;
						var _n3 = _n0.b;
						return 1;
					default:
						var _n4 = _n0.a;
						return 2;
				}
		}
	});
var cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2(cmditch$elm_bigint$BigInt$compare, x, y);
	});
var cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2(cmditch$elm_bigint$BigInt$lt, x, y);
	});
var cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				elm$core$String$repeat,
				n - elm$core$String$length(string),
				elm$core$String$fromChar(_char)),
			string);
	});
var cmditch$elm_bigint$BigInt$fillZeroes = A2(
	elm$core$Basics$composeL,
	A2(elm$core$String$padLeft, cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	elm$core$String$fromInt);
var elm$core$String$concat = function (strings) {
	return A2(elm$core$String$join, '', strings);
};
var cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_n0) {
	var digits = _n0;
	var _n1 = elm$core$List$reverse(digits);
	if (!_n1.b) {
		return '0';
	} else {
		var x = _n1.a;
		var xs = _n1.b;
		return elm$core$String$concat(
			A2(
				elm$core$List$cons,
				elm$core$String$fromInt(x),
				A2(elm$core$List$map, cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var author$project$Decimal$toString = function (_n0) {
	var m = _n0.a;
	var e = _n0.b;
	var sign = A2(
		cmditch$elm_bigint$BigInt$gte,
		m,
		cmditch$elm_bigint$BigInt$fromInt(0)) ? '' : '-';
	var add_zeros = function (n) {
		return A2(elm$core$String$repeat, n, '0');
	};
	var abs_m = A2(
		cmditch$elm_bigint$BigInt$gte,
		m,
		cmditch$elm_bigint$BigInt$fromInt(0)) ? m : cmditch$elm_bigint$BigInt$negate(m);
	var s = cmditch$elm_bigint$BigInt$toString(abs_m);
	var _n1 = A2(elm$core$Basics$compare, e, 0);
	switch (_n1) {
		case 1:
			return _Utils_ap(sign, s);
		case 2:
			return _Utils_ap(
				sign,
				_Utils_ap(
					s,
					add_zeros(e)));
		default:
			return _Utils_ap(
				sign,
				A2(author$project$Decimal$insert_decimal_period, 0 - e, s));
	}
};
var author$project$Functions$default = F2(
	function (maybeVal, defaultVal) {
		if (!maybeVal.$) {
			var val = maybeVal.a;
			return val;
		} else {
			return defaultVal;
		}
	});
var author$project$Utils$NumberFormatter$dropRight = F2(
	function (dropChar, string) {
		var reducer = F2(
			function (nextChar, res) {
				if (res.$ === 1) {
					return _Utils_eq(nextChar, dropChar) ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(
						elm$core$String$fromChar(nextChar));
				} else {
					var str = res.a;
					return elm$core$Maybe$Just(
						A2(elm$core$String$cons, nextChar, str));
				}
			});
		return A2(
			author$project$Functions$default,
			A3(elm$core$String$foldr, reducer, elm$core$Maybe$Nothing, string),
			'');
	});
var author$project$Utils$NumberFormatter$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return (elm$core$String$length(value) > 3) ? A2(
			elm$core$List$cons,
			A2(elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2(elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var author$project$Utils$NumberFormatter$formatToDecimalPlaces = F3(
	function (decimalValue, decimalPlaces, dropZeros) {
		var floatString = author$project$Decimal$toString(decimalValue);
		var dropper = dropZeros ? author$project$Utils$NumberFormatter$dropRight('0') : function (i) {
			return i;
		};
		var _n0 = function () {
			var _n1 = A2(elm$core$String$split, '.', floatString);
			if (!_n1.b) {
				return _Utils_Tuple2('', '');
			} else {
				if (!_n1.b.b) {
					var headValue = _n1.a;
					return _Utils_Tuple2(
						A2(
							elm$core$String$join,
							',',
							author$project$Utils$NumberFormatter$splitThousands(headValue)),
						'');
				} else {
					if (!_n1.b.b.b) {
						var headValue = _n1.a;
						var _n2 = _n1.b;
						var tailValue = _n2.a;
						return _Utils_Tuple2(
							A2(
								elm$core$String$join,
								',',
								author$project$Utils$NumberFormatter$splitThousands(headValue)),
							A2(
								elm$core$String$left,
								decimalPlaces,
								dropper(tailValue)));
					} else {
						return _Utils_Tuple2('', '');
					}
				}
			}
		}();
		var digitString = _n0.a;
		var decimalString = _n0.b;
		var _n3 = elm$core$String$isEmpty(decimalString);
		if (_n3) {
			return digitString;
		} else {
			return digitString + ('.' + decimalString);
		}
	});
var author$project$Decimal$addDecimals = F2(
	function (i, _n0) {
		addDecimals:
		while (true) {
			var m = _n0.a;
			var e = _n0.b;
			var mul10 = function (x) {
				return A2(
					cmditch$elm_bigint$BigInt$mul,
					x,
					cmditch$elm_bigint$BigInt$fromInt(10));
			};
			if (!i) {
				return A2(author$project$Decimal$Decimal, m, e);
			} else {
				if (i > 0) {
					var $temp$i = i - 1,
						$temp$_n0 = A2(
						author$project$Decimal$Decimal,
						mul10(m),
						e - 1);
					i = $temp$i;
					_n0 = $temp$_n0;
					continue addDecimals;
				} else {
					return A2(author$project$Decimal$Decimal, m, e);
				}
			}
		}
	});
var author$project$Decimal$toExponent = F2(
	function (e, _n0) {
		var md = _n0.a;
		var ed = _n0.b;
		return A2(
			author$project$Decimal$addDecimals,
			ed - e,
			A2(author$project$Decimal$Decimal, md, ed));
	});
var elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var author$project$Decimal$toCommonExponent = function (_n0) {
	var a = _n0.a;
	var b = _n0.b;
	var _n1 = b;
	var mb = _n1.a;
	var eb = _n1.b;
	var _n2 = a;
	var ma = _n2.a;
	var ea = _n2.b;
	var exponent = A2(elm$core$Basics$min, ea, eb);
	return _Utils_Tuple2(
		A2(author$project$Decimal$toExponent, exponent, a),
		A2(author$project$Decimal$toExponent, exponent, b));
};
var author$project$Decimal$add = F2(
	function (a, b) {
		var _n0 = author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var ra = _n0.a;
		var rb = _n0.b;
		var _n1 = rb;
		var mb = _n1.a;
		var eb = _n1.b;
		var _n2 = ra;
		var ma = _n2.a;
		var ea = _n2.b;
		return A2(
			author$project$Decimal$Decimal,
			A2(cmditch$elm_bigint$BigInt$add, ma, mb),
			ea);
	});
var author$project$Decimal$getDigit = F2(
	function (n, d) {
		var decimalAsString = author$project$Decimal$toString(d);
		var toInt = function (targetDecimal) {
			switch (targetDecimal) {
				case '1':
					return 1;
				case '2':
					return 2;
				case '3':
					return 3;
				case '4':
					return 4;
				case '5':
					return 5;
				case '6':
					return 6;
				case '7':
					return 7;
				case '8':
					return 8;
				case '9':
					return 9;
				case '0':
					return 0;
				case '':
					return 0;
				default:
					return -1;
			}
		};
		var _n0 = _Utils_Tuple2(
			A2(elm$core$String$split, '.', decimalAsString),
			A2(elm$core$Basics$compare, n, 0));
		_n0$6:
		while (true) {
			if (_n0.a.b) {
				if (!_n0.a.b.b) {
					switch (_n0.b) {
						case 2:
							var _n1 = _n0.a;
							var a = _n1.a;
							var _n2 = _n0.b;
							return toInt(
								A2(
									elm$core$String$right,
									1,
									A2(elm$core$String$dropRight, n, a)));
						case 1:
							var _n3 = _n0.a;
							var a = _n3.a;
							var _n4 = _n0.b;
							return toInt(
								A2(elm$core$String$right, 1, a));
						default:
							var _n5 = _n0.a;
							var a = _n5.a;
							var _n6 = _n0.b;
							return 0;
					}
				} else {
					if (!_n0.a.b.b.b) {
						switch (_n0.b) {
							case 2:
								var _n7 = _n0.a;
								var a = _n7.a;
								var _n8 = _n7.b;
								var b = _n8.a;
								var _n9 = _n0.b;
								return toInt(
									A2(
										elm$core$String$right,
										1,
										A2(elm$core$String$dropRight, n, a)));
							case 1:
								var _n10 = _n0.a;
								var a = _n10.a;
								var _n11 = _n10.b;
								var b = _n11.a;
								var _n12 = _n0.b;
								return toInt(
									A2(elm$core$String$right, 1, a));
							default:
								var _n13 = _n0.a;
								var a = _n13.a;
								var _n14 = _n13.b;
								var b = _n14.a;
								var _n15 = _n0.b;
								return toInt(
									A2(
										elm$core$String$left,
										1,
										A2(elm$core$String$dropLeft, (-n) - 1, b)));
						}
					} else {
						break _n0$6;
					}
				}
			} else {
				break _n0$6;
			}
		}
		return -13;
	});
var author$project$Decimal$compare = F2(
	function (a, b) {
		var _n0 = author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var fa = _n0.a;
		var fb = _n0.b;
		var _n1 = fb;
		var mb = _n1.a;
		var eb = _n1.b;
		var _n2 = fa;
		var ma = _n2.a;
		var ea = _n2.b;
		return A2(cmditch$elm_bigint$BigInt$compare, ma, mb);
	});
var author$project$Decimal$signAsInt = function (d) {
	var _n0 = A2(author$project$Decimal$compare, d, author$project$Decimal$zero);
	switch (_n0) {
		case 0:
			return -1;
		case 1:
			return 0;
		default:
			return 1;
	}
};
var author$project$Decimal$truncate = F2(
	function (n, d) {
		var decimalAsString = author$project$Decimal$toString(d);
		var toDecimal = function (s) {
			var _n7 = author$project$Decimal$fromString(s);
			if (!_n7.$) {
				var a = _n7.a;
				return a;
			} else {
				return author$project$Decimal$zero;
			}
		};
		var _n0 = _Utils_Tuple2(
			A2(elm$core$String$split, '.', decimalAsString),
			n >= 0);
		_n0$4:
		while (true) {
			if (_n0.a.b) {
				if (!_n0.a.b.b) {
					if (_n0.b) {
						var _n1 = _n0.a;
						var a = _n1.a;
						return toDecimal(
							_Utils_ap(
								A2(elm$core$String$dropRight, n, a),
								A2(elm$core$String$repeat, n, '0')));
					} else {
						var _n2 = _n0.a;
						var a = _n2.a;
						return toDecimal(a);
					}
				} else {
					if (!_n0.a.b.b.b) {
						if (_n0.b) {
							var _n3 = _n0.a;
							var a = _n3.a;
							var _n4 = _n3.b;
							var b = _n4.a;
							return toDecimal(
								_Utils_ap(
									A2(elm$core$String$dropRight, n, a),
									A2(elm$core$String$repeat, n, '0')));
						} else {
							var _n5 = _n0.a;
							var a = _n5.a;
							var _n6 = _n5.b;
							var b = _n6.a;
							return toDecimal(
								a + ('.' + A2(elm$core$String$left, -n, b)));
						}
					} else {
						break _n0$4;
					}
				}
			} else {
				break _n0$4;
			}
		}
		return author$project$Decimal$zero;
	});
var author$project$Decimal$round = F2(
	function (n, d) {
		var to_increment = A2(
			author$project$Decimal$fromIntWithExponent,
			author$project$Decimal$signAsInt(d),
			n);
		var t = A2(author$project$Decimal$truncate, n, d);
		var next_digit = A2(author$project$Decimal$getDigit, n - 1, d);
		return (next_digit >= 5) ? A2(author$project$Decimal$add, t, to_increment) : t;
	});
var author$project$Utils$NumberFormatter$interestRateAsPercentage = function (interestRate) {
	return A2(
		author$project$Decimal$round,
		-2,
		A2(
			author$project$Decimal$mul,
			interestRate,
			author$project$Decimal$fromInt(100)));
};
var author$project$Utils$NumberFormatter$formatPercentage = function (decimalValue) {
	return A3(
		author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue),
		2,
		false) + '%';
};
var elm$core$List$sortBy = _List_sortBy;
var author$project$LandingSite$Home$view = F3(
	function (userLanguage, maybeLatestTokens, model) {
		var latestTokens = function () {
			if (!maybeLatestTokens.$) {
				var tokens = maybeLatestTokens.a;
				return tokens.c1;
			} else {
				return _List_Nil;
			}
		}();
		var aprFormatter = function (rate) {
			return elm$html$Html$text(
				author$project$Utils$NumberFormatter$formatPercentage(rate));
		};
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('landing-overview'),
							author$project$Utils$CompoundHtmlAttributes$class('bg-dark')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('mars-city')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-right-1')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-right-2')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-left-1')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('marsbase-left-2')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('monorail-track')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('car')
										]),
									_List_Nil)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('sand')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$id('monorail')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-small')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row align-center')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('text-center crypto-container')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$compound_your_crypto(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('text-large')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$compound_description(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$class('button main')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$try_compound(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('supply'),
							author$project$Utils$CompoundHtmlAttributes$class('explanation')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-5')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('preview')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$earn_interest(userLanguage))
														])),
													A2(
													elm$html$Html$h3,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$supply_description(userLanguage))
														])),
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$id('supported_markets'),
															author$project$Utils$CompoundHtmlAttributes$class('supply')
														]),
													A2(
														elm$core$List$map,
														function (cToken) {
															return A2(
																elm$html$Html$div,
																_List_fromArray(
																	[
																		author$project$Utils$CompoundHtmlAttributes$class('col-20')
																	]),
																_List_fromArray(
																	[
																		A2(
																		elm$html$Html$div,
																		_List_fromArray(
																			[
																				author$project$Utils$CompoundHtmlAttributes$class('asset')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				elm$html$Html$div,
																				_List_fromArray(
																					[
																						author$project$Utils$CompoundHtmlAttributes$class('identity')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						elm$html$Html$div,
																						_List_fromArray(
																							[
																								author$project$Utils$CompoundHtmlAttributes$class('icon ' + cToken.eg)
																							]),
																						_List_Nil),
																						A2(
																						elm$html$Html$span,
																						_List_Nil,
																						_List_fromArray(
																							[
																								elm$html$Html$text(cToken.eg)
																							]))
																					])),
																				A2(
																				elm$html$Html$span,
																				_List_fromArray(
																					[
																						author$project$Utils$CompoundHtmlAttributes$class('rate')
																					]),
																				_List_fromArray(
																					[
																						aprFormatter(cToken.d_)
																					]))
																			]))
																	]));
														},
														A2(
															elm$core$List$sortBy,
															function ($) {
																return $.d$;
															},
															latestTokens)))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-7')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$stay_fully_liquid(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$stay_fully_liquid_description(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$avoid_credit_risk(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$avoid_credit_risk_description(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$earn_best_rate(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$earn_best_rate_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('borrow'),
							author$project$Utils$CompoundHtmlAttributes$class('explanation')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-5')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$div,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('preview')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_assets(userLanguage))
														])),
													A2(
													elm$html$Html$h3,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$borrow_description(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/the-compound-guide-to-supplying-borrowing-crypto-assets-94821f2950a0')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$learn_more(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-7')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$instant_liquidity(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$instant_liquidity_description(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$use_trade_short(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$use_trade_short_description(userLanguage))
														])),
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$repay_at_own_pace(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$repay_at_own_pace_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$section,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$id('develop'),
							author$project$Utils$CompoundHtmlAttributes$class('explanation')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-small text-center')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('preview')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											author$project$Strings$Translations$build_on_compound(userLanguage))
										])),
									A2(
									elm$html$Html$h3,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('summary')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											author$project$Strings$Translations$built_for_developers(userLanguage))
										]))
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-4')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$our_whitepaper(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$our_whitepaper_description(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(author$project$Utils$CompoundHtmlAttributes$href, 1, '/documents/Compound.Whitepaper.v04.pdf')),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$download_the_whitepaper(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-4')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$protocol(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$protocol_description(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Developers'),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$read_the_docs(userLanguage))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('col-sm-4')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															author$project$Utils$CompoundHtmlAttributes$class('feature')
														]),
													_List_fromArray(
														[
															A2(
															elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(
																	author$project$Strings$Translations$api_caps(userLanguage))
																])),
															elm$html$Html$text(
															author$project$Strings$Translations$api_description(userLanguage))
														])),
													A2(
													elm$html$Html$a,
													A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/Developers/api'),
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Strings$Translations$read_the_docs(userLanguage))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var author$project$Decimal$negate = function (_n0) {
	var m = _n0.a;
	var e = _n0.b;
	return A2(
		author$project$Decimal$Decimal,
		cmditch$elm_bigint$BigInt$negate(m),
		e);
};
var author$project$Decimal$sub = F2(
	function (a, b) {
		return A2(
			author$project$Decimal$add,
			a,
			author$project$Decimal$negate(b));
	});
var author$project$LandingSite$Markets$deltaSpan = F2(
	function (delta, formatter) {
		var rounded = A2(author$project$Decimal$round, -2, delta);
		var _n0 = A2(author$project$Decimal$compare, rounded, author$project$Decimal$zero);
		switch (_n0) {
			case 2:
				return A2(
					elm$html$Html$span,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('change up')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(
							'+' + formatter(rounded))
						]));
			case 0:
				return A2(
					elm$html$Html$span,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('change down')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(
							formatter(rounded))
						]));
			default:
				return A2(
					elm$html$Html$span,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('change neutral')
						]),
					_List_fromArray(
						[
							elm$html$Html$text('–')
						]));
		}
	});
var author$project$LandingSite$Markets$formatRate = function (dec) {
	var rounded = A2(author$project$Decimal$round, -2, dec);
	return author$project$Decimal$toString(rounded) + '%';
};
var elm$core$String$fromFloat = _String_fromNumber;
var author$project$Decimal$fromFloat = function (f) {
	return author$project$Decimal$fromString(
		elm$core$String$fromFloat(f));
};
var author$project$Decimal$toFloat = function (d) {
	var _n0 = elm$core$String$toFloat(
		author$project$Decimal$toString(d));
	if (!_n0.$) {
		var a = _n0.a;
		return a;
	} else {
		return 42.0;
	}
};
var author$project$Decimal$fastdiv = F2(
	function (a, b) {
		var fb = author$project$Decimal$toFloat(b);
		var fa = author$project$Decimal$toFloat(a);
		var res = fa / fb;
		return author$project$Decimal$fromFloat(res);
	});
var author$project$Decimal$one = author$project$Decimal$fromInt(1);
var author$project$LandingSite$Markets$percentGrowth = F2(
	function (latest, historic) {
		var _n0 = A2(author$project$Decimal$fastdiv, latest, historic);
		if (!_n0.$) {
			var d = _n0.a;
			return A2(
				author$project$Decimal$mul,
				author$project$Decimal$fromInt(100),
				A2(author$project$Decimal$sub, d, author$project$Decimal$one));
		} else {
			return author$project$Decimal$zero;
		}
	});
var author$project$LandingSite$Markets$assetRow = F2(
	function (dollarFormatter, _n0) {
		var latestToken = _n0.a;
		var maybeHistoricToken = _n0.b;
		var historicToken = function () {
			if (!maybeHistoricToken.$) {
				var t = maybeHistoricToken.a;
				return t;
			} else {
				return latestToken;
			}
		}();
		var supplyDeltaPercent = A2(author$project$LandingSite$Markets$percentGrowth, latestToken.ec, historicToken.ec);
		var supplyRateDelta = A2(
			author$project$Decimal$mul,
			author$project$Decimal$fromInt(100),
			A2(author$project$Decimal$sub, latestToken.d_, historicToken.d_));
		var borrowRateDelta = A2(
			author$project$Decimal$mul,
			author$project$Decimal$fromInt(100),
			A2(author$project$Decimal$sub, latestToken.c_, historicToken.c_));
		var borrowDeltaPercent = A2(author$project$LandingSite$Markets$percentGrowth, latestToken.d9, historicToken.d9);
		var aprFormatter = function (rate) {
			return elm$html$Html$text(
				author$project$LandingSite$Markets$formatRate(
					A2(
						author$project$Decimal$mul,
						author$project$Decimal$fromInt(100),
						rate)));
		};
		return A2(
			elm$html$Html$a,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('asset')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 identity')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('icon ' + latestToken.eg)
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('name')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(latestToken.ef)
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('symbol')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(latestToken.eg)
										]))
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(latestToken.ed)
								])),
							A2(author$project$LandingSite$Markets$deltaSpan, supplyDeltaPercent, author$project$LandingSite$Markets$formatRate)
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									aprFormatter(latestToken.d_)
								])),
							A2(author$project$LandingSite$Markets$deltaSpan, supplyRateDelta, author$project$Decimal$toString)
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(latestToken.d8)
								])),
							A2(author$project$LandingSite$Markets$deltaSpan, borrowDeltaPercent, author$project$LandingSite$Markets$formatRate)
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									aprFormatter(latestToken.c_)
								])),
							A2(author$project$LandingSite$Markets$deltaSpan, borrowRateDelta, author$project$Decimal$toString)
						]))
				]));
	});
var author$project$LandingSite$Markets$Borrow = 1;
var author$project$LandingSite$Markets$Supply = 0;
var elm$html$Html$label = _VirtualDom_node('label');
var author$project$LandingSite$Markets$topMarketsBars = F3(
	function (cardType, topTokens, total) {
		var _n0 = function () {
			if (cardType === 1) {
				return _Utils_Tuple2(
					function ($) {
						return $.d8;
					},
					'borrow');
			} else {
				return _Utils_Tuple2(
					function ($) {
						return $.ed;
					},
					'supply');
			}
		}();
		var totalValue = _n0.a;
		var classType = _n0.b;
		var percentOfTotal = function (token) {
			return author$project$LandingSite$Markets$formatRate(
				A2(
					author$project$Decimal$mul,
					author$project$Decimal$fromInt(100),
					function () {
						var _n2 = A2(
							author$project$Decimal$fastdiv,
							totalValue(token),
							total);
						if (!_n2.$) {
							var percent = _n2.a;
							return percent;
						} else {
							return author$project$Decimal$zero;
						}
					}()));
		};
		var tokenBar = function (token) {
			return A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						author$project$Utils$CompoundHtmlAttributes$class('market-bar ' + classType)
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text(token.eg)
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right ')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(
										percentOfTotal(token))
									]))
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('bar ' + classType)
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('fill ' + classType),
										A2(
										author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										percentOfTotal(token))
									]),
								_List_Nil)
							]))
					]));
		};
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('top 3 markets')
							]))
					]),
				A2(elm$core$List$map, tokenBar, topTokens)));
	});
var elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(x);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$core$List$sum = function (numbers) {
	return A3(elm$core$List$foldl, elm$core$Basics$add, 0, numbers);
};
var author$project$LandingSite$Markets$totalCard = F4(
	function (cardType, latestTokens, historicTokens, dollarFormatter) {
		var reduceTotals = F2(
			function (tokens, valueFun) {
				return A3(
					elm$core$List$foldl,
					author$project$Decimal$add,
					author$project$Decimal$zero,
					A2(elm$core$List$map, valueFun, tokens));
			});
		var currentValue = function (oldToken) {
			var todaysData = function () {
				var _n5 = elm$core$List$head(
					A2(
						elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.dA, oldToken.dA);
						},
						latestTokens));
				if (!_n5.$) {
					var token = _n5.a;
					return token;
				} else {
					return oldToken;
				}
			}();
			if (!cardType) {
				return A2(
					author$project$Decimal$round,
					-2,
					A2(
						author$project$Decimal$mul,
						todaysData.cL,
						A2(author$project$Decimal$mul, todaysData.df, oldToken.ec)));
			} else {
				return A2(
					author$project$Decimal$round,
					-2,
					A2(author$project$Decimal$mul, todaysData.cL, oldToken.d9));
			}
		};
		var historicTotal = A2(reduceTotals, historicTokens, currentValue);
		var _n0 = function () {
			if (!cardType) {
				return _Utils_Tuple3('Total Supply', '# suppliers', '24H Supply Volume');
			} else {
				return _Utils_Tuple3('Total Borrow', '# borrowers', '24H Borrow Volume');
			}
		}();
		var header = _n0.a;
		var userCountText = _n0.b;
		var volumeText = _n0.c;
		var _n2 = function () {
			if (!cardType) {
				return _Utils_Tuple3(
					function ($) {
						return $.ed;
					},
					function ($) {
						return $.dD;
					},
					function ($) {
						return $.ec;
					});
			} else {
				return _Utils_Tuple3(
					function ($) {
						return $.d8;
					},
					function ($) {
						return $.dC;
					},
					function ($) {
						return $.d9;
					});
			}
		}();
		var valueKey = _n2.a;
		var userKey = _n2.b;
		var nativeAmountKey = _n2.c;
		var users = elm$core$List$sum(
			A2(elm$core$List$map, userKey, latestTokens));
		var tokenSorter = F2(
			function (a, b) {
				return A2(
					author$project$Decimal$compare,
					valueKey(b),
					valueKey(a));
			});
		var topAssets = A2(
			elm$core$List$take,
			3,
			A2(elm$core$List$sortWith, tokenSorter, latestTokens));
		var total = A2(reduceTotals, latestTokens, valueKey);
		var delta = A2(author$project$LandingSite$Markets$percentGrowth, total, historicTotal);
		var volume = A2(author$project$Decimal$sub, total, historicTotal);
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('panel')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('header')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text(header)
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('text-largest')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											dollarFormatter(total)
										])),
									A2(author$project$LandingSite$Markets$deltaSpan, delta, author$project$LandingSite$Markets$formatRate)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('bars-row')
								]),
							_List_fromArray(
								[
									A3(author$project$LandingSite$Markets$topMarketsBars, cardType, topAssets, total)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									author$project$Utils$CompoundHtmlAttributes$class('demi row')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(volumeText)
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('text-large')
												]),
											_List_fromArray(
												[
													dollarFormatter(volume)
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(userCountText)
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													author$project$Utils$CompoundHtmlAttributes$class('text-large')
												]),
											_List_fromArray(
												[
													elm$html$Html$text(
													elm$core$String$fromInt(users))
												]))
										]))
								]))
						]))
				]));
	});
var author$project$LandingSite$Markets$marketTotals = F3(
	function (latestTokens, historicTokens, dollarFormatter) {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A4(author$project$LandingSite$Markets$totalCard, 0, latestTokens, historicTokens, dollarFormatter)
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A4(author$project$LandingSite$Markets$totalCard, 1, latestTokens, historicTokens, dollarFormatter)
						]))
				]));
	});
var author$project$LandingSite$Markets$usdPerEth = function (tokens) {
	var ethPerUsd = function () {
		var _n0 = elm$core$List$head(
			A2(
				elm$core$List$filter,
				function (token) {
					return token.eg === 'USDC';
				},
				tokens));
		if (!_n0.$) {
			var usdc = _n0.a;
			return usdc.cL;
		} else {
			return author$project$Decimal$zero;
		}
	}();
	return A2(author$project$Decimal$fastdiv, author$project$Decimal$one, ethPerUsd);
};
var author$project$Decimal$abs = function (_n0) {
	var m = _n0.a;
	var e = _n0.b;
	var _n1 = A2(
		cmditch$elm_bigint$BigInt$compare,
		m,
		cmditch$elm_bigint$BigInt$fromInt(0));
	if (!_n1) {
		return A2(
			author$project$Decimal$Decimal,
			cmditch$elm_bigint$BigInt$negate(m),
			e);
	} else {
		return A2(author$project$Decimal$Decimal, m, e);
	}
};
var author$project$Decimal$lt = F2(
	function (a, b) {
		var _n0 = A2(author$project$Decimal$compare, a, b);
		if (!_n0) {
			return true;
		} else {
			return false;
		}
	});
var author$project$Utils$NumberFormatter$getSignAndAbsValue = function (decimalValue) {
	var signString = A2(author$project$Decimal$lt, decimalValue, author$project$Decimal$zero) ? '- ' : '';
	return _Utils_Tuple2(
		signString,
		author$project$Decimal$abs(decimalValue));
};
var author$project$Utils$NumberFormatter$tokenDecimalPlaces = 4;
var author$project$Utils$NumberFormatter$formatEth = function (decimalValue) {
	var _n0 = author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _n0.a;
	var absoluteDecimalValue = _n0.b;
	return signString + ('Ξ' + A3(author$project$Utils$NumberFormatter$formatToDecimalPlaces, absoluteDecimalValue, author$project$Utils$NumberFormatter$tokenDecimalPlaces, false));
};
var author$project$Utils$NumberFormatter$formatUsd = function (decimalValue) {
	var roundedValue = A2(author$project$Decimal$round, -2, decimalValue);
	var _n0 = author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
	var signString = _n0.a;
	var absoluteRoundedValue = _n0.b;
	return signString + ('$' + A3(author$project$Utils$NumberFormatter$formatToDecimalPlaces, absoluteRoundedValue, 2, false));
};
var author$project$Preferences$formatDisplayCurrency = F3(
	function (displayCurrency, maybeEtherPrice, value) {
		if (!displayCurrency) {
			return elm$core$Maybe$Just(
				author$project$Utils$NumberFormatter$formatEth(value));
		} else {
			if (!maybeEtherPrice.$) {
				var etherPrice = maybeEtherPrice.a;
				return elm$core$Maybe$Just(
					author$project$Utils$NumberFormatter$formatUsd(
						A2(author$project$Decimal$mul, etherPrice, value)));
			} else {
				return elm$core$Maybe$Nothing;
			}
		}
	});
var author$project$Utils$NumberFormatter$formatEthToZeroDecimals = function (decimalValue) {
	var _n0 = author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _n0.a;
	var absoluteDecimalValue = _n0.b;
	return signString + ('Ξ' + A3(author$project$Utils$NumberFormatter$formatToDecimalPlaces, absoluteDecimalValue, 0, false));
};
var author$project$Decimal$gt = F2(
	function (a, b) {
		var _n0 = A2(author$project$Decimal$compare, a, b);
		if (_n0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions = function (decimalValue) {
	var thousandsValue = A2(
		elm$core$Maybe$withDefault,
		author$project$Decimal$zero,
		A2(
			author$project$Decimal$fastdiv,
			decimalValue,
			author$project$Decimal$fromInt(1000)));
	var millionsValue = A2(
		elm$core$Maybe$withDefault,
		author$project$Decimal$zero,
		A2(
			author$project$Decimal$fastdiv,
			decimalValue,
			author$project$Decimal$fromInt(1000000)));
	var _n0 = A2(author$project$Decimal$gt, millionsValue, author$project$Decimal$one) ? _Utils_Tuple3(millionsValue, 2, 'M') : _Utils_Tuple3(thousandsValue, 0, 'k');
	var scaledValueToUse = _n0.a;
	var roundedDecimals = _n0.b;
	var valueSuffix = _n0.c;
	var _n1 = author$project$Utils$NumberFormatter$getSignAndAbsValue(scaledValueToUse);
	var signString = _n1.a;
	var absoluteRoundedValue = _n1.b;
	return signString + ('$' + (A3(author$project$Utils$NumberFormatter$formatToDecimalPlaces, absoluteRoundedValue, roundedDecimals, false) + valueSuffix));
};
var author$project$Preferences$formatMarketSize = F3(
	function (displayCurrency, maybeEtherPrice, value) {
		if (!displayCurrency) {
			return elm$core$Maybe$Just(
				author$project$Utils$NumberFormatter$formatEthToZeroDecimals(value));
		} else {
			if (!maybeEtherPrice.$) {
				var etherPrice = maybeEtherPrice.a;
				return elm$core$Maybe$Just(
					author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions(
						A2(author$project$Decimal$mul, etherPrice, value)));
			} else {
				return elm$core$Maybe$Nothing;
			}
		}
	});
var author$project$Preferences$getPlaceholderPrefCurrency = function (displayCurrency) {
	if (!displayCurrency) {
		return 'Ξ –';
	} else {
		return '$ –';
	}
};
var author$project$LandingSite$Markets$view = function (model) {
	var _n0 = function () {
		var _n1 = _Utils_Tuple2(model.aJ, model.aI);
		if ((!_n1.a.$) && (!_n1.b.$)) {
			var tokens = _n1.a.a;
			var oldTokens = _n1.b.a;
			return _Utils_Tuple2(tokens.c1, oldTokens.c1);
		} else {
			return _Utils_Tuple2(_List_Nil, _List_Nil);
		}
	}();
	var latestTokens = _n0.a;
	var historicTokens = _n0.b;
	var historyDict = elm$core$Dict$fromList(
		A2(
			elm$core$List$map,
			function (token) {
				return _Utils_Tuple2(token.d$, token);
			},
			historicTokens));
	var matchWithHistoric = function (cToken) {
		return _Utils_Tuple2(
			cToken,
			A2(elm$core$Dict$get, cToken.d$, historyDict));
	};
	var etherPrice = author$project$LandingSite$Markets$usdPerEth(latestTokens);
	var templateDollarFormatter = F2(
		function (formatter, value) {
			var _n2 = A3(formatter, 1, etherPrice, value);
			if (!_n2.$) {
				var string = _n2.a;
				return elm$html$Html$text(string);
			} else {
				return elm$html$Html$text(
					author$project$Preferences$getPlaceholderPrefCurrency(1));
			}
		});
	var assetRowDollarFormatter = function (tokenValue) {
		return A2(templateDollarFormatter, author$project$Preferences$formatMarketSize, tokenValue);
	};
	var marketTotalDollarFormatter = function (tokenValue) {
		return A2(templateDollarFormatter, author$project$Preferences$formatDisplayCurrency, tokenValue);
	};
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				author$project$Utils$CompoundHtmlAttributes$id('Markets')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$section,
				_List_fromArray(
					[
						author$project$Utils$CompoundHtmlAttributes$class('hero')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text('Market Overview')
									]))
							]))
					])),
				A2(
				elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								author$project$Utils$CompoundHtmlAttributes$class('container')
							]),
						_List_fromArray(
							[
								A3(author$project$LandingSite$Markets$marketTotals, latestTokens, historicTokens, marketTotalDollarFormatter),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										author$project$Utils$CompoundHtmlAttributes$class('panel')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												author$project$Utils$CompoundHtmlAttributes$class('header')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														elm$html$Html$text('All Markets')
													]))
											])),
										A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												author$project$Utils$CompoundHtmlAttributes$class('labels')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Market')
															]))
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Gross Supply')
															]))
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Supply APR')
															]))
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Gross Borrow')
															]))
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('Borrow APR')
															]))
													]))
											])),
										A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												author$project$Utils$CompoundHtmlAttributes$class('assets')
											]),
										A2(
											elm$core$List$map,
											author$project$LandingSite$Markets$assetRow(assetRowDollarFormatter),
											A2(
												elm$core$List$map,
												matchWithHistoric,
												A2(
													elm$core$List$sortWith,
													F2(
														function (a, b) {
															return A2(
																author$project$Decimal$compare,
																function ($) {
																	return $.ed;
																}(b),
																function ($) {
																	return $.ed;
																}(a));
														}),
													latestTokens))))
									]))
							]))
					]))
			]));
};
var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
var author$project$Main$viewPage = function (model) {
	var page = model.H;
	var configs = model.aC;
	var preferences = model._;
	var userLanguage = model.aQ;
	var pageMainContent = function () {
		switch (page.$) {
			case 0:
				return A2(
					elm$html$Html$map,
					author$project$Main$landingHomeTranslator,
					A3(author$project$LandingSite$Home$view, userLanguage, model.X.aJ, model.an));
			case 1:
				return A2(
					elm$html$Html$map,
					author$project$Main$landingAboutTranslator,
					A2(author$project$LandingSite$About$view, userLanguage, model.U));
			case 2:
				var fragment = page.a;
				return A2(
					elm$html$Html$map,
					author$project$Main$landingDevelopersPresidioTranslator,
					A3(author$project$LandingSite$Developers$view, userLanguage, configs, model.W));
			case 3:
				var fragment = page.a;
				return A2(
					elm$html$Html$map,
					author$project$Main$landingDevelopersApiTranslator,
					A2(author$project$LandingSite$DevelopersAPI$view, userLanguage, model.V));
			case 4:
				return author$project$LandingSite$DevelopersLegacy$view;
			case 5:
				return elm$html$Html$text('');
			case 6:
				return A2(
					elm$html$Html$map,
					author$project$Main$landingMarketsTranslator,
					author$project$LandingSite$Markets$view(model.X));
			default:
				var token = page.a;
				return A2(
					elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text('Placeholder for tokens page' + token),
							A2(
							elm$html$Html$a,
							A2(author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
							_List_fromArray(
								[
									elm$html$Html$text('Home ')
								]))
						]));
		}
	}();
	var maybeConfig = author$project$Main$getMainNetConfig(model);
	return pageMainContent;
};
var author$project$Main$view = function (model) {
	var userLanguage = model.aQ;
	var _n0 = model.al;
	if (!_n0.$) {
		var _n1 = _n0.a;
		var targetNetwork = _n1.a;
		var contractName = _n1.b;
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					A3(author$project$LandingSite$AbiViewer$view, targetNetwork, contractName, model.aW)
				]));
	} else {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					author$project$LandingSite$CommonViews$pageHeader(userLanguage),
					author$project$Main$viewPage(model),
					author$project$LandingSite$CommonViews$pageFooter(userLanguage)
				]));
	}
};
var elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$Dom$NotFound = elm$core$Basics$identity;
var elm$core$Basics$never = function (_n0) {
	never:
	while (true) {
		var nvr = _n0;
		var $temp$_n0 = nvr;
		_n0 = $temp$_n0;
		continue never;
	}
};
var elm$browser$Browser$element = _Browser_element;
var author$project$Main$main = elm$browser$Browser$element(
	{dq: author$project$Main$init, dZ: author$project$Main$subscriptions, eh: author$project$Main$update, ek: author$project$Main$view});
_Platform_export({'Main':{'init':author$project$Main$main(
	A2(
		elm$json$Json$Decode$andThen,
		function (protoDocJson) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (path) {
					return A2(
						elm$json$Json$Decode$andThen,
						function (configurations) {
							return A2(
								elm$json$Json$Decode$andThen,
								function (configAbiFiles) {
									return A2(
										elm$json$Json$Decode$andThen,
										function (apiBaseUrlMap) {
											return A2(
												elm$json$Json$Decode$andThen,
												function (apiBaseUrl) {
													return elm$json$Json$Decode$succeed(
														{M: apiBaseUrl, aT: apiBaseUrlMap, aV: configAbiFiles, aX: configurations, bj: path, aa: protoDocJson});
												},
												A2(elm$json$Json$Decode$field, 'apiBaseUrl', elm$json$Json$Decode$value));
										},
										A2(elm$json$Json$Decode$field, 'apiBaseUrlMap', elm$json$Json$Decode$value));
								},
								A2(elm$json$Json$Decode$field, 'configAbiFiles', elm$json$Json$Decode$value));
						},
						A2(elm$json$Json$Decode$field, 'configurations', elm$json$Json$Decode$value));
				},
				A2(elm$json$Json$Decode$field, 'path', elm$json$Json$Decode$string));
		},
		A2(elm$json$Json$Decode$field, 'protoDocJson', elm$json$Json$Decode$value)))(0)}});}(this));